// Generated from LogoEditor.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');
var LogoEditorListener = require('./LogoEditorListener').LogoEditorListener;
var LogoEditorVisitor = require('./LogoEditorVisitor').LogoEditorVisitor;

var grammarFileName = "LogoEditor.g4";

var serializedATN = ["\u0003\u0430\ud6d1\u8206\uad2d\u4417\uaef1\u8d80\uaadd",
    "\u0003q\u0721\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
    "\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004",
    "\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004",
    "\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004",
    "\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t",
    "\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004",
    "\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a\u0004\u001b\t",
    "\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e\t\u001e\u0004",
    "\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#\t#\u0004$\t$\u0004",
    "%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004*\t*\u0004+\t+\u0004",
    ",\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u00041\t1\u00042\t2\u0004",
    "3\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u00048\t8\u00049\t9\u0004",
    ":\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004?\t?\u0004@\t@\u0004",
    "A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004F\tF\u0004G\tG\u0003",
    "\u0002\u0003\u0002\u0003\u0002\u0007\u0002\u0092\n\u0002\f\u0002\u000e",
    "\u0002\u0095\u000b\u0002\u0003\u0003\u0006\u0003\u0098\n\u0003\r\u0003",
    "\u000e\u0003\u0099\u0003\u0003\u0005\u0003\u009d\n\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0005\u0003\u00a2\n\u0003\u0005\u0003\u00a4",
    "\n\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0005\u0004\u00c4\n\u0004\u0003\u0005\u0003\u0005\u0003",
    "\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0006\u0005\u00cd",
    "\n\u0005\r\u0005\u000e\u0005\u00ce\u0005\u0005\u00d1\n\u0005\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0007\u0006\u00d6\n\u0006\f\u0006\u000e\u0006",
    "\u00d9\u000b\u0006\u0003\u0006\u0003\u0006\u0005\u0006\u00dd\n\u0006",
    "\u0003\u0006\u0007\u0006\u00e0\n\u0006\f\u0006\u000e\u0006\u00e3\u000b",
    "\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u00e7\n\u0006\f\u0006\u000e",
    "\u0006\u00ea\u000b\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u00ee\n",
    "\u0006\f\u0006\u000e\u0006\u00f1\u000b\u0006\u0003\u0006\u0003\u0006",
    "\u0007\u0006\u00f5\n\u0006\f\u0006\u000e\u0006\u00f8\u000b\u0006\u0006",
    "\u0006\u00fa\n\u0006\r\u0006\u000e\u0006\u00fb\u0003\u0006\u0003\u0006",
    "\u0007\u0006\u0100\n\u0006\f\u0006\u000e\u0006\u0103\u000b\u0006\u0003",
    "\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u0109\n\u0006",
    "\f\u0006\u000e\u0006\u010c\u000b\u0006\u0005\u0006\u010e\n\u0006\u0003",
    "\u0006\u0007\u0006\u0111\n\u0006\f\u0006\u000e\u0006\u0114\u000b\u0006",
    "\u0003\u0006\u0005\u0006\u0117\n\u0006\u0003\u0006\u0007\u0006\u011a",
    "\n\u0006\f\u0006\u000e\u0006\u011d\u000b\u0006\u0003\u0006\u0005\u0006",
    "\u0120\n\u0006\u0003\u0006\u0007\u0006\u0123\n\u0006\f\u0006\u000e\u0006",
    "\u0126\u000b\u0006\u0003\u0006\u0007\u0006\u0129\n\u0006\f\u0006\u000e",
    "\u0006\u012c\u000b\u0006\u0003\u0006\u0007\u0006\u012f\n\u0006\f\u0006",
    "\u000e\u0006\u0132\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007",
    "\u0006\u0137\n\u0006\f\u0006\u000e\u0006\u013a\u000b\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u0140\n\u0006\f\u0006",
    "\u000e\u0006\u0143\u000b\u0006\u0005\u0006\u0145\n\u0006\u0003\u0006",
    "\u0007\u0006\u0148\n\u0006\f\u0006\u000e\u0006\u014b\u000b\u0006\u0003",
    "\u0006\u0005\u0006\u014e\n\u0006\u0003\u0006\u0007\u0006\u0151\n\u0006",
    "\f\u0006\u000e\u0006\u0154\u000b\u0006\u0003\u0006\u0005\u0006\u0157",
    "\n\u0006\u0003\u0006\u0007\u0006\u015a\n\u0006\f\u0006\u000e\u0006\u015d",
    "\u000b\u0006\u0003\u0006\u0007\u0006\u0160\n\u0006\f\u0006\u000e\u0006",
    "\u0163\u000b\u0006\u0003\u0006\u0007\u0006\u0166\n\u0006\f\u0006\u000e",
    "\u0006\u0169\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006",
    "\u016e\n\u0006\f\u0006\u000e\u0006\u0171\u000b\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u0177\n\u0006\f\u0006\u000e",
    "\u0006\u017a\u000b\u0006\u0005\u0006\u017c\n\u0006\u0003\u0006\u0007",
    "\u0006\u017f\n\u0006\f\u0006\u000e\u0006\u0182\u000b\u0006\u0003\u0006",
    "\u0005\u0006\u0185\n\u0006\u0003\u0006\u0007\u0006\u0188\n\u0006\f\u0006",
    "\u000e\u0006\u018b\u000b\u0006\u0003\u0006\u0005\u0006\u018e\n\u0006",
    "\u0003\u0006\u0007\u0006\u0191\n\u0006\f\u0006\u000e\u0006\u0194\u000b",
    "\u0006\u0003\u0006\u0007\u0006\u0197\n\u0006\f\u0006\u000e\u0006\u019a",
    "\u000b\u0006\u0003\u0006\u0007\u0006\u019d\n\u0006\f\u0006\u000e\u0006",
    "\u01a0\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u01a5",
    "\n\u0006\f\u0006\u000e\u0006\u01a8\u000b\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0007\u0006\u01ae\n\u0006\f\u0006\u000e\u0006",
    "\u01b1\u000b\u0006\u0005\u0006\u01b3\n\u0006\u0003\u0006\u0007\u0006",
    "\u01b6\n\u0006\f\u0006\u000e\u0006\u01b9\u000b\u0006\u0003\u0006\u0005",
    "\u0006\u01bc\n\u0006\u0003\u0006\u0007\u0006\u01bf\n\u0006\f\u0006\u000e",
    "\u0006\u01c2\u000b\u0006\u0003\u0006\u0005\u0006\u01c5\n\u0006\u0003",
    "\u0006\u0007\u0006\u01c8\n\u0006\f\u0006\u000e\u0006\u01cb\u000b\u0006",
    "\u0003\u0006\u0007\u0006\u01ce\n\u0006\f\u0006\u000e\u0006\u01d1\u000b",
    "\u0006\u0003\u0006\u0007\u0006\u01d4\n\u0006\f\u0006\u000e\u0006\u01d7",
    "\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u01dc\n",
    "\u0006\f\u0006\u000e\u0006\u01df\u000b\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0007\u0006\u01e5\n\u0006\f\u0006\u000e\u0006",
    "\u01e8\u000b\u0006\u0005\u0006\u01ea\n\u0006\u0003\u0006\u0007\u0006",
    "\u01ed\n\u0006\f\u0006\u000e\u0006\u01f0\u000b\u0006\u0003\u0006\u0005",
    "\u0006\u01f3\n\u0006\u0003\u0006\u0007\u0006\u01f6\n\u0006\f\u0006\u000e",
    "\u0006\u01f9\u000b\u0006\u0003\u0006\u0005\u0006\u01fc\n\u0006\u0003",
    "\u0006\u0007\u0006\u01ff\n\u0006\f\u0006\u000e\u0006\u0202\u000b\u0006",
    "\u0003\u0006\u0007\u0006\u0205\n\u0006\f\u0006\u000e\u0006\u0208\u000b",
    "\u0006\u0003\u0006\u0007\u0006\u020b\n\u0006\f\u0006\u000e\u0006\u020e",
    "\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0006\u0006\u0213\n",
    "\u0006\r\u0006\u000e\u0006\u0214\u0003\u0006\u0007\u0006\u0218\n\u0006",
    "\f\u0006\u000e\u0006\u021b\u000b\u0006\u0003\u0006\u0003\u0006\u0007",
    "\u0006\u021f\n\u0006\f\u0006\u000e\u0006\u0222\u000b\u0006\u0003\u0006",
    "\u0007\u0006\u0225\n\u0006\f\u0006\u000e\u0006\u0228\u000b\u0006\u0003",
    "\u0006\u0005\u0006\u022b\n\u0006\u0003\u0006\u0007\u0006\u022e\n\u0006",
    "\f\u0006\u000e\u0006\u0231\u000b\u0006\u0003\u0006\u0005\u0006\u0234",
    "\n\u0006\u0003\u0006\u0007\u0006\u0237\n\u0006\f\u0006\u000e\u0006\u023a",
    "\u000b\u0006\u0003\u0006\u0007\u0006\u023d\n\u0006\f\u0006\u000e\u0006",
    "\u0240\u000b\u0006\u0003\u0006\u0007\u0006\u0243\n\u0006\f\u0006\u000e",
    "\u0006\u0246\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0006\u0006",
    "\u024b\n\u0006\r\u0006\u000e\u0006\u024c\u0003\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0007\u0006\u0253\n\u0006\f\u0006\u000e\u0006\u0256",
    "\u000b\u0006\u0003\u0006\u0007\u0006\u0259\n\u0006\f\u0006\u000e\u0006",
    "\u025c\u000b\u0006\u0003\u0006\u0005\u0006\u025f\n\u0006\u0003\u0006",
    "\u0007\u0006\u0262\n\u0006\f\u0006\u000e\u0006\u0265\u000b\u0006\u0003",
    "\u0006\u0005\u0006\u0268\n\u0006\u0003\u0006\u0007\u0006\u026b\n\u0006",
    "\f\u0006\u000e\u0006\u026e\u000b\u0006\u0003\u0006\u0007\u0006\u0271",
    "\n\u0006\f\u0006\u000e\u0006\u0274\u000b\u0006\u0003\u0006\u0007\u0006",
    "\u0277\n\u0006\f\u0006\u000e\u0006\u027a\u000b\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0006\u0006\u027f\n\u0006\r\u0006\u000e\u0006\u0280",
    "\u0003\u0006\u0006\u0006\u0284\n\u0006\r\u0006\u000e\u0006\u0285\u0003",
    "\u0006\u0006\u0006\u0289\n\u0006\r\u0006\u000e\u0006\u028a\u0003\u0006",
    "\u0003\u0006\u0007\u0006\u028f\n\u0006\f\u0006\u000e\u0006\u0292\u000b",
    "\u0006\u0003\u0006\u0007\u0006\u0295\n\u0006\f\u0006\u000e\u0006\u0298",
    "\u000b\u0006\u0003\u0006\u0005\u0006\u029b\n\u0006\u0003\u0006\u0007",
    "\u0006\u029e\n\u0006\f\u0006\u000e\u0006\u02a1\u000b\u0006\u0003\u0006",
    "\u0005\u0006\u02a4\n\u0006\u0003\u0006\u0007\u0006\u02a7\n\u0006\f\u0006",
    "\u000e\u0006\u02aa\u000b\u0006\u0003\u0006\u0007\u0006\u02ad\n\u0006",
    "\f\u0006\u000e\u0006\u02b0\u000b\u0006\u0003\u0006\u0007\u0006\u02b3",
    "\n\u0006\f\u0006\u000e\u0006\u02b6\u000b\u0006\u0003\u0006\u0003\u0006",
    "\u0006\u0006\u02ba\n\u0006\r\u0006\u000e\u0006\u02bb\u0003\u0006\u0003",
    "\u0006\u0007\u0006\u02c0\n\u0006\f\u0006\u000e\u0006\u02c3\u000b\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u02c9\n",
    "\u0006\f\u0006\u000e\u0006\u02cc\u000b\u0006\u0005\u0006\u02ce\n\u0006",
    "\u0003\u0006\u0007\u0006\u02d1\n\u0006\f\u0006\u000e\u0006\u02d4\u000b",
    "\u0006\u0003\u0006\u0005\u0006\u02d7\n\u0006\u0003\u0006\u0007\u0006",
    "\u02da\n\u0006\f\u0006\u000e\u0006\u02dd\u000b\u0006\u0003\u0006\u0005",
    "\u0006\u02e0\n\u0006\u0003\u0006\u0007\u0006\u02e3\n\u0006\f\u0006\u000e",
    "\u0006\u02e6\u000b\u0006\u0003\u0006\u0007\u0006\u02e9\n\u0006\f\u0006",
    "\u000e\u0006\u02ec\u000b\u0006\u0003\u0006\u0007\u0006\u02ef\n\u0006",
    "\f\u0006\u000e\u0006\u02f2\u000b\u0006\u0003\u0006\u0003\u0006\u0003",
    "\u0006\u0007\u0006\u02f7\n\u0006\f\u0006\u000e\u0006\u02fa\u000b\u0006",
    "\u0003\u0006\u0006\u0006\u02fd\n\u0006\r\u0006\u000e\u0006\u02fe\u0003",
    "\u0006\u0005\u0006\u0302\n\u0006\u0003\u0006\u0007\u0006\u0305\n\u0006",
    "\f\u0006\u000e\u0006\u0308\u000b\u0006\u0003\u0006\u0003\u0006\u0005",
    "\u0006\u030c\n\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u0310\n\u0006",
    "\f\u0006\u000e\u0006\u0313\u000b\u0006\u0003\u0006\u0003\u0006\u0003",
    "\u0006\u0007\u0006\u0318\n\u0006\f\u0006\u000e\u0006\u031b\u000b\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u0320\n\u0006\f\u0006",
    "\u000e\u0006\u0323\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007",
    "\u0006\u0328\n\u0006\f\u0006\u000e\u0006\u032b\u000b\u0006\u0003\u0006",
    "\u0007\u0006\u032e\n\u0006\f\u0006\u000e\u0006\u0331\u000b\u0006\u0003",
    "\u0006\u0005\u0006\u0334\n\u0006\u0003\u0006\u0007\u0006\u0337\n\u0006",
    "\f\u0006\u000e\u0006\u033a\u000b\u0006\u0003\u0006\u0005\u0006\u033d",
    "\n\u0006\u0003\u0006\u0007\u0006\u0340\n\u0006\f\u0006\u000e\u0006\u0343",
    "\u000b\u0006\u0003\u0006\u0007\u0006\u0346\n\u0006\f\u0006\u000e\u0006",
    "\u0349\u000b\u0006\u0003\u0006\u0007\u0006\u034c\n\u0006\f\u0006\u000e",
    "\u0006\u034f\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006",
    "\u0354\n\u0006\f\u0006\u000e\u0006\u0357\u000b\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0005\u0006\u035c\n\u0006\u0007\u0006\u035e\n\u0006",
    "\f\u0006\u000e\u0006\u0361\u000b\u0006\u0003\u0006\u0007\u0006\u0364",
    "\n\u0006\f\u0006\u000e\u0006\u0367\u000b\u0006\u0003\u0006\u0007\u0006",
    "\u036a\n\u0006\f\u0006\u000e\u0006\u036d\u000b\u0006\u0003\u0006\u0007",
    "\u0006\u0370\n\u0006\f\u0006\u000e\u0006\u0373\u000b\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0007\u0006\u0378\n\u0006\f\u0006\u000e\u0006",
    "\u037b\u000b\u0006\u0003\u0006\u0007\u0006\u037e\n\u0006\f\u0006\u000e",
    "\u0006\u0381\u000b\u0006\u0003\u0006\u0005\u0006\u0384\n\u0006\u0003",
    "\u0006\u0007\u0006\u0387\n\u0006\f\u0006\u000e\u0006\u038a\u000b\u0006",
    "\u0003\u0006\u0005\u0006\u038d\n\u0006\u0003\u0006\u0003\u0006\u0007",
    "\u0006\u0391\n\u0006\f\u0006\u000e\u0006\u0394\u000b\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0007\u0006\u0399\n\u0006\f\u0006\u000e\u0006",
    "\u039c\u000b\u0006\u0003\u0006\u0007\u0006\u039f\n\u0006\f\u0006\u000e",
    "\u0006\u03a2\u000b\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006",
    "\u03a7\n\u0006\f\u0006\u000e\u0006\u03aa\u000b\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u03b0\n\u0006\f\u0006\u000e",
    "\u0006\u03b3\u000b\u0006\u0005\u0006\u03b5\n\u0006\u0003\u0006\u0007",
    "\u0006\u03b8\n\u0006\f\u0006\u000e\u0006\u03bb\u000b\u0006\u0003\u0006",
    "\u0005\u0006\u03be\n\u0006\u0003\u0006\u0007\u0006\u03c1\n\u0006\f\u0006",
    "\u000e\u0006\u03c4\u000b\u0006\u0003\u0006\u0005\u0006\u03c7\n\u0006",
    "\u0003\u0006\u0007\u0006\u03ca\n\u0006\f\u0006\u000e\u0006\u03cd\u000b",
    "\u0006\u0003\u0006\u0007\u0006\u03d0\n\u0006\f\u0006\u000e\u0006\u03d3",
    "\u000b\u0006\u0003\u0006\u0007\u0006\u03d6\n\u0006\f\u0006\u000e\u0006",
    "\u03d9\u000b\u0006\u0003\u0006\u0003\u0006\u0007\u0006\u03dd\n\u0006",
    "\f\u0006\u000e\u0006\u03e0\u000b\u0006\u0003\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0007\u0006\u03e6\n\u0006\f\u0006\u000e\u0006\u03e9",
    "\u000b\u0006\u0005\u0006\u03eb\n\u0006\u0003\u0006\u0007\u0006\u03ee",
    "\n\u0006\f\u0006\u000e\u0006\u03f1\u000b\u0006\u0003\u0006\u0005\u0006",
    "\u03f4\n\u0006\u0003\u0006\u0007\u0006\u03f7\n\u0006\f\u0006\u000e\u0006",
    "\u03fa\u000b\u0006\u0003\u0006\u0005\u0006\u03fd\n\u0006\u0003\u0006",
    "\u0007\u0006\u0400\n\u0006\f\u0006\u000e\u0006\u0403\u000b\u0006\u0003",
    "\u0006\u0007\u0006\u0406\n\u0006\f\u0006\u000e\u0006\u0409\u000b\u0006",
    "\u0003\u0006\u0007\u0006\u040c\n\u0006\f\u0006\u000e\u0006\u040f\u000b",
    "\u0006\u0003\u0006\u0006\u0006\u0412\n\u0006\r\u0006\u000e\u0006\u0413",
    "\u0003\u0006\u0003\u0006\u0007\u0006\u0418\n\u0006\f\u0006\u000e\u0006",
    "\u041b\u000b\u0006\u0003\u0006\u0003\u0006\u0006\u0006\u041f\n\u0006",
    "\r\u0006\u000e\u0006\u0420\u0007\u0006\u0423\n\u0006\f\u0006\u000e\u0006",
    "\u0426\u000b\u0006\u0003\u0006\u0005\u0006\u0429\n\u0006\u0003\u0006",
    "\u0003\u0006\u0007\u0006\u042d\n\u0006\f\u0006\u000e\u0006\u0430\u000b",
    "\u0006\u0003\u0006\u0003\u0006\u0006\u0006\u0434\n\u0006\r\u0006\u000e",
    "\u0006\u0435\u0003\u0006\u0005\u0006\u0439\n\u0006\u0007\u0006\u043b",
    "\n\u0006\f\u0006\u000e\u0006\u043e\u000b\u0006\u0003\u0006\u0003\u0006",
    "\u0007\u0006\u0442\n\u0006\f\u0006\u000e\u0006\u0445\u000b\u0006\u0005",
    "\u0006\u0447\n\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007",
    "\u0005\u0007\u044d\n\u0007\u0003\b\u0003\b\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0005",
    "\t\u045d\n\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n",
    "\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0005\n\u046c\n\n\u0003",
    "\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003",
    "\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003",
    "\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0006\u000b\u047f",
    "\n\u000b\r\u000b\u000e\u000b\u0480\u0003\u000b\u0003\u000b\u0003\u000b",
    "\u0005\u000b\u0486\n\u000b\u0003\u000b\u0005\u000b\u0489\n\u000b\u0003",
    "\f\u0003\f\u0007\f\u048d\n\f\f\f\u000e\f\u0490\u000b\f\u0003\f\u0003",
    "\f\u0007\f\u0494\n\f\f\f\u000e\f\u0497\u000b\f\u0003\f\u0007\f\u049a",
    "\n\f\f\f\u000e\f\u049d\u000b\f\u0003\f\u0003\f\u0003\r\u0003\r\u0003",
    "\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003",
    "\r\u0003\r\u0003\r\u0003\r\u0003\r\u0006\r\u04b1\n\r\r\r\u000e\r\u04b2",
    "\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0005",
    "\r\u04bd\n\r\u0003\r\u0005\r\u04c0\n\r\u0003\u000e\u0003\u000e\u0003",
    "\u000e\u0003\u000e\u0003\u000e\u0005\u000e\u04c7\n\u000e\u0005\u000e",
    "\u04c9\n\u000e\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003",
    "\u0010\u0007\u0010\u04d0\n\u0010\f\u0010\u000e\u0010\u04d3\u000b\u0010",
    "\u0003\u0011\u0003\u0011\u0003\u0011\u0007\u0011\u04d8\n\u0011\f\u0011",
    "\u000e\u0011\u04db\u000b\u0011\u0003\u0012\u0005\u0012\u04de\n\u0012",
    "\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013",
    "\u04eb\n\u0013\u0003\u0014\u0003\u0014\u0003\u0014\u0005\u0014\u04f0",
    "\n\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015",
    "\u0003\u0015\u0003\u0015\u0005\u0015\u04f9\n\u0015\u0003\u0016\u0003",
    "\u0016\u0005\u0016\u04fd\n\u0016\u0003\u0017\u0003\u0017\u0003\u0017",
    "\u0003\u0017\u0003\u0017\u0007\u0017\u0504\n\u0017\f\u0017\u000e\u0017",
    "\u0507\u000b\u0017\u0003\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003",
    "\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003",
    "\u0019\u0006\u0019\u0514\n\u0019\r\u0019\u000e\u0019\u0515\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019",
    "\u0005\u0019\u051f\n\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003",
    "\u0019\u0005\u0019\u0525\n\u0019\u0003\u0019\u0003\u0019\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0006\u0019\u0533\n\u0019\r\u0019",
    "\u000e\u0019\u0534\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0005",
    "\u0019\u053b\n\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0005\u001a",
    "\u0540\n\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0005\u001a\u0545",
    "\n\u001a\u0003\u001a\u0003\u001a\u0006\u001a\u0549\n\u001a\r\u001a\u000e",
    "\u001a\u054a\u0003\u001a\u0005\u001a\u054e\n\u001a\u0003\u001b\u0003",
    "\u001b\u0007\u001b\u0552\n\u001b\f\u001b\u000e\u001b\u0555\u000b\u001b",
    "\u0003\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d",
    "\u0003\u001d\u0003\u001d\u0003\u001d\u0006\u001d\u0560\n\u001d\r\u001d",
    "\u000e\u001d\u0561\u0003\u001d\u0005\u001d\u0565\n\u001d\u0003\u001e",
    "\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0006\u001e\u056c\n",
    "\u001e\r\u001e\u000e\u001e\u056d\u0003\u001e\u0005\u001e\u0571\n\u001e",
    "\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0006\u001f",
    "\u0578\n\u001f\r\u001f\u000e\u001f\u0579\u0003\u001f\u0005\u001f\u057d",
    "\n\u001f\u0003 \u0003 \u0003 \u0003 \u0003 \u0006 \u0584\n \r \u000e",
    " \u0585\u0003 \u0005 \u0589\n \u0003!\u0003!\u0003!\u0006!\u058e\n!",
    "\r!\u000e!\u058f\u0005!\u0592\n!\u0003\"\u0003\"\u0003\"\u0006\"\u0597",
    "\n\"\r\"\u000e\"\u0598\u0005\"\u059b\n\"\u0003#\u0003#\u0003#\u0006",
    "#\u05a0\n#\r#\u000e#\u05a1\u0005#\u05a4\n#\u0003$\u0003$\u0003$\u0006",
    "$\u05a9\n$\r$\u000e$\u05aa\u0005$\u05ad\n$\u0003%\u0003%\u0003%\u0006",
    "%\u05b2\n%\r%\u000e%\u05b3\u0005%\u05b6\n%\u0003&\u0003&\u0003&\u0006",
    "&\u05bb\n&\r&\u000e&\u05bc\u0005&\u05bf\n&\u0003\'\u0003\'\u0003\'\u0006",
    "\'\u05c4\n\'\r\'\u000e\'\u05c5\u0005\'\u05c8\n\'\u0003(\u0003(\u0003",
    "(\u0006(\u05cd\n(\r(\u000e(\u05ce\u0005(\u05d1\n(\u0003)\u0003)\u0003",
    ")\u0003)\u0005)\u05d7\n)\u0003)\u0003)\u0003)\u0003)\u0005)\u05dd\n",
    ")\u0003)\u0003)\u0003)\u0006)\u05e2\n)\r)\u000e)\u05e3\u0003)\u0005",
    ")\u05e7\n)\u0003*\u0003*\u0003*\u0003*\u0005*\u05ed\n*\u0003*\u0003",
    "*\u0003*\u0003*\u0005*\u05f3\n*\u0003*\u0003*\u0003*\u0006*\u05f8\n",
    "*\r*\u000e*\u05f9\u0003*\u0005*\u05fd\n*\u0003+\u0003+\u0003+\u0006",
    "+\u0602\n+\r+\u000e+\u0603\u0005+\u0606\n+\u0003,\u0003,\u0003,\u0006",
    ",\u060b\n,\r,\u000e,\u060c\u0005,\u060f\n,\u0003-\u0003-\u0003-\u0003",
    "-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0006-\u061b\n-\r-\u000e",
    "-\u061c\u0003-\u0005-\u0620\n-\u0003.\u0003.\u0003.\u0003.\u0003.\u0006",
    ".\u0627\n.\r.\u000e.\u0628\u0003.\u0005.\u062c\n.\u0003/\u0003/\u0003",
    "/\u0003/\u0003/\u0006/\u0633\n/\r/\u000e/\u0634\u0003/\u0005/\u0638",
    "\n/\u00030\u00030\u00030\u00030\u00030\u00060\u063f\n0\r0\u000e0\u0640",
    "\u00030\u00050\u0644\n0\u00031\u00031\u00031\u00031\u00031\u00061\u064b",
    "\n1\r1\u000e1\u064c\u00031\u00051\u0650\n1\u00032\u00032\u00032\u0003",
    "2\u00032\u00062\u0657\n2\r2\u000e2\u0658\u00032\u00052\u065c\n2\u0003",
    "3\u00033\u00033\u00033\u00033\u00063\u0663\n3\r3\u000e3\u0664\u0003",
    "3\u00053\u0668\n3\u00034\u00034\u00034\u00034\u00034\u00064\u066f\n",
    "4\r4\u000e4\u0670\u00034\u00054\u0674\n4\u00035\u00035\u00035\u0003",
    "5\u00035\u00065\u067b\n5\r5\u000e5\u067c\u00035\u00055\u0680\n5\u0003",
    "6\u00036\u00036\u00036\u00036\u00066\u0687\n6\r6\u000e6\u0688\u0003",
    "6\u00056\u068c\n6\u00037\u00037\u00037\u00037\u00037\u00067\u0693\n",
    "7\r7\u000e7\u0694\u00037\u00057\u0698\n7\u00038\u00038\u00038\u0003",
    "8\u00038\u00068\u069f\n8\r8\u000e8\u06a0\u00038\u00058\u06a4\n8\u0003",
    "9\u00039\u00039\u00039\u00039\u00039\u00039\u00039\u00069\u06ae\n9\r",
    "9\u000e9\u06af\u00039\u00039\u00039\u00059\u06b5\n9\u0003:\u0003:\u0003",
    ":\u0003:\u0003:\u0003:\u0003:\u0003:\u0006:\u06bf\n:\r:\u000e:\u06c0",
    "\u0003:\u0003:\u0003:\u0005:\u06c6\n:\u0003;\u0003;\u0003;\u0003;\u0003",
    ";\u0006;\u06cd\n;\r;\u000e;\u06ce\u0003;\u0005;\u06d2\n;\u0003<\u0003",
    "<\u0003<\u0003<\u0003<\u0006<\u06d9\n<\r<\u000e<\u06da\u0003<\u0005",
    "<\u06de\n<\u0003=\u0003=\u0003=\u0006=\u06e3\n=\r=\u000e=\u06e4\u0005",
    "=\u06e7\n=\u0003>\u0003>\u0003>\u0003>\u0003>\u0006>\u06ee\n>\r>\u000e",
    ">\u06ef\u0003>\u0005>\u06f3\n>\u0003?\u0003?\u0003?\u0003?\u0003?\u0006",
    "?\u06fa\n?\r?\u000e?\u06fb\u0003?\u0005?\u06ff\n?\u0003@\u0003@\u0003",
    "@\u0003@\u0003@\u0006@\u0706\n@\r@\u000e@\u0707\u0003@\u0005@\u070b",
    "\n@\u0003A\u0003A\u0003A\u0003A\u0003A\u0003A\u0005A\u0713\nA\u0003",
    "B\u0003B\u0003C\u0003C\u0003D\u0003D\u0003E\u0003E\u0003F\u0003F\u0003",
    "G\u0003G\u0003G\u0002\u0002H\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012",
    "\u0014\u0016\u0018\u001a\u001c\u001e \"$&(*,.02468:<>@BDFHJLNPRTVXZ",
    "\\^`bdfhjlnprtvxz|~\u0080\u0082\u0084\u0086\u0088\u008a\u008c\u0002",
    "\u001e\u0003\u0002\u0004 \u0003\u0002!.\u0003\u00020@\u0003\u0002CH",
    "\u0003\u0002IK\u0003\u0002LN\u0003\u0002IJ\u0004\u0002  QQ\u0003\u0002",
    "AB\u0004\u0002\u0005\u0005RR\u0004\u0002\u0006\u0006ST\u0004\u0002\u0007",
    "\u0007UU\u0004\u0002\b\bVV\u0004\u0002\t\tWW\u0004\u0002\u000b\u000b",
    "XX\u0004\u0002\f\fYY\u0004\u0002\u000f\u000fZZ\u0004\u0002\u0010\u0010",
    "[[\u0004\u0002\r\r\\\\\u0004\u0002\u000e\u000e]]\u0004\u0002\u0015\u0015",
    "^^\u0004\u0002\u0016\u0016__\u0004\u0002!!`a\u0004\u0002%%bb\u0004\u0002",
    "&&cc\u0004\u0002\'\'dd\u0004\u0002,,ee\u0004\u0002\u001d\u001dff\u0889",
    "\u0002\u0093\u0003\u0002\u0002\u0002\u0004\u00a3\u0003\u0002\u0002\u0002",
    "\u0006\u00c3\u0003\u0002\u0002\u0002\b\u00d0\u0003\u0002\u0002\u0002",
    "\n\u0446\u0003\u0002\u0002\u0002\f\u044c\u0003\u0002\u0002\u0002\u000e",
    "\u044e\u0003\u0002\u0002\u0002\u0010\u045c\u0003\u0002\u0002\u0002\u0012",
    "\u046b\u0003\u0002\u0002\u0002\u0014\u0488\u0003\u0002\u0002\u0002\u0016",
    "\u048a\u0003\u0002\u0002\u0002\u0018\u04bf\u0003\u0002\u0002\u0002\u001a",
    "\u04c8\u0003\u0002\u0002\u0002\u001c\u04ca\u0003\u0002\u0002\u0002\u001e",
    "\u04cc\u0003\u0002\u0002\u0002 \u04d4\u0003\u0002\u0002\u0002\"\u04dd",
    "\u0003\u0002\u0002\u0002$\u04ea\u0003\u0002\u0002\u0002&\u04ef\u0003",
    "\u0002\u0002\u0002(\u04f8\u0003\u0002\u0002\u0002*\u04fc\u0003\u0002",
    "\u0002\u0002,\u04fe\u0003\u0002\u0002\u0002.\u050a\u0003\u0002\u0002",
    "\u00020\u053a\u0003\u0002\u0002\u00022\u054d\u0003\u0002\u0002\u0002",
    "4\u054f\u0003\u0002\u0002\u00026\u0558\u0003\u0002\u0002\u00028\u0564",
    "\u0003\u0002\u0002\u0002:\u0570\u0003\u0002\u0002\u0002<\u057c\u0003",
    "\u0002\u0002\u0002>\u0588\u0003\u0002\u0002\u0002@\u0591\u0003\u0002",
    "\u0002\u0002B\u059a\u0003\u0002\u0002\u0002D\u05a3\u0003\u0002\u0002",
    "\u0002F\u05ac\u0003\u0002\u0002\u0002H\u05b5\u0003\u0002\u0002\u0002",
    "J\u05be\u0003\u0002\u0002\u0002L\u05c7\u0003\u0002\u0002\u0002N\u05d0",
    "\u0003\u0002\u0002\u0002P\u05e6\u0003\u0002\u0002\u0002R\u05fc\u0003",
    "\u0002\u0002\u0002T\u0605\u0003\u0002\u0002\u0002V\u060e\u0003\u0002",
    "\u0002\u0002X\u061f\u0003\u0002\u0002\u0002Z\u062b\u0003\u0002\u0002",
    "\u0002\\\u0637\u0003\u0002\u0002\u0002^\u0643\u0003\u0002\u0002\u0002",
    "`\u064f\u0003\u0002\u0002\u0002b\u065b\u0003\u0002\u0002\u0002d\u0667",
    "\u0003\u0002\u0002\u0002f\u0673\u0003\u0002\u0002\u0002h\u067f\u0003",
    "\u0002\u0002\u0002j\u068b\u0003\u0002\u0002\u0002l\u0697\u0003\u0002",
    "\u0002\u0002n\u06a3\u0003\u0002\u0002\u0002p\u06b4\u0003\u0002\u0002",
    "\u0002r\u06c5\u0003\u0002\u0002\u0002t\u06d1\u0003\u0002\u0002\u0002",
    "v\u06dd\u0003\u0002\u0002\u0002x\u06e6\u0003\u0002\u0002\u0002z\u06f2",
    "\u0003\u0002\u0002\u0002|\u06fe\u0003\u0002\u0002\u0002~\u070a\u0003",
    "\u0002\u0002\u0002\u0080\u0712\u0003\u0002\u0002\u0002\u0082\u0714\u0003",
    "\u0002\u0002\u0002\u0084\u0716\u0003\u0002\u0002\u0002\u0086\u0718\u0003",
    "\u0002\u0002\u0002\u0088\u071a\u0003\u0002\u0002\u0002\u008a\u071c\u0003",
    "\u0002\u0002\u0002\u008c\u071e\u0003\u0002\u0002\u0002\u008e\u0092\u0005",
    "\n\u0006\u0002\u008f\u0092\u0005\u0088E\u0002\u0090\u0092\u0005\u0082",
    "B\u0002\u0091\u008e\u0003\u0002\u0002\u0002\u0091\u008f\u0003\u0002",
    "\u0002\u0002\u0091\u0090\u0003\u0002\u0002\u0002\u0092\u0095\u0003\u0002",
    "\u0002\u0002\u0093\u0091\u0003\u0002\u0002\u0002\u0093\u0094\u0003\u0002",
    "\u0002\u0002\u0094\u0003\u0003\u0002\u0002\u0002\u0095\u0093\u0003\u0002",
    "\u0002\u0002\u0096\u0098\u0005\u0006\u0004\u0002\u0097\u0096\u0003\u0002",
    "\u0002\u0002\u0098\u0099\u0003\u0002\u0002\u0002\u0099\u0097\u0003\u0002",
    "\u0002\u0002\u0099\u009a\u0003\u0002\u0002\u0002\u009a\u009c\u0003\u0002",
    "\u0002\u0002\u009b\u009d\u0005\u0082B\u0002\u009c\u009b\u0003\u0002",
    "\u0002\u0002\u009c\u009d\u0003\u0002\u0002\u0002\u009d\u00a4\u0003\u0002",
    "\u0002\u0002\u009e\u00a4\u0005\u0082B\u0002\u009f\u00a1\u00052\u001a",
    "\u0002\u00a0\u00a2\u0005\u0082B\u0002\u00a1\u00a0\u0003\u0002\u0002",
    "\u0002\u00a1\u00a2\u0003\u0002\u0002\u0002\u00a2\u00a4\u0003\u0002\u0002",
    "\u0002\u00a3\u0097\u0003\u0002\u0002\u0002\u00a3\u009e\u0003\u0002\u0002",
    "\u0002\u00a3\u009f\u0003\u0002\u0002\u0002\u00a4\u0005\u0003\u0002\u0002",
    "\u0002\u00a5\u00c4\u0005\u0012\n\u0002\u00a6\u00c4\u00058\u001d\u0002",
    "\u00a7\u00c4\u0005:\u001e\u0002\u00a8\u00c4\u0005<\u001f\u0002\u00a9",
    "\u00c4\u0005> \u0002\u00aa\u00c4\u0005@!\u0002\u00ab\u00c4\u0005B\"",
    "\u0002\u00ac\u00c4\u0005D#\u0002\u00ad\u00c4\u0005F$\u0002\u00ae\u00c4",
    "\u0005L\'\u0002\u00af\u00c4\u0005N(\u0002\u00b0\u00c4\u0005H%\u0002",
    "\u00b1\u00c4\u0005J&\u0002\u00b2\u00c4\u0005T+\u0002\u00b3\u00c4\u0005",
    "Z.\u0002\u00b4\u00c4\u0005\\/\u0002\u00b5\u00c4\u0005X-\u0002\u00b6",
    "\u00c4\u0005P)\u0002\u00b7\u00c4\u0005R*\u0002\u00b8\u00c4\u00050\u0019",
    "\u0002\u00b9\u00c4\u0005\u0018\r\u0002\u00ba\u00c4\u0005V,\u0002\u00bb",
    "\u00c4\u0005v<\u0002\u00bc\u00c4\u0005\u0014\u000b\u0002\u00bd\u00c4",
    "\u0005x=\u0002\u00be\u00c4\u0005z>\u0002\u00bf\u00c4\u0005|?\u0002\u00c0",
    "\u00c4\u0005~@\u0002\u00c1\u00c4\u00052\u001a\u0002\u00c2\u00c4\u0005",
    "\b\u0005\u0002\u00c3\u00a5\u0003\u0002\u0002\u0002\u00c3\u00a6\u0003",
    "\u0002\u0002\u0002\u00c3\u00a7\u0003\u0002\u0002\u0002\u00c3\u00a8\u0003",
    "\u0002\u0002\u0002\u00c3\u00a9\u0003\u0002\u0002\u0002\u00c3\u00aa\u0003",
    "\u0002\u0002\u0002\u00c3\u00ab\u0003\u0002\u0002\u0002\u00c3\u00ac\u0003",
    "\u0002\u0002\u0002\u00c3\u00ad\u0003\u0002\u0002\u0002\u00c3\u00ae\u0003",
    "\u0002\u0002\u0002\u00c3\u00af\u0003\u0002\u0002\u0002\u00c3\u00b0\u0003",
    "\u0002\u0002\u0002\u00c3\u00b1\u0003\u0002\u0002\u0002\u00c3\u00b2\u0003",
    "\u0002\u0002\u0002\u00c3\u00b3\u0003\u0002\u0002\u0002\u00c3\u00b4\u0003",
    "\u0002\u0002\u0002\u00c3\u00b5\u0003\u0002\u0002\u0002\u00c3\u00b6\u0003",
    "\u0002\u0002\u0002\u00c3\u00b7\u0003\u0002\u0002\u0002\u00c3\u00b8\u0003",
    "\u0002\u0002\u0002\u00c3\u00b9\u0003\u0002\u0002\u0002\u00c3\u00ba\u0003",
    "\u0002\u0002\u0002\u00c3\u00bb\u0003\u0002\u0002\u0002\u00c3\u00bc\u0003",
    "\u0002\u0002\u0002\u00c3\u00bd\u0003\u0002\u0002\u0002\u00c3\u00be\u0003",
    "\u0002\u0002\u0002\u00c3\u00bf\u0003\u0002\u0002\u0002\u00c3\u00c0\u0003",
    "\u0002\u0002\u0002\u00c3\u00c1\u0003\u0002\u0002\u0002\u00c3\u00c2\u0003",
    "\u0002\u0002\u0002\u00c4\u0007\u0003\u0002\u0002\u0002\u00c5\u00d1\u0007",
    "k\u0002\u0002\u00c6\u00cc\u0007k\u0002\u0002\u00c7\u00cd\u0005\u001a",
    "\u000e\u0002\u00c8\u00cd\u0005\u000e\b\u0002\u00c9\u00cd\u0005\u0016",
    "\f\u0002\u00ca\u00cd\u0005,\u0017\u0002\u00cb\u00cd\u00054\u001b\u0002",
    "\u00cc\u00c7\u0003\u0002\u0002\u0002\u00cc\u00c8\u0003\u0002\u0002\u0002",
    "\u00cc\u00c9\u0003\u0002\u0002\u0002\u00cc\u00ca\u0003\u0002\u0002\u0002",
    "\u00cc\u00cb\u0003\u0002\u0002\u0002\u00cd\u00ce\u0003\u0002\u0002\u0002",
    "\u00ce\u00cc\u0003\u0002\u0002\u0002\u00ce\u00cf\u0003\u0002\u0002\u0002",
    "\u00cf\u00d1\u0003\u0002\u0002\u0002\u00d0\u00c5\u0003\u0002\u0002\u0002",
    "\u00d0\u00c6\u0003\u0002\u0002\u0002\u00d1\t\u0003\u0002\u0002\u0002",
    "\u00d2\u00d3\u0007\u0003\u0002\u0002\u00d3\u00d7\u00056\u001c\u0002",
    "\u00d4\u00d6\u0005\f\u0007\u0002\u00d5\u00d4\u0003\u0002\u0002\u0002",
    "\u00d6\u00d9\u0003\u0002\u0002\u0002\u00d7\u00d5\u0003\u0002\u0002\u0002",
    "\u00d7\u00d8\u0003\u0002\u0002\u0002\u00d8\u00da\u0003\u0002\u0002\u0002",
    "\u00d9\u00d7\u0003\u0002\u0002\u0002\u00da\u00e1\u0005\u0088E\u0002",
    "\u00db\u00dd\u0005\u0004\u0003\u0002\u00dc\u00db\u0003\u0002\u0002\u0002",
    "\u00dc\u00dd\u0003\u0002\u0002\u0002\u00dd\u00de\u0003\u0002\u0002\u0002",
    "\u00de\u00e0\u0005\u0088E\u0002\u00df\u00dc\u0003\u0002\u0002\u0002",
    "\u00e0\u00e3\u0003\u0002\u0002\u0002\u00e1\u00df\u0003\u0002\u0002\u0002",
    "\u00e1\u00e2\u0003\u0002\u0002\u0002\u00e2\u00e4\u0003\u0002\u0002\u0002",
    "\u00e3\u00e1\u0003\u0002\u0002\u0002\u00e4\u00e8\u0005\u008cG\u0002",
    "\u00e5\u00e7\u0005\u0088E\u0002\u00e6\u00e5\u0003\u0002\u0002\u0002",
    "\u00e7\u00ea\u0003\u0002\u0002\u0002\u00e8\u00e6\u0003\u0002\u0002\u0002",
    "\u00e8\u00e9\u0003\u0002\u0002\u0002\u00e9\u0447\u0003\u0002\u0002\u0002",
    "\u00ea\u00e8\u0003\u0002\u0002\u0002\u00eb\u00ef\u0007\u0003\u0002\u0002",
    "\u00ec\u00ee\u0005\u0088E\u0002\u00ed\u00ec\u0003\u0002\u0002\u0002",
    "\u00ee\u00f1\u0003\u0002\u0002\u0002\u00ef\u00ed\u0003\u0002\u0002\u0002",
    "\u00ef\u00f0\u0003\u0002\u0002\u0002\u00f0\u00f9\u0003\u0002\u0002\u0002",
    "\u00f1\u00ef\u0003\u0002\u0002\u0002\u00f2\u00f6\u0007\u0003\u0002\u0002",
    "\u00f3\u00f5\u0005\u0088E\u0002\u00f4\u00f3\u0003\u0002\u0002\u0002",
    "\u00f5\u00f8\u0003\u0002\u0002\u0002\u00f6\u00f4\u0003\u0002\u0002\u0002",
    "\u00f6\u00f7\u0003\u0002\u0002\u0002\u00f7\u00fa\u0003\u0002\u0002\u0002",
    "\u00f8\u00f6\u0003\u0002\u0002\u0002\u00f9\u00f2\u0003\u0002\u0002\u0002",
    "\u00fa\u00fb\u0003\u0002\u0002\u0002\u00fb\u00f9\u0003\u0002\u0002\u0002",
    "\u00fb\u00fc\u0003\u0002\u0002\u0002\u00fc\u00fd\u0003\u0002\u0002\u0002",
    "\u00fd\u0101\u00056\u001c\u0002\u00fe\u0100\u0005\u0088E\u0002\u00ff",
    "\u00fe\u0003\u0002\u0002\u0002\u0100\u0103\u0003\u0002\u0002\u0002\u0101",
    "\u00ff\u0003\u0002\u0002\u0002\u0101\u0102\u0003\u0002\u0002\u0002\u0102",
    "\u010d\u0003\u0002\u0002\u0002\u0103\u0101\u0003\u0002\u0002\u0002\u0104",
    "\u010a\u0005\f\u0007\u0002\u0105\u0109\u0005\f\u0007\u0002\u0106\u0109",
    "\u0007k\u0002\u0002\u0107\u0109\u0005\u0088E\u0002\u0108\u0105\u0003",
    "\u0002\u0002\u0002\u0108\u0106\u0003\u0002\u0002\u0002\u0108\u0107\u0003",
    "\u0002\u0002\u0002\u0109\u010c\u0003\u0002\u0002\u0002\u010a\u0108\u0003",
    "\u0002\u0002\u0002\u010a\u010b\u0003\u0002\u0002\u0002\u010b\u010e\u0003",
    "\u0002\u0002\u0002\u010c\u010a\u0003\u0002\u0002\u0002\u010d\u0104\u0003",
    "\u0002\u0002\u0002\u010d\u010e\u0003\u0002\u0002\u0002\u010e\u0112\u0003",
    "\u0002\u0002\u0002\u010f\u0111\u0005\u0088E\u0002\u0110\u010f\u0003",
    "\u0002\u0002\u0002\u0111\u0114\u0003\u0002\u0002\u0002\u0112\u0110\u0003",
    "\u0002\u0002\u0002\u0112\u0113\u0003\u0002\u0002\u0002\u0113\u011b\u0003",
    "\u0002\u0002\u0002\u0114\u0112\u0003\u0002\u0002\u0002\u0115\u0117\u0005",
    "\u0004\u0003\u0002\u0116\u0115\u0003\u0002\u0002\u0002\u0116\u0117\u0003",
    "\u0002\u0002\u0002\u0117\u0118\u0003\u0002\u0002\u0002\u0118\u011a\u0005",
    "\u0088E\u0002\u0119\u0116\u0003\u0002\u0002\u0002\u011a\u011d\u0003",
    "\u0002\u0002\u0002\u011b\u0119\u0003\u0002\u0002\u0002\u011b\u011c\u0003",
    "\u0002\u0002\u0002\u011c\u011f\u0003\u0002\u0002\u0002\u011d\u011b\u0003",
    "\u0002\u0002\u0002\u011e\u0120\u0005\u0004\u0003\u0002\u011f\u011e\u0003",
    "\u0002\u0002\u0002\u011f\u0120\u0003\u0002\u0002\u0002\u0120\u012a\u0003",
    "\u0002\u0002\u0002\u0121\u0123\u0005\u0088E\u0002\u0122\u0121\u0003",
    "\u0002\u0002\u0002\u0123\u0126\u0003\u0002\u0002\u0002\u0124\u0122\u0003",
    "\u0002\u0002\u0002\u0124\u0125\u0003\u0002\u0002\u0002\u0125\u0127\u0003",
    "\u0002\u0002\u0002\u0126\u0124\u0003\u0002\u0002\u0002\u0127\u0129\u0005",
    "\u008cG\u0002\u0128\u0124\u0003\u0002\u0002\u0002\u0129\u012c\u0003",
    "\u0002\u0002\u0002\u012a\u0128\u0003\u0002\u0002\u0002\u012a\u012b\u0003",
    "\u0002\u0002\u0002\u012b\u0130\u0003\u0002\u0002\u0002\u012c\u012a\u0003",
    "\u0002\u0002\u0002\u012d\u012f\u0005\u0088E\u0002\u012e\u012d\u0003",
    "\u0002\u0002\u0002\u012f\u0132\u0003\u0002\u0002\u0002\u0130\u012e\u0003",
    "\u0002\u0002\u0002\u0130\u0131\u0003\u0002\u0002\u0002\u0131\u0447\u0003",
    "\u0002\u0002\u0002\u0132\u0130\u0003\u0002\u0002\u0002\u0133\u0134\u0007",
    "\u0003\u0002\u0002\u0134\u0138\u0007\u0003\u0002\u0002\u0135\u0137\u0005",
    "\u0088E\u0002\u0136\u0135\u0003\u0002\u0002\u0002\u0137\u013a\u0003",
    "\u0002\u0002\u0002\u0138\u0136\u0003\u0002\u0002\u0002\u0138\u0139\u0003",
    "\u0002\u0002\u0002\u0139\u0144\u0003\u0002\u0002\u0002\u013a\u0138\u0003",
    "\u0002\u0002\u0002\u013b\u0141\u0005\f\u0007\u0002\u013c\u0140\u0005",
    "\f\u0007\u0002\u013d\u0140\u0007k\u0002\u0002\u013e\u0140\u0005\u0088",
    "E\u0002\u013f\u013c\u0003\u0002\u0002\u0002\u013f\u013d\u0003\u0002",
    "\u0002\u0002\u013f\u013e\u0003\u0002\u0002\u0002\u0140\u0143\u0003\u0002",
    "\u0002\u0002\u0141\u013f\u0003\u0002\u0002\u0002\u0141\u0142\u0003\u0002",
    "\u0002\u0002\u0142\u0145\u0003\u0002\u0002\u0002\u0143\u0141\u0003\u0002",
    "\u0002\u0002\u0144\u013b\u0003\u0002\u0002\u0002\u0144\u0145\u0003\u0002",
    "\u0002\u0002\u0145\u0149\u0003\u0002\u0002\u0002\u0146\u0148\u0005\u0088",
    "E\u0002\u0147\u0146\u0003\u0002\u0002\u0002\u0148\u014b\u0003\u0002",
    "\u0002\u0002\u0149\u0147\u0003\u0002\u0002\u0002\u0149\u014a\u0003\u0002",
    "\u0002\u0002\u014a\u0152\u0003\u0002\u0002\u0002\u014b\u0149\u0003\u0002",
    "\u0002\u0002\u014c\u014e\u0005\u0004\u0003\u0002\u014d\u014c\u0003\u0002",
    "\u0002\u0002\u014d\u014e\u0003\u0002\u0002\u0002\u014e\u014f\u0003\u0002",
    "\u0002\u0002\u014f\u0151\u0005\u0088E\u0002\u0150\u014d\u0003\u0002",
    "\u0002\u0002\u0151\u0154\u0003\u0002\u0002\u0002\u0152\u0150\u0003\u0002",
    "\u0002\u0002\u0152\u0153\u0003\u0002\u0002\u0002\u0153\u0156\u0003\u0002",
    "\u0002\u0002\u0154\u0152\u0003\u0002\u0002\u0002\u0155\u0157\u0005\u0004",
    "\u0003\u0002\u0156\u0155\u0003\u0002\u0002\u0002\u0156\u0157\u0003\u0002",
    "\u0002\u0002\u0157\u0161\u0003\u0002\u0002\u0002\u0158\u015a\u0005\u0088",
    "E\u0002\u0159\u0158\u0003\u0002\u0002\u0002\u015a\u015d\u0003\u0002",
    "\u0002\u0002\u015b\u0159\u0003\u0002\u0002\u0002\u015b\u015c\u0003\u0002",
    "\u0002\u0002\u015c\u015e\u0003\u0002\u0002\u0002\u015d\u015b\u0003\u0002",
    "\u0002\u0002\u015e\u0160\u0005\u008cG\u0002\u015f\u015b\u0003\u0002",
    "\u0002\u0002\u0160\u0163\u0003\u0002\u0002\u0002\u0161\u015f\u0003\u0002",
    "\u0002\u0002\u0161\u0162\u0003\u0002\u0002\u0002\u0162\u0167\u0003\u0002",
    "\u0002\u0002\u0163\u0161\u0003\u0002\u0002\u0002\u0164\u0166\u0005\u0088",
    "E\u0002\u0165\u0164\u0003\u0002\u0002\u0002\u0166\u0169\u0003\u0002",
    "\u0002\u0002\u0167\u0165\u0003\u0002\u0002\u0002\u0167\u0168\u0003\u0002",
    "\u0002\u0002\u0168\u0447\u0003\u0002\u0002\u0002\u0169\u0167\u0003\u0002",
    "\u0002\u0002\u016a\u016b\u0007\u0003\u0002\u0002\u016b\u016f\u0005\u008c",
    "G\u0002\u016c\u016e\u0005\u0088E\u0002\u016d\u016c\u0003\u0002\u0002",
    "\u0002\u016e\u0171\u0003\u0002\u0002\u0002\u016f\u016d\u0003\u0002\u0002",
    "\u0002\u016f\u0170\u0003\u0002\u0002\u0002\u0170\u017b\u0003\u0002\u0002",
    "\u0002\u0171\u016f\u0003\u0002\u0002\u0002\u0172\u0178\u0005\f\u0007",
    "\u0002\u0173\u0177\u0005\f\u0007\u0002\u0174\u0177\u0007k\u0002\u0002",
    "\u0175\u0177\u0005\u0088E\u0002\u0176\u0173\u0003\u0002\u0002\u0002",
    "\u0176\u0174\u0003\u0002\u0002\u0002\u0176\u0175\u0003\u0002\u0002\u0002",
    "\u0177\u017a\u0003\u0002\u0002\u0002\u0178\u0176\u0003\u0002\u0002\u0002",
    "\u0178\u0179\u0003\u0002\u0002\u0002\u0179\u017c\u0003\u0002\u0002\u0002",
    "\u017a\u0178\u0003\u0002\u0002\u0002\u017b\u0172\u0003\u0002\u0002\u0002",
    "\u017b\u017c\u0003\u0002\u0002\u0002\u017c\u0180\u0003\u0002\u0002\u0002",
    "\u017d\u017f\u0005\u0088E\u0002\u017e\u017d\u0003\u0002\u0002\u0002",
    "\u017f\u0182\u0003\u0002\u0002\u0002\u0180\u017e\u0003\u0002\u0002\u0002",
    "\u0180\u0181\u0003\u0002\u0002\u0002\u0181\u0189\u0003\u0002\u0002\u0002",
    "\u0182\u0180\u0003\u0002\u0002\u0002\u0183\u0185\u0005\u0004\u0003\u0002",
    "\u0184\u0183\u0003\u0002\u0002\u0002\u0184\u0185\u0003\u0002\u0002\u0002",
    "\u0185\u0186\u0003\u0002\u0002\u0002\u0186\u0188\u0005\u0088E\u0002",
    "\u0187\u0184\u0003\u0002\u0002\u0002\u0188\u018b\u0003\u0002\u0002\u0002",
    "\u0189\u0187\u0003\u0002\u0002\u0002\u0189\u018a\u0003\u0002\u0002\u0002",
    "\u018a\u018d\u0003\u0002\u0002\u0002\u018b\u0189\u0003\u0002\u0002\u0002",
    "\u018c\u018e\u0005\u0004\u0003\u0002\u018d\u018c\u0003\u0002\u0002\u0002",
    "\u018d\u018e\u0003\u0002\u0002\u0002\u018e\u0198\u0003\u0002\u0002\u0002",
    "\u018f\u0191\u0005\u0088E\u0002\u0190\u018f\u0003\u0002\u0002\u0002",
    "\u0191\u0194\u0003\u0002\u0002\u0002\u0192\u0190\u0003\u0002\u0002\u0002",
    "\u0192\u0193\u0003\u0002\u0002\u0002\u0193\u0195\u0003\u0002\u0002\u0002",
    "\u0194\u0192\u0003\u0002\u0002\u0002\u0195\u0197\u0005\u008cG\u0002",
    "\u0196\u0192\u0003\u0002\u0002\u0002\u0197\u019a\u0003\u0002\u0002\u0002",
    "\u0198\u0196\u0003\u0002\u0002\u0002\u0198\u0199\u0003\u0002\u0002\u0002",
    "\u0199\u019e\u0003\u0002\u0002\u0002\u019a\u0198\u0003\u0002\u0002\u0002",
    "\u019b\u019d\u0005\u0088E\u0002\u019c\u019b\u0003\u0002\u0002\u0002",
    "\u019d\u01a0\u0003\u0002\u0002\u0002\u019e\u019c\u0003\u0002\u0002\u0002",
    "\u019e\u019f\u0003\u0002\u0002\u0002\u019f\u0447\u0003\u0002\u0002\u0002",
    "\u01a0\u019e\u0003\u0002\u0002\u0002\u01a1\u01a2\u0007\u0003\u0002\u0002",
    "\u01a2\u01a6\t\u0002\u0002\u0002\u01a3\u01a5\u0005\u0088E\u0002\u01a4",
    "\u01a3\u0003\u0002\u0002\u0002\u01a5\u01a8\u0003\u0002\u0002\u0002\u01a6",
    "\u01a4\u0003\u0002\u0002\u0002\u01a6\u01a7\u0003\u0002\u0002\u0002\u01a7",
    "\u01b2\u0003\u0002\u0002\u0002\u01a8\u01a6\u0003\u0002\u0002\u0002\u01a9",
    "\u01af\u0005\f\u0007\u0002\u01aa\u01ae\u0005\f\u0007\u0002\u01ab\u01ae",
    "\u0007k\u0002\u0002\u01ac\u01ae\u0005\u0088E\u0002\u01ad\u01aa\u0003",
    "\u0002\u0002\u0002\u01ad\u01ab\u0003\u0002\u0002\u0002\u01ad\u01ac\u0003",
    "\u0002\u0002\u0002\u01ae\u01b1\u0003\u0002\u0002\u0002\u01af\u01ad\u0003",
    "\u0002\u0002\u0002\u01af\u01b0\u0003\u0002\u0002\u0002\u01b0\u01b3\u0003",
    "\u0002\u0002\u0002\u01b1\u01af\u0003\u0002\u0002\u0002\u01b2\u01a9\u0003",
    "\u0002\u0002\u0002\u01b2\u01b3\u0003\u0002\u0002\u0002\u01b3\u01b7\u0003",
    "\u0002\u0002\u0002\u01b4\u01b6\u0005\u0088E\u0002\u01b5\u01b4\u0003",
    "\u0002\u0002\u0002\u01b6\u01b9\u0003\u0002\u0002\u0002\u01b7\u01b5\u0003",
    "\u0002\u0002\u0002\u01b7\u01b8\u0003\u0002\u0002\u0002\u01b8\u01c0\u0003",
    "\u0002\u0002\u0002\u01b9\u01b7\u0003\u0002\u0002\u0002\u01ba\u01bc\u0005",
    "\u0004\u0003\u0002\u01bb\u01ba\u0003\u0002\u0002\u0002\u01bb\u01bc\u0003",
    "\u0002\u0002\u0002\u01bc\u01bd\u0003\u0002\u0002\u0002\u01bd\u01bf\u0005",
    "\u0088E\u0002\u01be\u01bb\u0003\u0002\u0002\u0002\u01bf\u01c2\u0003",
    "\u0002\u0002\u0002\u01c0\u01be\u0003\u0002\u0002\u0002\u01c0\u01c1\u0003",
    "\u0002\u0002\u0002\u01c1\u01c4\u0003\u0002\u0002\u0002\u01c2\u01c0\u0003",
    "\u0002\u0002\u0002\u01c3\u01c5\u0005\u0004\u0003\u0002\u01c4\u01c3\u0003",
    "\u0002\u0002\u0002\u01c4\u01c5\u0003\u0002\u0002\u0002\u01c5\u01cf\u0003",
    "\u0002\u0002\u0002\u01c6\u01c8\u0005\u0088E\u0002\u01c7\u01c6\u0003",
    "\u0002\u0002\u0002\u01c8\u01cb\u0003\u0002\u0002\u0002\u01c9\u01c7\u0003",
    "\u0002\u0002\u0002\u01c9\u01ca\u0003\u0002\u0002\u0002\u01ca\u01cc\u0003",
    "\u0002\u0002\u0002\u01cb\u01c9\u0003\u0002\u0002\u0002\u01cc\u01ce\u0005",
    "\u008cG\u0002\u01cd\u01c9\u0003\u0002\u0002\u0002\u01ce\u01d1\u0003",
    "\u0002\u0002\u0002\u01cf\u01cd\u0003\u0002\u0002\u0002\u01cf\u01d0\u0003",
    "\u0002\u0002\u0002\u01d0\u01d5\u0003\u0002\u0002\u0002\u01d1\u01cf\u0003",
    "\u0002\u0002\u0002\u01d2\u01d4\u0005\u0088E\u0002\u01d3\u01d2\u0003",
    "\u0002\u0002\u0002\u01d4\u01d7\u0003\u0002\u0002\u0002\u01d5\u01d3\u0003",
    "\u0002\u0002\u0002\u01d5\u01d6\u0003\u0002\u0002\u0002\u01d6\u0447\u0003",
    "\u0002\u0002\u0002\u01d7\u01d5\u0003\u0002\u0002\u0002\u01d8\u01d9\u0007",
    "\u0003\u0002\u0002\u01d9\u01dd\t\u0003\u0002\u0002\u01da\u01dc\u0005",
    "\u0088E\u0002\u01db\u01da\u0003\u0002\u0002\u0002\u01dc\u01df\u0003",
    "\u0002\u0002\u0002\u01dd\u01db\u0003\u0002\u0002\u0002\u01dd\u01de\u0003",
    "\u0002\u0002\u0002\u01de\u01e9\u0003\u0002\u0002\u0002\u01df\u01dd\u0003",
    "\u0002\u0002\u0002\u01e0\u01e6\u0005\f\u0007\u0002\u01e1\u01e5\u0005",
    "\f\u0007\u0002\u01e2\u01e5\u0007k\u0002\u0002\u01e3\u01e5\u0005\u0088",
    "E\u0002\u01e4\u01e1\u0003\u0002\u0002\u0002\u01e4\u01e2\u0003\u0002",
    "\u0002\u0002\u01e4\u01e3\u0003\u0002\u0002\u0002\u01e5\u01e8\u0003\u0002",
    "\u0002\u0002\u01e6\u01e4\u0003\u0002\u0002\u0002\u01e6\u01e7\u0003\u0002",
    "\u0002\u0002\u01e7\u01ea\u0003\u0002\u0002\u0002\u01e8\u01e6\u0003\u0002",
    "\u0002\u0002\u01e9\u01e0\u0003\u0002\u0002\u0002\u01e9\u01ea\u0003\u0002",
    "\u0002\u0002\u01ea\u01ee\u0003\u0002\u0002\u0002\u01eb\u01ed\u0005\u0088",
    "E\u0002\u01ec\u01eb\u0003\u0002\u0002\u0002\u01ed\u01f0\u0003\u0002",
    "\u0002\u0002\u01ee\u01ec\u0003\u0002\u0002\u0002\u01ee\u01ef\u0003\u0002",
    "\u0002\u0002\u01ef\u01f7\u0003\u0002\u0002\u0002\u01f0\u01ee\u0003\u0002",
    "\u0002\u0002\u01f1\u01f3\u0005\u0004\u0003\u0002\u01f2\u01f1\u0003\u0002",
    "\u0002\u0002\u01f2\u01f3\u0003\u0002\u0002\u0002\u01f3\u01f4\u0003\u0002",
    "\u0002\u0002\u01f4\u01f6\u0005\u0088E\u0002\u01f5\u01f2\u0003\u0002",
    "\u0002\u0002\u01f6\u01f9\u0003\u0002\u0002\u0002\u01f7\u01f5\u0003\u0002",
    "\u0002\u0002\u01f7\u01f8\u0003\u0002\u0002\u0002\u01f8\u01fb\u0003\u0002",
    "\u0002\u0002\u01f9\u01f7\u0003\u0002\u0002\u0002\u01fa\u01fc\u0005\u0004",
    "\u0003\u0002\u01fb\u01fa\u0003\u0002\u0002\u0002\u01fb\u01fc\u0003\u0002",
    "\u0002\u0002\u01fc\u0206\u0003\u0002\u0002\u0002\u01fd\u01ff\u0005\u0088",
    "E\u0002\u01fe\u01fd\u0003\u0002\u0002\u0002\u01ff\u0202\u0003\u0002",
    "\u0002\u0002\u0200\u01fe\u0003\u0002\u0002\u0002\u0200\u0201\u0003\u0002",
    "\u0002\u0002\u0201\u0203\u0003\u0002\u0002\u0002\u0202\u0200\u0003\u0002",
    "\u0002\u0002\u0203\u0205\u0005\u008cG\u0002\u0204\u0200\u0003\u0002",
    "\u0002\u0002\u0205\u0208\u0003\u0002\u0002\u0002\u0206\u0204\u0003\u0002",
    "\u0002\u0002\u0206\u0207\u0003\u0002\u0002\u0002\u0207\u020c\u0003\u0002",
    "\u0002\u0002\u0208\u0206\u0003\u0002\u0002\u0002\u0209\u020b\u0005\u0088",
    "E\u0002\u020a\u0209\u0003\u0002\u0002\u0002\u020b\u020e\u0003\u0002",
    "\u0002\u0002\u020c\u020a\u0003\u0002\u0002\u0002\u020c\u020d\u0003\u0002",
    "\u0002\u0002\u020d\u0447\u0003\u0002\u0002\u0002\u020e\u020c\u0003\u0002",
    "\u0002\u0002\u020f\u0210\u0007\u0003\u0002\u0002\u0210\u0212\u0007k",
    "\u0002\u0002\u0211\u0213\u0007k\u0002\u0002\u0212\u0211\u0003\u0002",
    "\u0002\u0002\u0213\u0214\u0003\u0002\u0002\u0002\u0214\u0212\u0003\u0002",
    "\u0002\u0002\u0214\u0215\u0003\u0002\u0002\u0002\u0215\u0219\u0003\u0002",
    "\u0002\u0002\u0216\u0218\u0005\u0088E\u0002\u0217\u0216\u0003\u0002",
    "\u0002\u0002\u0218\u021b\u0003\u0002\u0002\u0002\u0219\u0217\u0003\u0002",
    "\u0002\u0002\u0219\u021a\u0003\u0002\u0002\u0002\u021a\u0220\u0003\u0002",
    "\u0002\u0002\u021b\u0219\u0003\u0002\u0002\u0002\u021c\u021f\u0005\f",
    "\u0007\u0002\u021d\u021f\u0005\u0088E\u0002\u021e\u021c\u0003\u0002",
    "\u0002\u0002\u021e\u021d\u0003\u0002\u0002\u0002\u021f\u0222\u0003\u0002",
    "\u0002\u0002\u0220\u021e\u0003\u0002\u0002\u0002\u0220\u0221\u0003\u0002",
    "\u0002\u0002\u0221\u0226\u0003\u0002\u0002\u0002\u0222\u0220\u0003\u0002",
    "\u0002\u0002\u0223\u0225\u0005\u0088E\u0002\u0224\u0223\u0003\u0002",
    "\u0002\u0002\u0225\u0228\u0003\u0002\u0002\u0002\u0226\u0224\u0003\u0002",
    "\u0002\u0002\u0226\u0227\u0003\u0002\u0002\u0002\u0227\u022f\u0003\u0002",
    "\u0002\u0002\u0228\u0226\u0003\u0002\u0002\u0002\u0229\u022b\u0005\u0004",
    "\u0003\u0002\u022a\u0229\u0003\u0002\u0002\u0002\u022a\u022b\u0003\u0002",
    "\u0002\u0002\u022b\u022c\u0003\u0002\u0002\u0002\u022c\u022e\u0005\u0088",
    "E\u0002\u022d\u022a\u0003\u0002\u0002\u0002\u022e\u0231\u0003\u0002",
    "\u0002\u0002\u022f\u022d\u0003\u0002\u0002\u0002\u022f\u0230\u0003\u0002",
    "\u0002\u0002\u0230\u0233\u0003\u0002\u0002\u0002\u0231\u022f\u0003\u0002",
    "\u0002\u0002\u0232\u0234\u0005\u0004\u0003\u0002\u0233\u0232\u0003\u0002",
    "\u0002\u0002\u0233\u0234\u0003\u0002\u0002\u0002\u0234\u023e\u0003\u0002",
    "\u0002\u0002\u0235\u0237\u0005\u0088E\u0002\u0236\u0235\u0003\u0002",
    "\u0002\u0002\u0237\u023a\u0003\u0002\u0002\u0002\u0238\u0236\u0003\u0002",
    "\u0002\u0002\u0238\u0239\u0003\u0002\u0002\u0002\u0239\u023b\u0003\u0002",
    "\u0002\u0002\u023a\u0238\u0003\u0002\u0002\u0002\u023b\u023d\u0005\u008c",
    "G\u0002\u023c\u0238\u0003\u0002\u0002\u0002\u023d\u0240\u0003\u0002",
    "\u0002\u0002\u023e\u023c\u0003\u0002\u0002\u0002\u023e\u023f\u0003\u0002",
    "\u0002\u0002\u023f\u0244\u0003\u0002\u0002\u0002\u0240\u023e\u0003\u0002",
    "\u0002\u0002\u0241\u0243\u0005\u0088E\u0002\u0242\u0241\u0003\u0002",
    "\u0002\u0002\u0243\u0246\u0003\u0002\u0002\u0002\u0244\u0242\u0003\u0002",
    "\u0002\u0002\u0244\u0245\u0003\u0002\u0002\u0002\u0245\u0447\u0003\u0002",
    "\u0002\u0002\u0246\u0244\u0003\u0002\u0002\u0002\u0247\u0248\u0007\u0003",
    "\u0002\u0002\u0248\u024a\u00056\u001c\u0002\u0249\u024b\u0005\u0088",
    "E\u0002\u024a\u0249\u0003\u0002\u0002\u0002\u024b\u024c\u0003\u0002",
    "\u0002\u0002\u024c\u024a\u0003\u0002\u0002\u0002\u024c\u024d\u0003\u0002",
    "\u0002\u0002\u024d\u024e\u0003\u0002\u0002\u0002\u024e\u0254\u0005\f",
    "\u0007\u0002\u024f\u0253\u0005\f\u0007\u0002\u0250\u0253\u0007k\u0002",
    "\u0002\u0251\u0253\u0005\u0088E\u0002\u0252\u024f\u0003\u0002\u0002",
    "\u0002\u0252\u0250\u0003\u0002\u0002\u0002\u0252\u0251\u0003\u0002\u0002",
    "\u0002\u0253\u0256\u0003\u0002\u0002\u0002\u0254\u0252\u0003\u0002\u0002",
    "\u0002\u0254\u0255\u0003\u0002\u0002\u0002\u0255\u025a\u0003\u0002\u0002",
    "\u0002\u0256\u0254\u0003\u0002\u0002\u0002\u0257\u0259\u0005\u0088E",
    "\u0002\u0258\u0257\u0003\u0002\u0002\u0002\u0259\u025c\u0003\u0002\u0002",
    "\u0002\u025a\u0258\u0003\u0002\u0002\u0002\u025a\u025b\u0003\u0002\u0002",
    "\u0002\u025b\u0263\u0003\u0002\u0002\u0002\u025c\u025a\u0003\u0002\u0002",
    "\u0002\u025d\u025f\u0005\u0004\u0003\u0002\u025e\u025d\u0003\u0002\u0002",
    "\u0002\u025e\u025f\u0003\u0002\u0002\u0002\u025f\u0260\u0003\u0002\u0002",
    "\u0002\u0260\u0262\u0005\u0088E\u0002\u0261\u025e\u0003\u0002\u0002",
    "\u0002\u0262\u0265\u0003\u0002\u0002\u0002\u0263\u0261\u0003\u0002\u0002",
    "\u0002\u0263\u0264\u0003\u0002\u0002\u0002\u0264\u0267\u0003\u0002\u0002",
    "\u0002\u0265\u0263\u0003\u0002\u0002\u0002\u0266\u0268\u0005\u0004\u0003",
    "\u0002\u0267\u0266\u0003\u0002\u0002\u0002\u0267\u0268\u0003\u0002\u0002",
    "\u0002\u0268\u0272\u0003\u0002\u0002\u0002\u0269\u026b\u0005\u0088E",
    "\u0002\u026a\u0269\u0003\u0002\u0002\u0002\u026b\u026e\u0003\u0002\u0002",
    "\u0002\u026c\u026a\u0003\u0002\u0002\u0002\u026c\u026d\u0003\u0002\u0002",
    "\u0002\u026d\u026f\u0003\u0002\u0002\u0002\u026e\u026c\u0003\u0002\u0002",
    "\u0002\u026f\u0271\u0005\u008cG\u0002\u0270\u026c\u0003\u0002\u0002",
    "\u0002\u0271\u0274\u0003\u0002\u0002\u0002\u0272\u0270\u0003\u0002\u0002",
    "\u0002\u0272\u0273\u0003\u0002\u0002\u0002\u0273\u0278\u0003\u0002\u0002",
    "\u0002\u0274\u0272\u0003\u0002\u0002\u0002\u0275\u0277\u0005\u0088E",
    "\u0002\u0276\u0275\u0003\u0002\u0002\u0002\u0277\u027a\u0003\u0002\u0002",
    "\u0002\u0278\u0276\u0003\u0002\u0002\u0002\u0278\u0279\u0003\u0002\u0002",
    "\u0002\u0279\u0447\u0003\u0002\u0002\u0002\u027a\u0278\u0003\u0002\u0002",
    "\u0002\u027b\u027c\u0007\u0003\u0002\u0002\u027c\u027e\u00056\u001c",
    "\u0002\u027d\u027f\u0005\f\u0007\u0002\u027e\u027d\u0003\u0002\u0002",
    "\u0002\u027f\u0280\u0003\u0002\u0002\u0002\u0280\u027e\u0003\u0002\u0002",
    "\u0002\u0280\u0281\u0003\u0002\u0002\u0002\u0281\u0283\u0003\u0002\u0002",
    "\u0002\u0282\u0284\u0005\u0088E\u0002\u0283\u0282\u0003\u0002\u0002",
    "\u0002\u0284\u0285\u0003\u0002\u0002\u0002\u0285\u0283\u0003\u0002\u0002",
    "\u0002\u0285\u0286\u0003\u0002\u0002\u0002\u0286\u0288\u0003\u0002\u0002",
    "\u0002\u0287\u0289\u0005\f\u0007\u0002\u0288\u0287\u0003\u0002\u0002",
    "\u0002\u0289\u028a\u0003\u0002\u0002\u0002\u028a\u0288\u0003\u0002\u0002",
    "\u0002\u028a\u028b\u0003\u0002\u0002\u0002\u028b\u0290\u0003\u0002\u0002",
    "\u0002\u028c\u028f\u0005\f\u0007\u0002\u028d\u028f\u0005\u0088E\u0002",
    "\u028e\u028c\u0003\u0002\u0002\u0002\u028e\u028d\u0003\u0002\u0002\u0002",
    "\u028f\u0292\u0003\u0002\u0002\u0002\u0290\u028e\u0003\u0002\u0002\u0002",
    "\u0290\u0291\u0003\u0002\u0002\u0002\u0291\u0296\u0003\u0002\u0002\u0002",
    "\u0292\u0290\u0003\u0002\u0002\u0002\u0293\u0295\u0005\u0088E\u0002",
    "\u0294\u0293\u0003\u0002\u0002\u0002\u0295\u0298\u0003\u0002\u0002\u0002",
    "\u0296\u0294\u0003\u0002\u0002\u0002\u0296\u0297\u0003\u0002\u0002\u0002",
    "\u0297\u029f\u0003\u0002\u0002\u0002\u0298\u0296\u0003\u0002\u0002\u0002",
    "\u0299\u029b\u0005\u0004\u0003\u0002\u029a\u0299\u0003\u0002\u0002\u0002",
    "\u029a\u029b\u0003\u0002\u0002\u0002\u029b\u029c\u0003\u0002\u0002\u0002",
    "\u029c\u029e\u0005\u0088E\u0002\u029d\u029a\u0003\u0002\u0002\u0002",
    "\u029e\u02a1\u0003\u0002\u0002\u0002\u029f\u029d\u0003\u0002\u0002\u0002",
    "\u029f\u02a0\u0003\u0002\u0002\u0002\u02a0\u02a3\u0003\u0002\u0002\u0002",
    "\u02a1\u029f\u0003\u0002\u0002\u0002\u02a2\u02a4\u0005\u0004\u0003\u0002",
    "\u02a3\u02a2\u0003\u0002\u0002\u0002\u02a3\u02a4\u0003\u0002\u0002\u0002",
    "\u02a4\u02ae\u0003\u0002\u0002\u0002\u02a5\u02a7\u0005\u0088E\u0002",
    "\u02a6\u02a5\u0003\u0002\u0002\u0002\u02a7\u02aa\u0003\u0002\u0002\u0002",
    "\u02a8\u02a6\u0003\u0002\u0002\u0002\u02a8\u02a9\u0003\u0002\u0002\u0002",
    "\u02a9\u02ab\u0003\u0002\u0002\u0002\u02aa\u02a8\u0003\u0002\u0002\u0002",
    "\u02ab\u02ad\u0005\u008cG\u0002\u02ac\u02a8\u0003\u0002\u0002\u0002",
    "\u02ad\u02b0\u0003\u0002\u0002\u0002\u02ae\u02ac\u0003\u0002\u0002\u0002",
    "\u02ae\u02af\u0003\u0002\u0002\u0002\u02af\u02b4\u0003\u0002\u0002\u0002",
    "\u02b0\u02ae\u0003\u0002\u0002\u0002\u02b1\u02b3\u0005\u0088E\u0002",
    "\u02b2\u02b1\u0003\u0002\u0002\u0002\u02b3\u02b6\u0003\u0002\u0002\u0002",
    "\u02b4\u02b2\u0003\u0002\u0002\u0002\u02b4\u02b5\u0003\u0002\u0002\u0002",
    "\u02b5\u0447\u0003\u0002\u0002\u0002\u02b6\u02b4\u0003\u0002\u0002\u0002",
    "\u02b7\u02b9\u0007\u0003\u0002\u0002\u02b8\u02ba\u0005\u0088E\u0002",
    "\u02b9\u02b8\u0003\u0002\u0002\u0002\u02ba\u02bb\u0003\u0002\u0002\u0002",
    "\u02bb\u02b9\u0003\u0002\u0002\u0002\u02bb\u02bc\u0003\u0002\u0002\u0002",
    "\u02bc\u02bd\u0003\u0002\u0002\u0002\u02bd\u02c1\u00056\u001c\u0002",
    "\u02be\u02c0\u0005\u0088E\u0002\u02bf\u02be\u0003\u0002\u0002\u0002",
    "\u02c0\u02c3\u0003\u0002\u0002\u0002\u02c1\u02bf\u0003\u0002\u0002\u0002",
    "\u02c1\u02c2\u0003\u0002\u0002\u0002\u02c2\u02cd\u0003\u0002\u0002\u0002",
    "\u02c3\u02c1\u0003\u0002\u0002\u0002\u02c4\u02ca\u0005\f\u0007\u0002",
    "\u02c5\u02c9\u0005\f\u0007\u0002\u02c6\u02c9\u0007k\u0002\u0002\u02c7",
    "\u02c9\u0005\u0088E\u0002\u02c8\u02c5\u0003\u0002\u0002\u0002\u02c8",
    "\u02c6\u0003\u0002\u0002\u0002\u02c8\u02c7\u0003\u0002\u0002\u0002\u02c9",
    "\u02cc\u0003\u0002\u0002\u0002\u02ca\u02c8\u0003\u0002\u0002\u0002\u02ca",
    "\u02cb\u0003\u0002\u0002\u0002\u02cb\u02ce\u0003\u0002\u0002\u0002\u02cc",
    "\u02ca\u0003\u0002\u0002\u0002\u02cd\u02c4\u0003\u0002\u0002\u0002\u02cd",
    "\u02ce\u0003\u0002\u0002\u0002\u02ce\u02d2\u0003\u0002\u0002\u0002\u02cf",
    "\u02d1\u0005\u0088E\u0002\u02d0\u02cf\u0003\u0002\u0002\u0002\u02d1",
    "\u02d4\u0003\u0002\u0002\u0002\u02d2\u02d0\u0003\u0002\u0002\u0002\u02d2",
    "\u02d3\u0003\u0002\u0002\u0002\u02d3\u02db\u0003\u0002\u0002\u0002\u02d4",
    "\u02d2\u0003\u0002\u0002\u0002\u02d5\u02d7\u0005\u0004\u0003\u0002\u02d6",
    "\u02d5\u0003\u0002\u0002\u0002\u02d6\u02d7\u0003\u0002\u0002\u0002\u02d7",
    "\u02d8\u0003\u0002\u0002\u0002\u02d8\u02da\u0005\u0088E\u0002\u02d9",
    "\u02d6\u0003\u0002\u0002\u0002\u02da\u02dd\u0003\u0002\u0002\u0002\u02db",
    "\u02d9\u0003\u0002\u0002\u0002\u02db\u02dc\u0003\u0002\u0002\u0002\u02dc",
    "\u02df\u0003\u0002\u0002\u0002\u02dd\u02db\u0003\u0002\u0002\u0002\u02de",
    "\u02e0\u0005\u0004\u0003\u0002\u02df\u02de\u0003\u0002\u0002\u0002\u02df",
    "\u02e0\u0003\u0002\u0002\u0002\u02e0\u02ea\u0003\u0002\u0002\u0002\u02e1",
    "\u02e3\u0005\u0088E\u0002\u02e2\u02e1\u0003\u0002\u0002\u0002\u02e3",
    "\u02e6\u0003\u0002\u0002\u0002\u02e4\u02e2\u0003\u0002\u0002\u0002\u02e4",
    "\u02e5\u0003\u0002\u0002\u0002\u02e5\u02e7\u0003\u0002\u0002\u0002\u02e6",
    "\u02e4\u0003\u0002\u0002\u0002\u02e7\u02e9\u0005\u008cG\u0002\u02e8",
    "\u02e4\u0003\u0002\u0002\u0002\u02e9\u02ec\u0003\u0002\u0002\u0002\u02ea",
    "\u02e8\u0003\u0002\u0002\u0002\u02ea\u02eb\u0003\u0002\u0002\u0002\u02eb",
    "\u02f0\u0003\u0002\u0002\u0002\u02ec\u02ea\u0003\u0002\u0002\u0002\u02ed",
    "\u02ef\u0005\u0088E\u0002\u02ee\u02ed\u0003\u0002\u0002\u0002\u02ef",
    "\u02f2\u0003\u0002\u0002\u0002\u02f0\u02ee\u0003\u0002\u0002\u0002\u02f0",
    "\u02f1\u0003\u0002\u0002\u0002\u02f1\u0447\u0003\u0002\u0002\u0002\u02f2",
    "\u02f0\u0003\u0002\u0002\u0002\u02f3\u02f4\u0007\u0003\u0002\u0002\u02f4",
    "\u02f8\u00056\u001c\u0002\u02f5\u02f7\u0005\f\u0007\u0002\u02f6\u02f5",
    "\u0003\u0002\u0002\u0002\u02f7\u02fa\u0003\u0002\u0002\u0002\u02f8\u02f6",
    "\u0003\u0002\u0002\u0002\u02f8\u02f9\u0003\u0002\u0002\u0002\u02f9\u030b",
    "\u0003\u0002\u0002\u0002\u02fa\u02f8\u0003\u0002\u0002\u0002\u02fb\u02fd",
    "\u0005\u0088E\u0002\u02fc\u02fb\u0003\u0002\u0002\u0002\u02fd\u02fe",
    "\u0003\u0002\u0002\u0002\u02fe\u02fc\u0003\u0002\u0002\u0002\u02fe\u02ff",
    "\u0003\u0002\u0002\u0002\u02ff\u0306\u0003\u0002\u0002\u0002\u0300\u0302",
    "\u0005\u0004\u0003\u0002\u0301\u0300\u0003\u0002\u0002\u0002\u0301\u0302",
    "\u0003\u0002\u0002\u0002\u0302\u0303\u0003\u0002\u0002\u0002\u0303\u0305",
    "\u0005\u0088E\u0002\u0304\u0301\u0003\u0002\u0002\u0002\u0305\u0308",
    "\u0003\u0002\u0002\u0002\u0306\u0304\u0003\u0002\u0002\u0002\u0306\u0307",
    "\u0003\u0002\u0002\u0002\u0307\u0309\u0003\u0002\u0002\u0002\u0308\u0306",
    "\u0003\u0002\u0002\u0002\u0309\u030a\u0005\u0004\u0003\u0002\u030a\u030c",
    "\u0003\u0002\u0002\u0002\u030b\u02fc\u0003\u0002\u0002\u0002\u030b\u030c",
    "\u0003\u0002\u0002\u0002\u030c\u030d\u0003\u0002\u0002\u0002\u030d\u0311",
    "\u0005\u008cG\u0002\u030e\u0310\u0005\u0088E\u0002\u030f\u030e\u0003",
    "\u0002\u0002\u0002\u0310\u0313\u0003\u0002\u0002\u0002\u0311\u030f\u0003",
    "\u0002\u0002\u0002\u0311\u0312\u0003\u0002\u0002\u0002\u0312\u0447\u0003",
    "\u0002\u0002\u0002\u0313\u0311\u0003\u0002\u0002\u0002\u0314\u0315\u0007",
    "\u0003\u0002\u0002\u0315\u0319\u00056\u001c\u0002\u0316\u0318\u0007",
    "k\u0002\u0002\u0317\u0316\u0003\u0002\u0002\u0002\u0318\u031b\u0003",
    "\u0002\u0002\u0002\u0319\u0317\u0003\u0002\u0002\u0002\u0319\u031a\u0003",
    "\u0002\u0002\u0002\u031a\u031c\u0003\u0002\u0002\u0002\u031b\u0319\u0003",
    "\u0002\u0002\u0002\u031c\u0321\u0005\f\u0007\u0002\u031d\u0320\u0005",
    "\f\u0007\u0002\u031e\u0320\u0007k\u0002\u0002\u031f\u031d\u0003\u0002",
    "\u0002\u0002\u031f\u031e\u0003\u0002\u0002\u0002\u0320\u0323\u0003\u0002",
    "\u0002\u0002\u0321\u031f\u0003\u0002\u0002\u0002\u0321\u0322\u0003\u0002",
    "\u0002\u0002\u0322\u0324\u0003\u0002\u0002\u0002\u0323\u0321\u0003\u0002",
    "\u0002\u0002\u0324\u0329\u0007k\u0002\u0002\u0325\u0328\u0005\f\u0007",
    "\u0002\u0326\u0328\u0007k\u0002\u0002\u0327\u0325\u0003\u0002\u0002",
    "\u0002\u0327\u0326\u0003\u0002\u0002\u0002\u0328\u032b\u0003\u0002\u0002",
    "\u0002\u0329\u0327\u0003\u0002\u0002\u0002\u0329\u032a\u0003\u0002\u0002",
    "\u0002\u032a\u032f\u0003\u0002\u0002\u0002\u032b\u0329\u0003\u0002\u0002",
    "\u0002\u032c\u032e\u0005\u0088E\u0002\u032d\u032c\u0003\u0002\u0002",
    "\u0002\u032e\u0331\u0003\u0002\u0002\u0002\u032f\u032d\u0003\u0002\u0002",
    "\u0002\u032f\u0330\u0003\u0002\u0002\u0002\u0330\u0338\u0003\u0002\u0002",
    "\u0002\u0331\u032f\u0003\u0002\u0002\u0002\u0332\u0334\u0005\u0004\u0003",
    "\u0002\u0333\u0332\u0003\u0002\u0002\u0002\u0333\u0334\u0003\u0002\u0002",
    "\u0002\u0334\u0335\u0003\u0002\u0002\u0002\u0335\u0337\u0005\u0088E",
    "\u0002\u0336\u0333\u0003\u0002\u0002\u0002\u0337\u033a\u0003\u0002\u0002",
    "\u0002\u0338\u0336\u0003\u0002\u0002\u0002\u0338\u0339\u0003\u0002\u0002",
    "\u0002\u0339\u033c\u0003\u0002\u0002\u0002\u033a\u0338\u0003\u0002\u0002",
    "\u0002\u033b\u033d\u0005\u0004\u0003\u0002\u033c\u033b\u0003\u0002\u0002",
    "\u0002\u033c\u033d\u0003\u0002\u0002\u0002\u033d\u0347\u0003\u0002\u0002",
    "\u0002\u033e\u0340\u0005\u0088E\u0002\u033f\u033e\u0003\u0002\u0002",
    "\u0002\u0340\u0343\u0003\u0002\u0002\u0002\u0341\u033f\u0003\u0002\u0002",
    "\u0002\u0341\u0342\u0003\u0002\u0002\u0002\u0342\u0344\u0003\u0002\u0002",
    "\u0002\u0343\u0341\u0003\u0002\u0002\u0002\u0344\u0346\u0005\u008cG",
    "\u0002\u0345\u0341\u0003\u0002\u0002\u0002\u0346\u0349\u0003\u0002\u0002",
    "\u0002\u0347\u0345\u0003\u0002\u0002\u0002\u0347\u0348\u0003\u0002\u0002",
    "\u0002\u0348\u034d\u0003\u0002\u0002\u0002\u0349\u0347\u0003\u0002\u0002",
    "\u0002\u034a\u034c\u0005\u0088E\u0002\u034b\u034a\u0003\u0002\u0002",
    "\u0002\u034c\u034f\u0003\u0002\u0002\u0002\u034d\u034b\u0003\u0002\u0002",
    "\u0002\u034d\u034e\u0003\u0002\u0002\u0002\u034e\u0447\u0003\u0002\u0002",
    "\u0002\u034f\u034d\u0003\u0002\u0002\u0002\u0350\u0351\u0007\u0003\u0002",
    "\u0002\u0351\u0355\u00056\u001c\u0002\u0352\u0354\u0005\f\u0007\u0002",
    "\u0353\u0352\u0003\u0002\u0002\u0002\u0354\u0357\u0003\u0002\u0002\u0002",
    "\u0355\u0353\u0003\u0002\u0002\u0002\u0355\u0356\u0003\u0002\u0002\u0002",
    "\u0356\u0358\u0003\u0002\u0002\u0002\u0357\u0355\u0003\u0002\u0002\u0002",
    "\u0358\u035f\u0005\u0004\u0003\u0002\u0359\u035b\u0005\u0088E\u0002",
    "\u035a\u035c\u0005\u0004\u0003\u0002\u035b\u035a\u0003\u0002\u0002\u0002",
    "\u035b\u035c\u0003\u0002\u0002\u0002\u035c\u035e\u0003\u0002\u0002\u0002",
    "\u035d\u0359\u0003\u0002\u0002\u0002\u035e\u0361\u0003\u0002\u0002\u0002",
    "\u035f\u035d\u0003\u0002\u0002\u0002\u035f\u0360\u0003\u0002\u0002\u0002",
    "\u0360\u036b\u0003\u0002\u0002\u0002\u0361\u035f\u0003\u0002\u0002\u0002",
    "\u0362\u0364\u0005\u0088E\u0002\u0363\u0362\u0003\u0002\u0002\u0002",
    "\u0364\u0367\u0003\u0002\u0002\u0002\u0365\u0363\u0003\u0002\u0002\u0002",
    "\u0365\u0366\u0003\u0002\u0002\u0002\u0366\u0368\u0003\u0002\u0002\u0002",
    "\u0367\u0365\u0003\u0002\u0002\u0002\u0368\u036a\u0005\u008cG\u0002",
    "\u0369\u0365\u0003\u0002\u0002\u0002\u036a\u036d\u0003\u0002\u0002\u0002",
    "\u036b\u0369\u0003\u0002\u0002\u0002\u036b\u036c\u0003\u0002\u0002\u0002",
    "\u036c\u0371\u0003\u0002\u0002\u0002\u036d\u036b\u0003\u0002\u0002\u0002",
    "\u036e\u0370\u0005\u0088E\u0002\u036f\u036e\u0003\u0002\u0002\u0002",
    "\u0370\u0373\u0003\u0002\u0002\u0002\u0371\u036f\u0003\u0002\u0002\u0002",
    "\u0371\u0372\u0003\u0002\u0002\u0002\u0372\u0447\u0003\u0002\u0002\u0002",
    "\u0373\u0371\u0003\u0002\u0002\u0002\u0374\u0375\u0007\u0003\u0002\u0002",
    "\u0375\u0379\u00056\u001c\u0002\u0376\u0378\u0005\f\u0007\u0002\u0377",
    "\u0376\u0003\u0002\u0002\u0002\u0378\u037b\u0003\u0002\u0002\u0002\u0379",
    "\u0377\u0003\u0002\u0002\u0002\u0379\u037a\u0003\u0002\u0002\u0002\u037a",
    "\u037f\u0003\u0002\u0002\u0002\u037b\u0379\u0003\u0002\u0002\u0002\u037c",
    "\u037e\u0005\u0088E\u0002\u037d\u037c\u0003\u0002\u0002\u0002\u037e",
    "\u0381\u0003\u0002\u0002\u0002\u037f\u037d\u0003\u0002\u0002\u0002\u037f",
    "\u0380\u0003\u0002\u0002\u0002\u0380\u0388\u0003\u0002\u0002\u0002\u0381",
    "\u037f\u0003\u0002\u0002\u0002\u0382\u0384\u0005\u0004\u0003\u0002\u0383",
    "\u0382\u0003\u0002\u0002\u0002\u0383\u0384\u0003\u0002\u0002\u0002\u0384",
    "\u0385\u0003\u0002\u0002\u0002\u0385\u0387\u0005\u0088E\u0002\u0386",
    "\u0383\u0003\u0002\u0002\u0002\u0387\u038a\u0003\u0002\u0002\u0002\u0388",
    "\u0386\u0003\u0002\u0002\u0002\u0388\u0389\u0003\u0002\u0002\u0002\u0389",
    "\u038c\u0003\u0002\u0002\u0002\u038a\u0388\u0003\u0002\u0002\u0002\u038b",
    "\u038d\u0005\u0004\u0003\u0002\u038c\u038b\u0003\u0002\u0002\u0002\u038c",
    "\u038d\u0003\u0002\u0002\u0002\u038d\u038e\u0003\u0002\u0002\u0002\u038e",
    "\u0392\u0005\u008cG\u0002\u038f\u0391\u0005\u0088E\u0002\u0390\u038f",
    "\u0003\u0002\u0002\u0002\u0391\u0394\u0003\u0002\u0002\u0002\u0392\u0390",
    "\u0003\u0002\u0002\u0002\u0392\u0393\u0003\u0002\u0002\u0002\u0393\u0395",
    "\u0003\u0002\u0002\u0002\u0394\u0392\u0003\u0002\u0002\u0002\u0395\u039a",
    "\u0005\u008cG\u0002\u0396\u0399\u0005\u008cG\u0002\u0397\u0399\u0005",
    "\u0088E\u0002\u0398\u0396\u0003\u0002\u0002\u0002\u0398\u0397\u0003",
    "\u0002\u0002\u0002\u0399\u039c\u0003\u0002\u0002\u0002\u039a\u0398\u0003",
    "\u0002\u0002\u0002\u039a\u039b\u0003\u0002\u0002\u0002\u039b\u03a0\u0003",
    "\u0002\u0002\u0002\u039c\u039a\u0003\u0002\u0002\u0002\u039d\u039f\u0005",
    "\u0088E\u0002\u039e\u039d\u0003\u0002\u0002\u0002\u039f\u03a2\u0003",
    "\u0002\u0002\u0002\u03a0\u039e\u0003\u0002\u0002\u0002\u03a0\u03a1\u0003",
    "\u0002\u0002\u0002\u03a1\u0447\u0003\u0002\u0002\u0002\u03a2\u03a0\u0003",
    "\u0002\u0002\u0002\u03a3\u03a4\u0005\u008aF\u0002\u03a4\u03a8\u0005",
    "6\u001c\u0002\u03a5\u03a7\u0005\u0088E\u0002\u03a6\u03a5\u0003\u0002",
    "\u0002\u0002\u03a7\u03aa\u0003\u0002\u0002\u0002\u03a8\u03a6\u0003\u0002",
    "\u0002\u0002\u03a8\u03a9\u0003\u0002\u0002\u0002\u03a9\u03b4\u0003\u0002",
    "\u0002\u0002\u03aa\u03a8\u0003\u0002\u0002\u0002\u03ab\u03b1\u0005\f",
    "\u0007\u0002\u03ac\u03b0\u0005\f\u0007\u0002\u03ad\u03b0\u0007k\u0002",
    "\u0002\u03ae\u03b0\u0005\u0088E\u0002\u03af\u03ac\u0003\u0002\u0002",
    "\u0002\u03af\u03ad\u0003\u0002\u0002\u0002\u03af\u03ae\u0003\u0002\u0002",
    "\u0002\u03b0\u03b3\u0003\u0002\u0002\u0002\u03b1\u03af\u0003\u0002\u0002",
    "\u0002\u03b1\u03b2\u0003\u0002\u0002\u0002\u03b2\u03b5\u0003\u0002\u0002",
    "\u0002\u03b3\u03b1\u0003\u0002\u0002\u0002\u03b4\u03ab\u0003\u0002\u0002",
    "\u0002\u03b4\u03b5\u0003\u0002\u0002\u0002\u03b5\u03b9\u0003\u0002\u0002",
    "\u0002\u03b6\u03b8\u0005\u0088E\u0002\u03b7\u03b6\u0003\u0002\u0002",
    "\u0002\u03b8\u03bb\u0003\u0002\u0002\u0002\u03b9\u03b7\u0003\u0002\u0002",
    "\u0002\u03b9\u03ba\u0003\u0002\u0002\u0002\u03ba\u03c2\u0003\u0002\u0002",
    "\u0002\u03bb\u03b9\u0003\u0002\u0002\u0002\u03bc\u03be\u0005\u0004\u0003",
    "\u0002\u03bd\u03bc\u0003\u0002\u0002\u0002\u03bd\u03be\u0003\u0002\u0002",
    "\u0002\u03be\u03bf\u0003\u0002\u0002\u0002\u03bf\u03c1\u0005\u0088E",
    "\u0002\u03c0\u03bd\u0003\u0002\u0002\u0002\u03c1\u03c4\u0003\u0002\u0002",
    "\u0002\u03c2\u03c0\u0003\u0002\u0002\u0002\u03c2\u03c3\u0003\u0002\u0002",
    "\u0002\u03c3\u03c6\u0003\u0002\u0002\u0002\u03c4\u03c2\u0003\u0002\u0002",
    "\u0002\u03c5\u03c7\u0005\u0004\u0003\u0002\u03c6\u03c5\u0003\u0002\u0002",
    "\u0002\u03c6\u03c7\u0003\u0002\u0002\u0002\u03c7\u03d1\u0003\u0002\u0002",
    "\u0002\u03c8\u03ca\u0005\u0088E\u0002\u03c9\u03c8\u0003\u0002\u0002",
    "\u0002\u03ca\u03cd\u0003\u0002\u0002\u0002\u03cb\u03c9\u0003\u0002\u0002",
    "\u0002\u03cb\u03cc\u0003\u0002\u0002\u0002\u03cc\u03ce\u0003\u0002\u0002",
    "\u0002\u03cd\u03cb\u0003\u0002\u0002\u0002\u03ce\u03d0\u0005\u008cG",
    "\u0002\u03cf\u03cb\u0003\u0002\u0002\u0002\u03d0\u03d3\u0003\u0002\u0002",
    "\u0002\u03d1\u03cf\u0003\u0002\u0002\u0002\u03d1\u03d2\u0003\u0002\u0002",
    "\u0002\u03d2\u03d7\u0003\u0002\u0002\u0002\u03d3\u03d1\u0003\u0002\u0002",
    "\u0002\u03d4\u03d6\u0005\u0088E\u0002\u03d5\u03d4\u0003\u0002\u0002",
    "\u0002\u03d6\u03d9\u0003\u0002\u0002\u0002\u03d7\u03d5\u0003\u0002\u0002",
    "\u0002\u03d7\u03d8\u0003\u0002\u0002\u0002\u03d8\u0447\u0003\u0002\u0002",
    "\u0002\u03d9\u03d7\u0003\u0002\u0002\u0002\u03da\u03de\u00056\u001c",
    "\u0002\u03db\u03dd\u0005\u0088E\u0002\u03dc\u03db\u0003\u0002\u0002",
    "\u0002\u03dd\u03e0\u0003\u0002\u0002\u0002\u03de\u03dc\u0003\u0002\u0002",
    "\u0002\u03de\u03df\u0003\u0002\u0002\u0002\u03df\u03ea\u0003\u0002\u0002",
    "\u0002\u03e0\u03de\u0003\u0002\u0002\u0002\u03e1\u03e7\u0005\f\u0007",
    "\u0002\u03e2\u03e6\u0005\f\u0007\u0002\u03e3\u03e6\u0007k\u0002\u0002",
    "\u03e4\u03e6\u0005\u0088E\u0002\u03e5\u03e2\u0003\u0002\u0002\u0002",
    "\u03e5\u03e3\u0003\u0002\u0002\u0002\u03e5\u03e4\u0003\u0002\u0002\u0002",
    "\u03e6\u03e9\u0003\u0002\u0002\u0002\u03e7\u03e5\u0003\u0002\u0002\u0002",
    "\u03e7\u03e8\u0003\u0002\u0002\u0002\u03e8\u03eb\u0003\u0002\u0002\u0002",
    "\u03e9\u03e7\u0003\u0002\u0002\u0002\u03ea\u03e1\u0003\u0002\u0002\u0002",
    "\u03ea\u03eb\u0003\u0002\u0002\u0002\u03eb\u03ef\u0003\u0002\u0002\u0002",
    "\u03ec\u03ee\u0005\u0088E\u0002\u03ed\u03ec\u0003\u0002\u0002\u0002",
    "\u03ee\u03f1\u0003\u0002\u0002\u0002\u03ef\u03ed\u0003\u0002\u0002\u0002",
    "\u03ef\u03f0\u0003\u0002\u0002\u0002\u03f0\u03f8\u0003\u0002\u0002\u0002",
    "\u03f1\u03ef\u0003\u0002\u0002\u0002\u03f2\u03f4\u0005\u0004\u0003\u0002",
    "\u03f3\u03f2\u0003\u0002\u0002\u0002\u03f3\u03f4\u0003\u0002\u0002\u0002",
    "\u03f4\u03f5\u0003\u0002\u0002\u0002\u03f5\u03f7\u0005\u0088E\u0002",
    "\u03f6\u03f3\u0003\u0002\u0002\u0002\u03f7\u03fa\u0003\u0002\u0002\u0002",
    "\u03f8\u03f6\u0003\u0002\u0002\u0002\u03f8\u03f9\u0003\u0002\u0002\u0002",
    "\u03f9\u03fc\u0003\u0002\u0002\u0002\u03fa\u03f8\u0003\u0002\u0002\u0002",
    "\u03fb\u03fd\u0005\u0004\u0003\u0002\u03fc\u03fb\u0003\u0002\u0002\u0002",
    "\u03fc\u03fd\u0003\u0002\u0002\u0002\u03fd\u0407\u0003\u0002\u0002\u0002",
    "\u03fe\u0400\u0005\u0088E\u0002\u03ff\u03fe\u0003\u0002\u0002\u0002",
    "\u0400\u0403\u0003\u0002\u0002\u0002\u0401\u03ff\u0003\u0002\u0002\u0002",
    "\u0401\u0402\u0003\u0002\u0002\u0002\u0402\u0404\u0003\u0002\u0002\u0002",
    "\u0403\u0401\u0003\u0002\u0002\u0002\u0404\u0406\u0005\u008cG\u0002",
    "\u0405\u0401\u0003\u0002\u0002\u0002\u0406\u0409\u0003\u0002\u0002\u0002",
    "\u0407\u0405\u0003\u0002\u0002\u0002\u0407\u0408\u0003\u0002\u0002\u0002",
    "\u0408\u040d\u0003\u0002\u0002\u0002\u0409\u0407\u0003\u0002\u0002\u0002",
    "\u040a\u040c\u0005\u0088E\u0002\u040b\u040a\u0003\u0002\u0002\u0002",
    "\u040c\u040f\u0003\u0002\u0002\u0002\u040d\u040b\u0003\u0002\u0002\u0002",
    "\u040d\u040e\u0003\u0002\u0002\u0002\u040e\u0447\u0003\u0002\u0002\u0002",
    "\u040f\u040d\u0003\u0002\u0002\u0002\u0410\u0412\u0005\f\u0007\u0002",
    "\u0411\u0410\u0003\u0002\u0002\u0002\u0412\u0413\u0003\u0002\u0002\u0002",
    "\u0413\u0411\u0003\u0002\u0002\u0002\u0413\u0414\u0003\u0002\u0002\u0002",
    "\u0414\u0419\u0003\u0002\u0002\u0002\u0415\u0418\u0005\f\u0007\u0002",
    "\u0416\u0418\u0005\u0088E\u0002\u0417\u0415\u0003\u0002\u0002\u0002",
    "\u0417\u0416\u0003\u0002\u0002\u0002\u0418\u041b\u0003\u0002\u0002\u0002",
    "\u0419\u0417\u0003\u0002\u0002\u0002\u0419\u041a\u0003\u0002\u0002\u0002",
    "\u041a\u0424\u0003\u0002\u0002\u0002\u041b\u0419\u0003\u0002\u0002\u0002",
    "\u041c\u041e\u0005\u0004\u0003\u0002\u041d\u041f\u0005\u0088E\u0002",
    "\u041e\u041d\u0003\u0002\u0002\u0002\u041f\u0420\u0003\u0002\u0002\u0002",
    "\u0420\u041e\u0003\u0002\u0002\u0002\u0420\u0421\u0003\u0002\u0002\u0002",
    "\u0421\u0423\u0003\u0002\u0002\u0002\u0422\u041c\u0003\u0002\u0002\u0002",
    "\u0423\u0426\u0003\u0002\u0002\u0002\u0424\u0422\u0003\u0002\u0002\u0002",
    "\u0424\u0425\u0003\u0002\u0002\u0002\u0425\u0428\u0003\u0002\u0002\u0002",
    "\u0426\u0424\u0003\u0002\u0002\u0002\u0427\u0429\u0005\u0004\u0003\u0002",
    "\u0428\u0427\u0003\u0002\u0002\u0002\u0428\u0429\u0003\u0002\u0002\u0002",
    "\u0429\u042e\u0003\u0002\u0002\u0002\u042a\u042d\u0005\u008cG\u0002",
    "\u042b\u042d\u0005\u0088E\u0002\u042c\u042a\u0003\u0002\u0002\u0002",
    "\u042c\u042b\u0003\u0002\u0002\u0002\u042d\u0430\u0003\u0002\u0002\u0002",
    "\u042e\u042c\u0003\u0002\u0002\u0002\u042e\u042f\u0003\u0002\u0002\u0002",
    "\u042f\u0447\u0003\u0002\u0002\u0002\u0430\u042e\u0003\u0002\u0002\u0002",
    "\u0431\u043c\u0005\u0004\u0003\u0002\u0432\u0434\u0005\u0088E\u0002",
    "\u0433\u0432\u0003\u0002\u0002\u0002\u0434\u0435\u0003\u0002\u0002\u0002",
    "\u0435\u0433\u0003\u0002\u0002\u0002\u0435\u0436\u0003\u0002\u0002\u0002",
    "\u0436\u0438\u0003\u0002\u0002\u0002\u0437\u0439\u0005\u0004\u0003\u0002",
    "\u0438\u0437\u0003\u0002\u0002\u0002\u0438\u0439\u0003\u0002\u0002\u0002",
    "\u0439\u043b\u0003\u0002\u0002\u0002\u043a\u0433\u0003\u0002\u0002\u0002",
    "\u043b\u043e\u0003\u0002\u0002\u0002\u043c\u043a\u0003\u0002\u0002\u0002",
    "\u043c\u043d\u0003\u0002\u0002\u0002\u043d\u0443\u0003\u0002\u0002\u0002",
    "\u043e\u043c\u0003\u0002\u0002\u0002\u043f\u0442\u0005\u008cG\u0002",
    "\u0440\u0442\u0005\u0088E\u0002\u0441\u043f\u0003\u0002\u0002\u0002",
    "\u0441\u0440\u0003\u0002\u0002\u0002\u0442\u0445\u0003\u0002\u0002\u0002",
    "\u0443\u0441\u0003\u0002\u0002\u0002\u0443\u0444\u0003\u0002\u0002\u0002",
    "\u0444\u0447\u0003\u0002\u0002\u0002\u0445\u0443\u0003\u0002\u0002\u0002",
    "\u0446\u00d2\u0003\u0002\u0002\u0002\u0446\u00eb\u0003\u0002\u0002\u0002",
    "\u0446\u0133\u0003\u0002\u0002\u0002\u0446\u016a\u0003\u0002\u0002\u0002",
    "\u0446\u01a1\u0003\u0002\u0002\u0002\u0446\u01d8\u0003\u0002\u0002\u0002",
    "\u0446\u020f\u0003\u0002\u0002\u0002\u0446\u0247\u0003\u0002\u0002\u0002",
    "\u0446\u027b\u0003\u0002\u0002\u0002\u0446\u02b7\u0003\u0002\u0002\u0002",
    "\u0446\u02f3\u0003\u0002\u0002\u0002\u0446\u0314\u0003\u0002\u0002\u0002",
    "\u0446\u0350\u0003\u0002\u0002\u0002\u0446\u0374\u0003\u0002\u0002\u0002",
    "\u0446\u03a3\u0003\u0002\u0002\u0002\u0446\u03da\u0003\u0002\u0002\u0002",
    "\u0446\u0411\u0003\u0002\u0002\u0002\u0446\u0431\u0003\u0002\u0002\u0002",
    "\u0447\u000b\u0003\u0002\u0002\u0002\u0448\u044d\u0007i\u0002\u0002",
    "\u0449\u044a\u0007/\u0002\u0002\u044a\u044d\u0007k\u0002\u0002\u044b",
    "\u044d\u0007/\u0002\u0002\u044c\u0448\u0003\u0002\u0002\u0002\u044c",
    "\u0449\u0003\u0002\u0002\u0002\u044c\u044b\u0003\u0002\u0002\u0002\u044d",
    "\r\u0003\u0002\u0002\u0002\u044e\u044f\t\u0004\u0002\u0002\u044f\u000f",
    "\u0003\u0002\u0002\u0002\u0450\u045d\u0005^0\u0002\u0451\u045d\u0005",
    "`1\u0002\u0452\u045d\u0005b2\u0002\u0453\u045d\u0005d3\u0002\u0454\u045d",
    "\u0005f4\u0002\u0455\u045d\u0005h5\u0002\u0456\u045d\u0005j6\u0002\u0457",
    "\u045d\u0005l7\u0002\u0458\u045d\u0005n8\u0002\u0459\u045d\u0005p9\u0002",
    "\u045a\u045d\u0005r:\u0002\u045b\u045d\u0005t;\u0002\u045c\u0450\u0003",
    "\u0002\u0002\u0002\u045c\u0451\u0003\u0002\u0002\u0002\u045c\u0452\u0003",
    "\u0002\u0002\u0002\u045c\u0453\u0003\u0002\u0002\u0002\u045c\u0454\u0003",
    "\u0002\u0002\u0002\u045c\u0455\u0003\u0002\u0002\u0002\u045c\u0456\u0003",
    "\u0002\u0002\u0002\u045c\u0457\u0003\u0002\u0002\u0002\u045c\u0458\u0003",
    "\u0002\u0002\u0002\u045c\u0459\u0003\u0002\u0002\u0002\u045c\u045a\u0003",
    "\u0002\u0002\u0002\u045c\u045b\u0003\u0002\u0002\u0002\u045d\u0011\u0003",
    "\u0002\u0002\u0002\u045e\u045f\u0007\u0004\u0002\u0002\u045f\u0460\u0005",
    "\u001a\u000e\u0002\u0460\u0461\u0005\u0016\f\u0002\u0461\u046c\u0003",
    "\u0002\u0002\u0002\u0462\u0463\u0007\u0004\u0002\u0002\u0463\u046c\u0005",
    "\u0016\f\u0002\u0464\u0465\u0007\u0004\u0002\u0002\u0465\u0466\u0005",
    "\u001a\u000e\u0002\u0466\u0467\u0005\u0006\u0004\u0002\u0467\u046c\u0003",
    "\u0002\u0002\u0002\u0468\u0469\u0007\u0004\u0002\u0002\u0469\u046c\u0005",
    "\u001a\u000e\u0002\u046a\u046c\u0007\u0004\u0002\u0002\u046b\u045e\u0003",
    "\u0002\u0002\u0002\u046b\u0462\u0003\u0002\u0002\u0002\u046b\u0464\u0003",
    "\u0002\u0002\u0002\u046b\u0468\u0003\u0002\u0002\u0002\u046b\u046a\u0003",
    "\u0002\u0002\u0002\u046c\u0013\u0003\u0002\u0002\u0002\u046d\u046e\u0007",
    "\u001b\u0002\u0002\u046e\u046f\u0007A\u0002\u0002\u046f\u0470\u0005",
    "\u001a\u000e\u0002\u0470\u0471\u0007B\u0002\u0002\u0471\u0472\u0005",
    "\u0016\f\u0002\u0472\u0489\u0003\u0002\u0002\u0002\u0473\u0474\u0007",
    "\u001b\u0002\u0002\u0474\u0475\u0007A\u0002\u0002\u0475\u0476\u0005",
    "\u001a\u000e\u0002\u0476\u0477\u0007B\u0002\u0002\u0477\u0489\u0003",
    "\u0002\u0002\u0002\u0478\u0479\u0007\u001b\u0002\u0002\u0479\u047a\u0007",
    "A\u0002\u0002\u047a\u047b\u0005\u001a\u000e\u0002\u047b\u047c\u0007",
    "B\u0002\u0002\u047c\u047e\u0005\u0016\f\u0002\u047d\u047f\u0005\u0016",
    "\f\u0002\u047e\u047d\u0003\u0002\u0002\u0002\u047f\u0480\u0003\u0002",
    "\u0002\u0002\u0480\u047e\u0003\u0002\u0002\u0002\u0480\u0481\u0003\u0002",
    "\u0002\u0002\u0481\u0489\u0003\u0002\u0002\u0002\u0482\u0483\u0007\u001b",
    "\u0002\u0002\u0483\u0485\u0005\u001a\u000e\u0002\u0484\u0486\u0005\u0016",
    "\f\u0002\u0485\u0484\u0003\u0002\u0002\u0002\u0485\u0486\u0003\u0002",
    "\u0002\u0002\u0486\u0489\u0003\u0002\u0002\u0002\u0487\u0489\u0007\u001b",
    "\u0002\u0002\u0488\u046d\u0003\u0002\u0002\u0002\u0488\u0473\u0003\u0002",
    "\u0002\u0002\u0488\u0478\u0003\u0002\u0002\u0002\u0488\u0482\u0003\u0002",
    "\u0002\u0002\u0488\u0487\u0003\u0002\u0002\u0002\u0489\u0015\u0003\u0002",
    "\u0002\u0002\u048a\u048e\u0007A\u0002\u0002\u048b\u048d\u0005\u0088",
    "E\u0002\u048c\u048b\u0003\u0002\u0002\u0002\u048d\u0490\u0003\u0002",
    "\u0002\u0002\u048e\u048c\u0003\u0002\u0002\u0002\u048e\u048f\u0003\u0002",
    "\u0002\u0002\u048f\u0495\u0003\u0002\u0002\u0002\u0490\u048e\u0003\u0002",
    "\u0002\u0002\u0491\u0494\u0005\u0006\u0004\u0002\u0492\u0494\u0005\u0088",
    "E\u0002\u0493\u0491\u0003\u0002\u0002\u0002\u0493\u0492\u0003\u0002",
    "\u0002\u0002\u0494\u0497\u0003\u0002\u0002\u0002\u0495\u0493\u0003\u0002",
    "\u0002\u0002\u0495\u0496\u0003\u0002\u0002\u0002\u0496\u049b\u0003\u0002",
    "\u0002\u0002\u0497\u0495\u0003\u0002\u0002\u0002\u0498\u049a\u0005\u0088",
    "E\u0002\u0499\u0498\u0003\u0002\u0002\u0002\u049a\u049d\u0003\u0002",
    "\u0002\u0002\u049b\u0499\u0003\u0002\u0002\u0002\u049b\u049c\u0003\u0002",
    "\u0002\u0002\u049c\u049e\u0003\u0002\u0002\u0002\u049d\u049b\u0003\u0002",
    "\u0002\u0002\u049e\u049f\u0007B\u0002\u0002\u049f\u0017\u0003\u0002",
    "\u0002\u0002\u04a0\u04a1\u0007\u0018\u0002\u0002\u04a1\u04a2\u0005\u001a",
    "\u000e\u0002\u04a2\u04a3\u0005\u0016\f\u0002\u04a3\u04c0\u0003\u0002",
    "\u0002\u0002\u04a4\u04a5\u0007\u0018\u0002\u0002\u04a5\u04a6\u0005\u001a",
    "\u000e\u0002\u04a6\u04a7\u0005\u0016\f\u0002\u04a7\u04a8\u0005\u0016",
    "\f\u0002\u04a8\u04c0\u0003\u0002\u0002\u0002\u04a9\u04aa\u0007\u0018",
    "\u0002\u0002\u04aa\u04c0\u0005\u001a\u000e\u0002\u04ab\u04ac\u0007\u0018",
    "\u0002\u0002\u04ac\u04ad\u0005\u001a\u000e\u0002\u04ad\u04ae\u0005\u0016",
    "\f\u0002\u04ae\u04b0\u0005\u0016\f\u0002\u04af\u04b1\u0005\u0016\f\u0002",
    "\u04b0\u04af\u0003\u0002\u0002\u0002\u04b1\u04b2\u0003\u0002\u0002\u0002",
    "\u04b2\u04b0\u0003\u0002\u0002\u0002\u04b2\u04b3\u0003\u0002\u0002\u0002",
    "\u04b3\u04c0\u0003\u0002\u0002\u0002\u04b4\u04b5\u0007\u0018\u0002\u0002",
    "\u04b5\u04b6\u0007A\u0002\u0002\u04b6\u04b7\u0005\u001a\u000e\u0002",
    "\u04b7\u04bc\u0007B\u0002\u0002\u04b8\u04bd\u0005\u0016\f\u0002\u04b9",
    "\u04ba\u0005\u0016\f\u0002\u04ba\u04bb\u0005\u0016\f\u0002\u04bb\u04bd",
    "\u0003\u0002\u0002\u0002\u04bc\u04b8\u0003\u0002\u0002\u0002\u04bc\u04b9",
    "\u0003\u0002\u0002\u0002\u04bc\u04bd\u0003\u0002\u0002\u0002\u04bd\u04c0",
    "\u0003\u0002\u0002\u0002\u04be\u04c0\u0007\u0018\u0002\u0002\u04bf\u04a0",
    "\u0003\u0002\u0002\u0002\u04bf\u04a4\u0003\u0002\u0002\u0002\u04bf\u04a9",
    "\u0003\u0002\u0002\u0002\u04bf\u04ab\u0003\u0002\u0002\u0002\u04bf\u04b4",
    "\u0003\u0002\u0002\u0002\u04bf\u04be\u0003\u0002\u0002\u0002\u04c0\u0019",
    "\u0003\u0002\u0002\u0002\u04c1\u04c9\u0005\u0080A\u0002\u04c2\u04c6",
    "\u0005\u001e\u0010\u0002\u04c3\u04c4\u0005\u001c\u000f\u0002\u04c4\u04c5",
    "\u0005\u001e\u0010\u0002\u04c5\u04c7\u0003\u0002\u0002\u0002\u04c6\u04c3",
    "\u0003\u0002\u0002\u0002\u04c6\u04c7\u0003\u0002\u0002\u0002\u04c7\u04c9",
    "\u0003\u0002\u0002\u0002\u04c8\u04c1\u0003\u0002\u0002\u0002\u04c8\u04c2",
    "\u0003\u0002\u0002\u0002\u04c9\u001b\u0003\u0002\u0002\u0002\u04ca\u04cb",
    "\t\u0005\u0002\u0002\u04cb\u001d\u0003\u0002\u0002\u0002\u04cc\u04d1",
    "\u0005 \u0011\u0002\u04cd\u04ce\t\u0006\u0002\u0002\u04ce\u04d0\u0005",
    " \u0011\u0002\u04cf\u04cd\u0003\u0002\u0002\u0002\u04d0\u04d3\u0003",
    "\u0002\u0002\u0002\u04d1\u04cf\u0003\u0002\u0002\u0002\u04d1\u04d2\u0003",
    "\u0002\u0002\u0002\u04d2\u001f\u0003\u0002\u0002\u0002\u04d3\u04d1\u0003",
    "\u0002\u0002\u0002\u04d4\u04d9\u0005\"\u0012\u0002\u04d5\u04d6\t\u0007",
    "\u0002\u0002\u04d6\u04d8\u0005\"\u0012\u0002\u04d7\u04d5\u0003\u0002",
    "\u0002\u0002\u04d8\u04db\u0003\u0002\u0002\u0002\u04d9\u04d7\u0003\u0002",
    "\u0002\u0002\u04d9\u04da\u0003\u0002\u0002\u0002\u04da!\u0003\u0002",
    "\u0002\u0002\u04db\u04d9\u0003\u0002\u0002\u0002\u04dc\u04de\t\b\u0002",
    "\u0002\u04dd\u04dc\u0003\u0002\u0002\u0002\u04dd\u04de\u0003\u0002\u0002",
    "\u0002\u04de\u04df\u0003\u0002\u0002\u0002\u04df\u04e0\u0005$\u0013",
    "\u0002\u04e0#\u0003\u0002\u0002\u0002\u04e1\u04eb\u0005\u0080A\u0002",
    "\u04e2\u04eb\u0005(\u0015\u0002\u04e3\u04eb\u0005\u0010\t\u0002\u04e4",
    "\u04e5\u0007l\u0002\u0002\u04e5\u04e6\u0005\u001a\u000e\u0002\u04e6",
    "\u04e7\u0007m\u0002\u0002\u04e7\u04eb\u0003\u0002\u0002\u0002\u04e8",
    "\u04e9\u0007O\u0002\u0002\u04e9\u04eb\u0005\"\u0012\u0002\u04ea\u04e1",
    "\u0003\u0002\u0002\u0002\u04ea\u04e2\u0003\u0002\u0002\u0002\u04ea\u04e3",
    "\u0003\u0002\u0002\u0002\u04ea\u04e4\u0003\u0002\u0002\u0002\u04ea\u04e8",
    "\u0003\u0002\u0002\u0002\u04eb%\u0003\u0002\u0002\u0002\u04ec\u04f0",
    "\u0007j\u0002\u0002\u04ed\u04f0\u0005\u001a\u000e\u0002\u04ee\u04f0",
    "\u0005(\u0015\u0002\u04ef\u04ec\u0003\u0002\u0002\u0002\u04ef\u04ed",
    "\u0003\u0002\u0002\u0002\u04ef\u04ee\u0003\u0002\u0002\u0002\u04f0\'",
    "\u0003\u0002\u0002\u0002\u04f1\u04f9\u0007i\u0002\u0002\u04f2\u04f3",
    "\u0007/\u0002\u0002\u04f3\u04f9\u0007k\u0002\u0002\u04f4\u04f9\u0007",
    "/\u0002\u0002\u04f5\u04f6\u0007P\u0002\u0002\u04f6\u04f9\u0007k\u0002",
    "\u0002\u04f7\u04f9\u0007j\u0002\u0002\u04f8\u04f1\u0003\u0002\u0002",
    "\u0002\u04f8\u04f2\u0003\u0002\u0002\u0002\u04f8\u04f4\u0003\u0002\u0002",
    "\u0002\u04f8\u04f5\u0003\u0002\u0002\u0002\u04f8\u04f7\u0003\u0002\u0002",
    "\u0002\u04f9)\u0003\u0002\u0002\u0002\u04fa\u04fd\t\u0004\u0002\u0002",
    "\u04fb\u04fd\u0007k\u0002\u0002\u04fc\u04fa\u0003\u0002\u0002\u0002",
    "\u04fc\u04fb\u0003\u0002\u0002\u0002\u04fd+\u0003\u0002\u0002\u0002",
    "\u04fe\u04ff\u0007A\u0002\u0002\u04ff\u0500\u0005\u001a\u000e\u0002",
    "\u0500\u0501\u0005\u001a\u000e\u0002\u0501\u0505\u0005\u001a\u000e\u0002",
    "\u0502\u0504\u0005\u0088E\u0002\u0503\u0502\u0003\u0002\u0002\u0002",
    "\u0504\u0507\u0003\u0002\u0002\u0002\u0505\u0503\u0003\u0002\u0002\u0002",
    "\u0505\u0506\u0003\u0002\u0002\u0002\u0506\u0508\u0003\u0002\u0002\u0002",
    "\u0507\u0505\u0003\u0002\u0002\u0002\u0508\u0509\u0007B\u0002\u0002",
    "\u0509-\u0003\u0002\u0002\u0002\u050a\u050b\u0005\u001a\u000e\u0002",
    "\u050b/\u0003\u0002\u0002\u0002\u050c\u050d\u0007\u0017\u0002\u0002",
    "\u050d\u050e\u0007j\u0002\u0002\u050e\u053b\u0005&\u0014\u0002\u050f",
    "\u0510\u0007\u0017\u0002\u0002\u0510\u0511\u0007j\u0002\u0002\u0511",
    "\u0513\u0005&\u0014\u0002\u0512\u0514\u0005&\u0014\u0002\u0513\u0512",
    "\u0003\u0002\u0002\u0002\u0514\u0515\u0003\u0002\u0002\u0002\u0515\u0513",
    "\u0003\u0002\u0002\u0002\u0515\u0516\u0003\u0002\u0002\u0002\u0516\u053b",
    "\u0003\u0002\u0002\u0002\u0517\u0518\u0007\u0017\u0002\u0002\u0518\u053b",
    "\u0007j\u0002\u0002\u0519\u051a\u0007\u0017\u0002\u0002\u051a\u051e",
    "\u0005&\u0014\u0002\u051b\u051f\u0007j\u0002\u0002\u051c\u051d\u0007",
    "P\u0002\u0002\u051d\u051f\u0007k\u0002\u0002\u051e\u051b\u0003\u0002",
    "\u0002\u0002\u051e\u051c\u0003\u0002\u0002\u0002\u051f\u053b\u0003\u0002",
    "\u0002\u0002\u0520\u0524\u0007\u0017\u0002\u0002\u0521\u0525\u0007i",
    "\u0002\u0002\u0522\u0523\u0007/\u0002\u0002\u0523\u0525\u0007k\u0002",
    "\u0002\u0524\u0521\u0003\u0002\u0002\u0002\u0524\u0522\u0003\u0002\u0002",
    "\u0002\u0525\u0526\u0003\u0002\u0002\u0002\u0526\u053b\u0005&\u0014",
    "\u0002\u0527\u0528\u0007\u0017\u0002\u0002\u0528\u053b\u0005&\u0014",
    "\u0002\u0529\u052a\u0007\u0017\u0002\u0002\u052a\u052b\u0007P\u0002",
    "\u0002\u052b\u052c\u0007k\u0002\u0002\u052c\u053b\u0005&\u0014\u0002",
    "\u052d\u052e\u0007\u0017\u0002\u0002\u052e\u052f\u0007P\u0002\u0002",
    "\u052f\u0530\u0007k\u0002\u0002\u0530\u0532\u0005&\u0014\u0002\u0531",
    "\u0533\u0005&\u0014\u0002\u0532\u0531\u0003\u0002\u0002\u0002\u0533",
    "\u0534\u0003\u0002\u0002\u0002\u0534\u0532\u0003\u0002\u0002\u0002\u0534",
    "\u0535\u0003\u0002\u0002\u0002\u0535\u053b\u0003\u0002\u0002\u0002\u0536",
    "\u0537\u0007\u0017\u0002\u0002\u0537\u0538\u0007P\u0002\u0002\u0538",
    "\u053b\u0007k\u0002\u0002\u0539\u053b\u0007\u0017\u0002\u0002\u053a",
    "\u050c\u0003\u0002\u0002\u0002\u053a\u050f\u0003\u0002\u0002\u0002\u053a",
    "\u0517\u0003\u0002\u0002\u0002\u053a\u0519\u0003\u0002\u0002\u0002\u053a",
    "\u0520\u0003\u0002\u0002\u0002\u053a\u0527\u0003\u0002\u0002\u0002\u053a",
    "\u0529\u0003\u0002\u0002\u0002\u053a\u052d\u0003\u0002\u0002\u0002\u053a",
    "\u0536\u0003\u0002\u0002\u0002\u053a\u0539\u0003\u0002\u0002\u0002\u053b",
    "1\u0003\u0002\u0002\u0002\u053c\u053f\t\t\u0002\u0002\u053d\u0540\u0005",
    "&\u0014\u0002\u053e\u0540\u00054\u001b\u0002\u053f\u053d\u0003\u0002",
    "\u0002\u0002\u053f\u053e\u0003\u0002\u0002\u0002\u0540\u054e\u0003\u0002",
    "\u0002\u0002\u0541\u0544\t\t\u0002\u0002\u0542\u0545\u0005&\u0014\u0002",
    "\u0543\u0545\u00054\u001b\u0002\u0544\u0542\u0003\u0002\u0002\u0002",
    "\u0544\u0543\u0003\u0002\u0002\u0002\u0545\u0548\u0003\u0002\u0002\u0002",
    "\u0546\u0549\u0005&\u0014\u0002\u0547\u0549\u00054\u001b\u0002\u0548",
    "\u0546\u0003\u0002\u0002\u0002\u0548\u0547\u0003\u0002\u0002\u0002\u0549",
    "\u054a\u0003\u0002\u0002\u0002\u054a\u0548\u0003\u0002\u0002\u0002\u054a",
    "\u054b\u0003\u0002\u0002\u0002\u054b\u054e\u0003\u0002\u0002\u0002\u054c",
    "\u054e\t\t\u0002\u0002\u054d\u053c\u0003\u0002\u0002\u0002\u054d\u0541",
    "\u0003\u0002\u0002\u0002\u054d\u054c\u0003\u0002\u0002\u0002\u054e3",
    "\u0003\u0002\u0002\u0002\u054f\u0553\u0007A\u0002\u0002\u0550\u0552",
    "\n\n\u0002\u0002\u0551\u0550\u0003\u0002\u0002\u0002\u0552\u0555\u0003",
    "\u0002\u0002\u0002\u0553\u0551\u0003\u0002\u0002\u0002\u0553\u0554\u0003",
    "\u0002\u0002\u0002\u0554\u0556\u0003\u0002\u0002\u0002\u0555\u0553\u0003",
    "\u0002\u0002\u0002\u0556\u0557\u0007B\u0002\u0002\u05575\u0003\u0002",
    "\u0002\u0002\u0558\u0559\u0007k\u0002\u0002\u05597\u0003\u0002\u0002",
    "\u0002\u055a\u055b\t\u000b\u0002\u0002\u055b\u0565\u0005\u001a\u000e",
    "\u0002\u055c\u055d\t\u000b\u0002\u0002\u055d\u055f\u0005\u001a\u000e",
    "\u0002\u055e\u0560\u0005\u001a\u000e\u0002\u055f\u055e\u0003\u0002\u0002",
    "\u0002\u0560\u0561\u0003\u0002\u0002\u0002\u0561\u055f\u0003\u0002\u0002",
    "\u0002\u0561\u0562\u0003\u0002\u0002\u0002\u0562\u0565\u0003\u0002\u0002",
    "\u0002\u0563\u0565\t\u000b\u0002\u0002\u0564\u055a\u0003\u0002\u0002",
    "\u0002\u0564\u055c\u0003\u0002\u0002\u0002\u0564\u0563\u0003\u0002\u0002",
    "\u0002\u05659\u0003\u0002\u0002\u0002\u0566\u0567\t\f\u0002\u0002\u0567",
    "\u0571\u0005\u001a\u000e\u0002\u0568\u0569\t\f\u0002\u0002\u0569\u056b",
    "\u0005\u001a\u000e\u0002\u056a\u056c\u0005\u001a\u000e\u0002\u056b\u056a",
    "\u0003\u0002\u0002\u0002\u056c\u056d\u0003\u0002\u0002\u0002\u056d\u056b",
    "\u0003\u0002\u0002\u0002\u056d\u056e\u0003\u0002\u0002\u0002\u056e\u0571",
    "\u0003\u0002\u0002\u0002\u056f\u0571\t\f\u0002\u0002\u0570\u0566\u0003",
    "\u0002\u0002\u0002\u0570\u0568\u0003\u0002\u0002\u0002\u0570\u056f\u0003",
    "\u0002\u0002\u0002\u0571;\u0003\u0002\u0002\u0002\u0572\u0573\t\r\u0002",
    "\u0002\u0573\u057d\u0005\u001a\u000e\u0002\u0574\u0575\t\r\u0002\u0002",
    "\u0575\u0577\u0005\u001a\u000e\u0002\u0576\u0578\u0005\u001a\u000e\u0002",
    "\u0577\u0576\u0003\u0002\u0002\u0002\u0578\u0579\u0003\u0002\u0002\u0002",
    "\u0579\u0577\u0003\u0002\u0002\u0002\u0579\u057a\u0003\u0002\u0002\u0002",
    "\u057a\u057d\u0003\u0002\u0002\u0002\u057b\u057d\t\r\u0002\u0002\u057c",
    "\u0572\u0003\u0002\u0002\u0002\u057c\u0574\u0003\u0002\u0002\u0002\u057c",
    "\u057b\u0003\u0002\u0002\u0002\u057d=\u0003\u0002\u0002\u0002\u057e",
    "\u057f\t\u000e\u0002\u0002\u057f\u0589\u0005\u001a\u000e\u0002\u0580",
    "\u0581\t\u000e\u0002\u0002\u0581\u0583\u0005\u001a\u000e\u0002\u0582",
    "\u0584\u0005\u001a\u000e\u0002\u0583\u0582\u0003\u0002\u0002\u0002\u0584",
    "\u0585\u0003\u0002\u0002\u0002\u0585\u0583\u0003\u0002\u0002\u0002\u0585",
    "\u0586\u0003\u0002\u0002\u0002\u0586\u0589\u0003\u0002\u0002\u0002\u0587",
    "\u0589\t\u000e\u0002\u0002\u0588\u057e\u0003\u0002\u0002\u0002\u0588",
    "\u0580\u0003\u0002\u0002\u0002\u0588\u0587\u0003\u0002\u0002\u0002\u0589",
    "?\u0003\u0002\u0002\u0002\u058a\u0592\t\u000f\u0002\u0002\u058b\u058d",
    "\t\u000f\u0002\u0002\u058c\u058e\u0005\u001a\u000e\u0002\u058d\u058c",
    "\u0003\u0002\u0002\u0002\u058e\u058f\u0003\u0002\u0002\u0002\u058f\u058d",
    "\u0003\u0002\u0002\u0002\u058f\u0590\u0003\u0002\u0002\u0002\u0590\u0592",
    "\u0003\u0002\u0002\u0002\u0591\u058a\u0003\u0002\u0002\u0002\u0591\u058b",
    "\u0003\u0002\u0002\u0002\u0592A\u0003\u0002\u0002\u0002\u0593\u059b",
    "\u0007\n\u0002\u0002\u0594\u0596\u0007\n\u0002\u0002\u0595\u0597\u0005",
    "\u001a\u000e\u0002\u0596\u0595\u0003\u0002\u0002\u0002\u0597\u0598\u0003",
    "\u0002\u0002\u0002\u0598\u0596\u0003\u0002\u0002\u0002\u0598\u0599\u0003",
    "\u0002\u0002\u0002\u0599\u059b\u0003\u0002\u0002\u0002\u059a\u0593\u0003",
    "\u0002\u0002\u0002\u059a\u0594\u0003\u0002\u0002\u0002\u059bC\u0003",
    "\u0002\u0002\u0002\u059c\u05a4\t\u0010\u0002\u0002\u059d\u059f\t\u0010",
    "\u0002\u0002\u059e\u05a0\u0005\u001a\u000e\u0002\u059f\u059e\u0003\u0002",
    "\u0002\u0002\u05a0\u05a1\u0003\u0002\u0002\u0002\u05a1\u059f\u0003\u0002",
    "\u0002\u0002\u05a1\u05a2\u0003\u0002\u0002\u0002\u05a2\u05a4\u0003\u0002",
    "\u0002\u0002\u05a3\u059c\u0003\u0002\u0002\u0002\u05a3\u059d\u0003\u0002",
    "\u0002\u0002\u05a4E\u0003\u0002\u0002\u0002\u05a5\u05ad\t\u0011\u0002",
    "\u0002\u05a6\u05a8\t\u0011\u0002\u0002\u05a7\u05a9\u0005\u001a\u000e",
    "\u0002\u05a8\u05a7\u0003\u0002\u0002\u0002\u05a9\u05aa\u0003\u0002\u0002",
    "\u0002\u05aa\u05a8\u0003\u0002\u0002\u0002\u05aa\u05ab\u0003\u0002\u0002",
    "\u0002\u05ab\u05ad\u0003\u0002\u0002\u0002\u05ac\u05a5\u0003\u0002\u0002",
    "\u0002\u05ac\u05a6\u0003\u0002\u0002\u0002\u05adG\u0003\u0002\u0002",
    "\u0002\u05ae\u05b6\t\u0012\u0002\u0002\u05af\u05b1\t\u0012\u0002\u0002",
    "\u05b0\u05b2\u0005\u001a\u000e\u0002\u05b1\u05b0\u0003\u0002\u0002\u0002",
    "\u05b2\u05b3\u0003\u0002\u0002\u0002\u05b3\u05b1\u0003\u0002\u0002\u0002",
    "\u05b3\u05b4\u0003\u0002\u0002\u0002\u05b4\u05b6\u0003\u0002\u0002\u0002",
    "\u05b5\u05ae\u0003\u0002\u0002\u0002\u05b5\u05af\u0003\u0002\u0002\u0002",
    "\u05b6I\u0003\u0002\u0002\u0002\u05b7\u05bf\t\u0013\u0002\u0002\u05b8",
    "\u05ba\t\u0013\u0002\u0002\u05b9\u05bb\u0005\u001a\u000e\u0002\u05ba",
    "\u05b9\u0003\u0002\u0002\u0002\u05bb\u05bc\u0003\u0002\u0002\u0002\u05bc",
    "\u05ba\u0003\u0002\u0002\u0002\u05bc\u05bd\u0003\u0002\u0002\u0002\u05bd",
    "\u05bf\u0003\u0002\u0002\u0002\u05be\u05b7\u0003\u0002\u0002\u0002\u05be",
    "\u05b8\u0003\u0002\u0002\u0002\u05bfK\u0003\u0002\u0002\u0002\u05c0",
    "\u05c8\t\u0014\u0002\u0002\u05c1\u05c3\t\u0014\u0002\u0002\u05c2\u05c4",
    "\u0005\u001a\u000e\u0002\u05c3\u05c2\u0003\u0002\u0002\u0002\u05c4\u05c5",
    "\u0003\u0002\u0002\u0002\u05c5\u05c3\u0003\u0002\u0002\u0002\u05c5\u05c6",
    "\u0003\u0002\u0002\u0002\u05c6\u05c8\u0003\u0002\u0002\u0002\u05c7\u05c0",
    "\u0003\u0002\u0002\u0002\u05c7\u05c1\u0003\u0002\u0002\u0002\u05c8M",
    "\u0003\u0002\u0002\u0002\u05c9\u05d1\t\u0015\u0002\u0002\u05ca\u05cc",
    "\t\u0015\u0002\u0002\u05cb\u05cd\u0005\u001a\u000e\u0002\u05cc\u05cb",
    "\u0003\u0002\u0002\u0002\u05cd\u05ce\u0003\u0002\u0002\u0002\u05ce\u05cc",
    "\u0003\u0002\u0002\u0002\u05ce\u05cf\u0003\u0002\u0002\u0002\u05cf\u05d1",
    "\u0003\u0002\u0002\u0002\u05d0\u05c9\u0003\u0002\u0002\u0002\u05d0\u05ca",
    "\u0003\u0002\u0002\u0002\u05d1O\u0003\u0002\u0002\u0002\u05d2\u05d6",
    "\t\u0016\u0002\u0002\u05d3\u05d7\u0005.\u0018\u0002\u05d4\u05d7\u0005",
    ",\u0017\u0002\u05d5\u05d7\u0005*\u0016\u0002\u05d6\u05d3\u0003\u0002",
    "\u0002\u0002\u05d6\u05d4\u0003\u0002\u0002\u0002\u05d6\u05d5\u0003\u0002",
    "\u0002\u0002\u05d7\u05e7\u0003\u0002\u0002\u0002\u05d8\u05dc\t\u0016",
    "\u0002\u0002\u05d9\u05dd\u0005.\u0018\u0002\u05da\u05dd\u0005,\u0017",
    "\u0002\u05db\u05dd\u0005*\u0016\u0002\u05dc\u05d9\u0003\u0002\u0002",
    "\u0002\u05dc\u05da\u0003\u0002\u0002\u0002\u05dc\u05db\u0003\u0002\u0002",
    "\u0002\u05dd\u05e1\u0003\u0002\u0002\u0002\u05de\u05e2\u0005.\u0018",
    "\u0002\u05df\u05e2\u0005,\u0017\u0002\u05e0\u05e2\u0005*\u0016\u0002",
    "\u05e1\u05de\u0003\u0002\u0002\u0002\u05e1\u05df\u0003\u0002\u0002\u0002",
    "\u05e1\u05e0\u0003\u0002\u0002\u0002\u05e2\u05e3\u0003\u0002\u0002\u0002",
    "\u05e3\u05e1\u0003\u0002\u0002\u0002\u05e3\u05e4\u0003\u0002\u0002\u0002",
    "\u05e4\u05e7\u0003\u0002\u0002\u0002\u05e5\u05e7\t\u0016\u0002\u0002",
    "\u05e6\u05d2\u0003\u0002\u0002\u0002\u05e6\u05d8\u0003\u0002\u0002\u0002",
    "\u05e6\u05e5\u0003\u0002\u0002\u0002\u05e7Q\u0003\u0002\u0002\u0002",
    "\u05e8\u05ec\t\u0017\u0002\u0002\u05e9\u05ed\u0005.\u0018\u0002\u05ea",
    "\u05ed\u0005,\u0017\u0002\u05eb\u05ed\u0005*\u0016\u0002\u05ec\u05e9",
    "\u0003\u0002\u0002\u0002\u05ec\u05ea\u0003\u0002\u0002\u0002\u05ec\u05eb",
    "\u0003\u0002\u0002\u0002\u05ed\u05fd\u0003\u0002\u0002\u0002\u05ee\u05f2",
    "\t\u0017\u0002\u0002\u05ef\u05f3\u0005.\u0018\u0002\u05f0\u05f3\u0005",
    ",\u0017\u0002\u05f1\u05f3\u0005*\u0016\u0002\u05f2\u05ef\u0003\u0002",
    "\u0002\u0002\u05f2\u05f0\u0003\u0002\u0002\u0002\u05f2\u05f1\u0003\u0002",
    "\u0002\u0002\u05f3\u05f7\u0003\u0002\u0002\u0002\u05f4\u05f8\u0005.",
    "\u0018\u0002\u05f5\u05f8\u0005,\u0017\u0002\u05f6\u05f8\u0005*\u0016",
    "\u0002\u05f7\u05f4\u0003\u0002\u0002\u0002\u05f7\u05f5\u0003\u0002\u0002",
    "\u0002\u05f7\u05f6\u0003\u0002\u0002\u0002\u05f8\u05f9\u0003\u0002\u0002",
    "\u0002\u05f9\u05f7\u0003\u0002\u0002\u0002\u05f9\u05fa\u0003\u0002\u0002",
    "\u0002\u05fa\u05fd\u0003\u0002\u0002\u0002\u05fb\u05fd\t\u0017\u0002",
    "\u0002\u05fc\u05e8\u0003\u0002\u0002\u0002\u05fc\u05ee\u0003\u0002\u0002",
    "\u0002\u05fc\u05fb\u0003\u0002\u0002\u0002\u05fdS\u0003\u0002\u0002",
    "\u0002\u05fe\u0606\u0007\u0011\u0002\u0002\u05ff\u0601\u0007\u0011\u0002",
    "\u0002\u0600\u0602\u0005\u001a\u000e\u0002\u0601\u0600\u0003\u0002\u0002",
    "\u0002\u0602\u0603\u0003\u0002\u0002\u0002\u0603\u0601\u0003\u0002\u0002",
    "\u0002\u0603\u0604\u0003\u0002\u0002\u0002\u0604\u0606\u0003\u0002\u0002",
    "\u0002\u0605\u05fe\u0003\u0002\u0002\u0002\u0605\u05ff\u0003\u0002\u0002",
    "\u0002\u0606U\u0003\u0002\u0002\u0002\u0607\u060f\u0007\u0019\u0002",
    "\u0002\u0608\u060a\u0007\u0019\u0002\u0002\u0609\u060b\u0005\u001a\u000e",
    "\u0002\u060a\u0609\u0003\u0002\u0002\u0002\u060b\u060c\u0003\u0002\u0002",
    "\u0002\u060c\u060a\u0003\u0002\u0002\u0002\u060c\u060d\u0003\u0002\u0002",
    "\u0002\u060d\u060f\u0003\u0002\u0002\u0002\u060e\u0607\u0003\u0002\u0002",
    "\u0002\u060e\u0608\u0003\u0002\u0002\u0002\u060fW\u0003\u0002\u0002",
    "\u0002\u0610\u0611\u0007\u0014\u0002\u0002\u0611\u0612\u0005\u001a\u000e",
    "\u0002\u0612\u0613\u0005\u001a\u000e\u0002\u0613\u0620\u0003\u0002\u0002",
    "\u0002\u0614\u0615\u0007\u0014\u0002\u0002\u0615\u0620\u0005\u001a\u000e",
    "\u0002\u0616\u0617\u0007\u0014\u0002\u0002\u0617\u0618\u0005\u001a\u000e",
    "\u0002\u0618\u061a\u0005\u001a\u000e\u0002\u0619\u061b\u0005\u001a\u000e",
    "\u0002\u061a\u0619\u0003\u0002\u0002\u0002\u061b\u061c\u0003\u0002\u0002",
    "\u0002\u061c\u061a\u0003\u0002\u0002\u0002\u061c\u061d\u0003\u0002\u0002",
    "\u0002\u061d\u0620\u0003\u0002\u0002\u0002\u061e\u0620\u0007\u0014\u0002",
    "\u0002\u061f\u0610\u0003\u0002\u0002\u0002\u061f\u0614\u0003\u0002\u0002",
    "\u0002\u061f\u0616\u0003\u0002\u0002\u0002\u061f\u061e\u0003\u0002\u0002",
    "\u0002\u0620Y\u0003\u0002\u0002\u0002\u0621\u0622\u0007\u0012\u0002",
    "\u0002\u0622\u062c\u0005\u001a\u000e\u0002\u0623\u0624\u0007\u0012\u0002",
    "\u0002\u0624\u0626\u0005\u001a\u000e\u0002\u0625\u0627\u0005\u001a\u000e",
    "\u0002\u0626\u0625\u0003\u0002\u0002\u0002\u0627\u0628\u0003\u0002\u0002",
    "\u0002\u0628\u0626\u0003\u0002\u0002\u0002\u0628\u0629\u0003\u0002\u0002",
    "\u0002\u0629\u062c\u0003\u0002\u0002\u0002\u062a\u062c\u0007\u0012\u0002",
    "\u0002\u062b\u0621\u0003\u0002\u0002\u0002\u062b\u0623\u0003\u0002\u0002",
    "\u0002\u062b\u062a\u0003\u0002\u0002\u0002\u062c[\u0003\u0002\u0002",
    "\u0002\u062d\u062e\u0007\u0013\u0002\u0002\u062e\u0638\u0005\u001a\u000e",
    "\u0002\u062f\u0630\u0007\u0013\u0002\u0002\u0630\u0632\u0005\u001a\u000e",
    "\u0002\u0631\u0633\u0005\u001a\u000e\u0002\u0632\u0631\u0003\u0002\u0002",
    "\u0002\u0633\u0634\u0003\u0002\u0002\u0002\u0634\u0632\u0003\u0002\u0002",
    "\u0002\u0634\u0635\u0003\u0002\u0002\u0002\u0635\u0638\u0003\u0002\u0002",
    "\u0002\u0636\u0638\u0007\u0013\u0002\u0002\u0637\u062d\u0003\u0002\u0002",
    "\u0002\u0637\u062f\u0003\u0002\u0002\u0002\u0637\u0636\u0003\u0002\u0002",
    "\u0002\u0638]\u0003\u0002\u0002\u0002\u0639\u063a\t\u0018\u0002\u0002",
    "\u063a\u0644\u0005\u001a\u000e\u0002\u063b\u063c\t\u0018\u0002\u0002",
    "\u063c\u063e\u0005\u001a\u000e\u0002\u063d\u063f\u0005\u001a\u000e\u0002",
    "\u063e\u063d\u0003\u0002\u0002\u0002\u063f\u0640\u0003\u0002\u0002\u0002",
    "\u0640\u063e\u0003\u0002\u0002\u0002\u0640\u0641\u0003\u0002\u0002\u0002",
    "\u0641\u0644\u0003\u0002\u0002\u0002\u0642\u0644\t\u0018\u0002\u0002",
    "\u0643\u0639\u0003\u0002\u0002\u0002\u0643\u063b\u0003\u0002\u0002\u0002",
    "\u0643\u0642\u0003\u0002\u0002\u0002\u0644_\u0003\u0002\u0002\u0002",
    "\u0645\u0646\u0007\"\u0002\u0002\u0646\u0650\u0005\u001a\u000e\u0002",
    "\u0647\u0648\u0007\"\u0002\u0002\u0648\u064a\u0005\u001a\u000e\u0002",
    "\u0649\u064b\u0005\u001a\u000e\u0002\u064a\u0649\u0003\u0002\u0002\u0002",
    "\u064b\u064c\u0003\u0002\u0002\u0002\u064c\u064a\u0003\u0002\u0002\u0002",
    "\u064c\u064d\u0003\u0002\u0002\u0002\u064d\u0650\u0003\u0002\u0002\u0002",
    "\u064e\u0650\u0007\"\u0002\u0002\u064f\u0645\u0003\u0002\u0002\u0002",
    "\u064f\u0647\u0003\u0002\u0002\u0002\u064f\u064e\u0003\u0002\u0002\u0002",
    "\u0650a\u0003\u0002\u0002\u0002\u0651\u0652\u0007#\u0002\u0002\u0652",
    "\u065c\u0005\u001a\u000e\u0002\u0653\u0654\u0007#\u0002\u0002\u0654",
    "\u0656\u0005\u001a\u000e\u0002\u0655\u0657\u0005\u001a\u000e\u0002\u0656",
    "\u0655\u0003\u0002\u0002\u0002\u0657\u0658\u0003\u0002\u0002\u0002\u0658",
    "\u0656\u0003\u0002\u0002\u0002\u0658\u0659\u0003\u0002\u0002\u0002\u0659",
    "\u065c\u0003\u0002\u0002\u0002\u065a\u065c\u0007#\u0002\u0002\u065b",
    "\u0651\u0003\u0002\u0002\u0002\u065b\u0653\u0003\u0002\u0002\u0002\u065b",
    "\u065a\u0003\u0002\u0002\u0002\u065cc\u0003\u0002\u0002\u0002\u065d",
    "\u065e\u0007$\u0002\u0002\u065e\u0668\u0005\u001a\u000e\u0002\u065f",
    "\u0660\u0007$\u0002\u0002\u0660\u0662\u0005\u001a\u000e\u0002\u0661",
    "\u0663\u0005\u001a\u000e\u0002\u0662\u0661\u0003\u0002\u0002\u0002\u0663",
    "\u0664\u0003\u0002\u0002\u0002\u0664\u0662\u0003\u0002\u0002\u0002\u0664",
    "\u0665\u0003\u0002\u0002\u0002\u0665\u0668\u0003\u0002\u0002\u0002\u0666",
    "\u0668\u0007$\u0002\u0002\u0667\u065d\u0003\u0002\u0002\u0002\u0667",
    "\u065f\u0003\u0002\u0002\u0002\u0667\u0666\u0003\u0002\u0002\u0002\u0668",
    "e\u0003\u0002\u0002\u0002\u0669\u066a\t\u0019\u0002\u0002\u066a\u0674",
    "\u0005\u001a\u000e\u0002\u066b\u066c\t\u0019\u0002\u0002\u066c\u066e",
    "\u0005\u001a\u000e\u0002\u066d\u066f\u0005\u001a\u000e\u0002\u066e\u066d",
    "\u0003\u0002\u0002\u0002\u066f\u0670\u0003\u0002\u0002\u0002\u0670\u066e",
    "\u0003\u0002\u0002\u0002\u0670\u0671\u0003\u0002\u0002\u0002\u0671\u0674",
    "\u0003\u0002\u0002\u0002\u0672\u0674\t\u0019\u0002\u0002\u0673\u0669",
    "\u0003\u0002\u0002\u0002\u0673\u066b\u0003\u0002\u0002\u0002\u0673\u0672",
    "\u0003\u0002\u0002\u0002\u0674g\u0003\u0002\u0002\u0002\u0675\u0676",
    "\t\u001a\u0002\u0002\u0676\u0680\u0005\u001a\u000e\u0002\u0677\u0678",
    "\t\u001a\u0002\u0002\u0678\u067a\u0005\u001a\u000e\u0002\u0679\u067b",
    "\u0005\u001a\u000e\u0002\u067a\u0679\u0003\u0002\u0002\u0002\u067b\u067c",
    "\u0003\u0002\u0002\u0002\u067c\u067a\u0003\u0002\u0002\u0002\u067c\u067d",
    "\u0003\u0002\u0002\u0002\u067d\u0680\u0003\u0002\u0002\u0002\u067e\u0680",
    "\t\u001a\u0002\u0002\u067f\u0675\u0003\u0002\u0002\u0002\u067f\u0677",
    "\u0003\u0002\u0002\u0002\u067f\u067e\u0003\u0002\u0002\u0002\u0680i",
    "\u0003\u0002\u0002\u0002\u0681\u0682\t\u001b\u0002\u0002\u0682\u068c",
    "\u0005\u001a\u000e\u0002\u0683\u0684\t\u001b\u0002\u0002\u0684\u0686",
    "\u0005\u001a\u000e\u0002\u0685\u0687\u0005\u001a\u000e\u0002\u0686\u0685",
    "\u0003\u0002\u0002\u0002\u0687\u0688\u0003\u0002\u0002\u0002\u0688\u0686",
    "\u0003\u0002\u0002\u0002\u0688\u0689\u0003\u0002\u0002\u0002\u0689\u068c",
    "\u0003\u0002\u0002\u0002\u068a\u068c\t\u001b\u0002\u0002\u068b\u0681",
    "\u0003\u0002\u0002\u0002\u068b\u0683\u0003\u0002\u0002\u0002\u068b\u068a",
    "\u0003\u0002\u0002\u0002\u068ck\u0003\u0002\u0002\u0002\u068d\u068e",
    "\u0007(\u0002\u0002\u068e\u0698\u0005\u001a\u000e\u0002\u068f\u0690",
    "\u0007(\u0002\u0002\u0690\u0692\u0005\u001a\u000e\u0002\u0691\u0693",
    "\u0005\u001a\u000e\u0002\u0692\u0691\u0003\u0002\u0002\u0002\u0693\u0694",
    "\u0003\u0002\u0002\u0002\u0694\u0692\u0003\u0002\u0002\u0002\u0694\u0695",
    "\u0003\u0002\u0002\u0002\u0695\u0698\u0003\u0002\u0002\u0002\u0696\u0698",
    "\u0007(\u0002\u0002\u0697\u068d\u0003\u0002\u0002\u0002\u0697\u068f",
    "\u0003\u0002\u0002\u0002\u0697\u0696\u0003\u0002\u0002\u0002\u0698m",
    "\u0003\u0002\u0002\u0002\u0699\u069a\u0007)\u0002\u0002\u069a\u06a4",
    "\u0005\u001a\u000e\u0002\u069b\u069c\u0007)\u0002\u0002\u069c\u069e",
    "\u0005\u001a\u000e\u0002\u069d\u069f\u0005\u001a\u000e\u0002\u069e\u069d",
    "\u0003\u0002\u0002\u0002\u069f\u06a0\u0003\u0002\u0002\u0002\u06a0\u069e",
    "\u0003\u0002\u0002\u0002\u06a0\u06a1\u0003\u0002\u0002\u0002\u06a1\u06a4",
    "\u0003\u0002\u0002\u0002\u06a2\u06a4\u0007)\u0002\u0002\u06a3\u0699",
    "\u0003\u0002\u0002\u0002\u06a3\u069b\u0003\u0002\u0002\u0002\u06a3\u06a2",
    "\u0003\u0002\u0002\u0002\u06a4o\u0003\u0002\u0002\u0002\u06a5\u06a6",
    "\u0007*\u0002\u0002\u06a6\u06a7\u0005\u001a\u000e\u0002\u06a7\u06a8",
    "\u0005\u001a\u000e\u0002\u06a8\u06b5\u0003\u0002\u0002\u0002\u06a9\u06aa",
    "\u0007*\u0002\u0002\u06aa\u06ab\u0005\u001a\u000e\u0002\u06ab\u06ad",
    "\u0005\u001a\u000e\u0002\u06ac\u06ae\u0005\u001a\u000e\u0002\u06ad\u06ac",
    "\u0003\u0002\u0002\u0002\u06ae\u06af\u0003\u0002\u0002\u0002\u06af\u06ad",
    "\u0003\u0002\u0002\u0002\u06af\u06b0\u0003\u0002\u0002\u0002\u06b0\u06b5",
    "\u0003\u0002\u0002\u0002\u06b1\u06b2\u0007*\u0002\u0002\u06b2\u06b5",
    "\u0005\u001a\u000e\u0002\u06b3\u06b5\u0007*\u0002\u0002\u06b4\u06a5",
    "\u0003\u0002\u0002\u0002\u06b4\u06a9\u0003\u0002\u0002\u0002\u06b4\u06b1",
    "\u0003\u0002\u0002\u0002\u06b4\u06b3\u0003\u0002\u0002\u0002\u06b5q",
    "\u0003\u0002\u0002\u0002\u06b6\u06b7\u0007+\u0002\u0002\u06b7\u06b8",
    "\u0005\u001a\u000e\u0002\u06b8\u06b9\u0005\u001a\u000e\u0002\u06b9\u06c6",
    "\u0003\u0002\u0002\u0002\u06ba\u06bb\u0007+\u0002\u0002\u06bb\u06bc",
    "\u0005\u001a\u000e\u0002\u06bc\u06be\u0005\u001a\u000e\u0002\u06bd\u06bf",
    "\u0005\u001a\u000e\u0002\u06be\u06bd\u0003\u0002\u0002\u0002\u06bf\u06c0",
    "\u0003\u0002\u0002\u0002\u06c0\u06be\u0003\u0002\u0002\u0002\u06c0\u06c1",
    "\u0003\u0002\u0002\u0002\u06c1\u06c6\u0003\u0002\u0002\u0002\u06c2\u06c3",
    "\u0007+\u0002\u0002\u06c3\u06c6\u0005\u001a\u000e\u0002\u06c4\u06c6",
    "\u0007+\u0002\u0002\u06c5\u06b6\u0003\u0002\u0002\u0002\u06c5\u06ba",
    "\u0003\u0002\u0002\u0002\u06c5\u06c2\u0003\u0002\u0002\u0002\u06c5\u06c4",
    "\u0003\u0002\u0002\u0002\u06c6s\u0003\u0002\u0002\u0002\u06c7\u06c8",
    "\t\u001c\u0002\u0002\u06c8\u06d2\u0005\u001a\u000e\u0002\u06c9\u06ca",
    "\t\u001c\u0002\u0002\u06ca\u06cc\u0005\u001a\u000e\u0002\u06cb\u06cd",
    "\u0005\u001a\u000e\u0002\u06cc\u06cb\u0003\u0002\u0002\u0002\u06cd\u06ce",
    "\u0003\u0002\u0002\u0002\u06ce\u06cc\u0003\u0002\u0002\u0002\u06ce\u06cf",
    "\u0003\u0002\u0002\u0002\u06cf\u06d2\u0003\u0002\u0002\u0002\u06d0\u06d2",
    "\t\u001c\u0002\u0002\u06d1\u06c7\u0003\u0002\u0002\u0002\u06d1\u06c9",
    "\u0003\u0002\u0002\u0002\u06d1\u06d0\u0003\u0002\u0002\u0002\u06d2u",
    "\u0003\u0002\u0002\u0002\u06d3\u06d4\u0007\u001a\u0002\u0002\u06d4\u06de",
    "\u0005\u001a\u000e\u0002\u06d5\u06d6\u0007\u001a\u0002\u0002\u06d6\u06d8",
    "\u0005\u001a\u000e\u0002\u06d7\u06d9\u0005\u001a\u000e\u0002\u06d8\u06d7",
    "\u0003\u0002\u0002\u0002\u06d9\u06da\u0003\u0002\u0002\u0002\u06da\u06d8",
    "\u0003\u0002\u0002\u0002\u06da\u06db\u0003\u0002\u0002\u0002\u06db\u06de",
    "\u0003\u0002\u0002\u0002\u06dc\u06de\u0007\u001a\u0002\u0002\u06dd\u06d3",
    "\u0003\u0002\u0002\u0002\u06dd\u06d5\u0003\u0002\u0002\u0002\u06dd\u06dc",
    "\u0003\u0002\u0002\u0002\u06dew\u0003\u0002\u0002\u0002\u06df\u06e7",
    "\u0007\u001c\u0002\u0002\u06e0\u06e2\u0007\u001c\u0002\u0002\u06e1\u06e3",
    "\u0005\u001a\u000e\u0002\u06e2\u06e1\u0003\u0002\u0002\u0002\u06e3\u06e4",
    "\u0003\u0002\u0002\u0002\u06e4\u06e2\u0003\u0002\u0002\u0002\u06e4\u06e5",
    "\u0003\u0002\u0002\u0002\u06e5\u06e7\u0003\u0002\u0002\u0002\u06e6\u06df",
    "\u0003\u0002\u0002\u0002\u06e6\u06e0\u0003\u0002\u0002\u0002\u06e7y",
    "\u0003\u0002\u0002\u0002\u06e8\u06e9\t\u001d\u0002\u0002\u06e9\u06f3",
    "\u0005\u001a\u000e\u0002\u06ea\u06eb\t\u001d\u0002\u0002\u06eb\u06ed",
    "\u0005\u001a\u000e\u0002\u06ec\u06ee\u0005\u001a\u000e\u0002\u06ed\u06ec",
    "\u0003\u0002\u0002\u0002\u06ee\u06ef\u0003\u0002\u0002\u0002\u06ef\u06ed",
    "\u0003\u0002\u0002\u0002\u06ef\u06f0\u0003\u0002\u0002\u0002\u06f0\u06f3",
    "\u0003\u0002\u0002\u0002\u06f1\u06f3\t\u001d\u0002\u0002\u06f2\u06e8",
    "\u0003\u0002\u0002\u0002\u06f2\u06ea\u0003\u0002\u0002\u0002\u06f2\u06f1",
    "\u0003\u0002\u0002\u0002\u06f3{\u0003\u0002\u0002\u0002\u06f4\u06f5",
    "\u0007\u001e\u0002\u0002\u06f5\u06ff\u0005\u001a\u000e\u0002\u06f6\u06f7",
    "\u0007\u001e\u0002\u0002\u06f7\u06f9\u0005\u001a\u000e\u0002\u06f8\u06fa",
    "\u0005\u001a\u000e\u0002\u06f9\u06f8\u0003\u0002\u0002\u0002\u06fa\u06fb",
    "\u0003\u0002\u0002\u0002\u06fb\u06f9\u0003\u0002\u0002\u0002\u06fb\u06fc",
    "\u0003\u0002\u0002\u0002\u06fc\u06ff\u0003\u0002\u0002\u0002\u06fd\u06ff",
    "\u0007\u001e\u0002\u0002\u06fe\u06f4\u0003\u0002\u0002\u0002\u06fe\u06f6",
    "\u0003\u0002\u0002\u0002\u06fe\u06fd\u0003\u0002\u0002\u0002\u06ff}",
    "\u0003\u0002\u0002\u0002\u0700\u0701\u0007\u001f\u0002\u0002\u0701\u070b",
    "\u0005\u001a\u000e\u0002\u0702\u0703\u0007\u001f\u0002\u0002\u0703\u0705",
    "\u0005\u001a\u000e\u0002\u0704\u0706\u0005\u001a\u000e\u0002\u0705\u0704",
    "\u0003\u0002\u0002\u0002\u0706\u0707\u0003\u0002\u0002\u0002\u0707\u0705",
    "\u0003\u0002\u0002\u0002\u0707\u0708\u0003\u0002\u0002\u0002\u0708\u070b",
    "\u0003\u0002\u0002\u0002\u0709\u070b\u0007\u001f\u0002\u0002\u070a\u0700",
    "\u0003\u0002\u0002\u0002\u070a\u0702\u0003\u0002\u0002\u0002\u070a\u0709",
    "\u0003\u0002\u0002\u0002\u070b\u007f\u0003\u0002\u0002\u0002\u070c\u0713",
    "\u0007n\u0002\u0002\u070d\u070e\u0007n\u0002\u0002\u070e\u070f\u0007",
    "g\u0002\u0002\u070f\u0713\u0007n\u0002\u0002\u0710\u0713\u0005\u0084",
    "C\u0002\u0711\u0713\u0005\u0086D\u0002\u0712\u070c\u0003\u0002\u0002",
    "\u0002\u0712\u070d\u0003\u0002\u0002\u0002\u0712\u0710\u0003\u0002\u0002",
    "\u0002\u0712\u0711\u0003\u0002\u0002\u0002\u0713\u0081\u0003\u0002\u0002",
    "\u0002\u0714\u0715\u0007o\u0002\u0002\u0715\u0083\u0003\u0002\u0002",
    "\u0002\u0716\u0717\u0007.\u0002\u0002\u0717\u0085\u0003\u0002\u0002",
    "\u0002\u0718\u0719\u0007-\u0002\u0002\u0719\u0087\u0003\u0002\u0002",
    "\u0002\u071a\u071b\u0007p\u0002\u0002\u071b\u0089\u0003\u0002\u0002",
    "\u0002\u071c\u071d\u0007k\u0002\u0002\u071d\u008b\u0003\u0002\u0002",
    "\u0002\u071e\u071f\u0007h\u0002\u0002\u071f\u008d\u0003\u0002\u0002",
    "\u0002\u012d\u0091\u0093\u0099\u009c\u00a1\u00a3\u00c3\u00cc\u00ce\u00d0",
    "\u00d7\u00dc\u00e1\u00e8\u00ef\u00f6\u00fb\u0101\u0108\u010a\u010d\u0112",
    "\u0116\u011b\u011f\u0124\u012a\u0130\u0138\u013f\u0141\u0144\u0149\u014d",
    "\u0152\u0156\u015b\u0161\u0167\u016f\u0176\u0178\u017b\u0180\u0184\u0189",
    "\u018d\u0192\u0198\u019e\u01a6\u01ad\u01af\u01b2\u01b7\u01bb\u01c0\u01c4",
    "\u01c9\u01cf\u01d5\u01dd\u01e4\u01e6\u01e9\u01ee\u01f2\u01f7\u01fb\u0200",
    "\u0206\u020c\u0214\u0219\u021e\u0220\u0226\u022a\u022f\u0233\u0238\u023e",
    "\u0244\u024c\u0252\u0254\u025a\u025e\u0263\u0267\u026c\u0272\u0278\u0280",
    "\u0285\u028a\u028e\u0290\u0296\u029a\u029f\u02a3\u02a8\u02ae\u02b4\u02bb",
    "\u02c1\u02c8\u02ca\u02cd\u02d2\u02d6\u02db\u02df\u02e4\u02ea\u02f0\u02f8",
    "\u02fe\u0301\u0306\u030b\u0311\u0319\u031f\u0321\u0327\u0329\u032f\u0333",
    "\u0338\u033c\u0341\u0347\u034d\u0355\u035b\u035f\u0365\u036b\u0371\u0379",
    "\u037f\u0383\u0388\u038c\u0392\u0398\u039a\u03a0\u03a8\u03af\u03b1\u03b4",
    "\u03b9\u03bd\u03c2\u03c6\u03cb\u03d1\u03d7\u03de\u03e5\u03e7\u03ea\u03ef",
    "\u03f3\u03f8\u03fc\u0401\u0407\u040d\u0413\u0417\u0419\u0420\u0424\u0428",
    "\u042c\u042e\u0435\u0438\u043c\u0441\u0443\u0446\u044c\u045c\u046b\u0480",
    "\u0485\u0488\u048e\u0493\u0495\u049b\u04b2\u04bc\u04bf\u04c6\u04c8\u04d1",
    "\u04d9\u04dd\u04ea\u04ef\u04f8\u04fc\u0505\u0515\u051e\u0524\u0534\u053a",
    "\u053f\u0544\u0548\u054a\u054d\u0553\u0561\u0564\u056d\u0570\u0579\u057c",
    "\u0585\u0588\u058f\u0591\u0598\u059a\u05a1\u05a3\u05aa\u05ac\u05b3\u05b5",
    "\u05bc\u05be\u05c5\u05c7\u05ce\u05d0\u05d6\u05dc\u05e1\u05e3\u05e6\u05ec",
    "\u05f2\u05f7\u05f9\u05fc\u0603\u0605\u060c\u060e\u061c\u061f\u0628\u062b",
    "\u0634\u0637\u0640\u0643\u064c\u064f\u0658\u065b\u0664\u0667\u0670\u0673",
    "\u067c\u067f\u0688\u068b\u0694\u0697\u06a0\u06a3\u06af\u06b4\u06c0\u06c5",
    "\u06ce\u06d1\u06da\u06dd\u06e4\u06e6\u06ef\u06f2\u06fb\u06fe\u0707\u070a",
    "\u0712"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [ null, "'to'", "'repeat'", "'fd'", "'bk'", "'rt'", "'lt'", 
                     "'cs'", "'ct'", "'pu'", "'pd'", "'ht'", "'st'", "'pe'", 
                     "'ppt'", "'home'", "'setx'", "'sety'", "'setxy'", "'setpc'", 
                     "'setsc'", "'make'", "'if'", "'stop'", "'wait'", "'while'", 
                     "'wash'", "'setpw'", "'circle'", "'setheading'", "'print'", 
                     "'random'", "'sin'", "'cos'", "'tan'", "'arcsin'", 
                     "'arccos'", "'arctan'", "'abs'", "'sqrt'", "'mod'", 
                     "'power'", "'log10'", "'e'", "'pi'", "':'", "'black'", 
                     "'red'", "'green'", "'yellow'", "'blue'", "'magenta'", 
                     "'cyan'", "'white'", "'gray'", "'lightgray'", "'darkred'", 
                     "'darkgreen'", "'darkblue'", "'orange'", "'pink'", 
                     "'purple'", "'brown'", "'['", "']'", "'<'", "'>'", 
                     "'='", "'<='", "'>='", "'!='", "'+'", "'-'", "'||'", 
                     "'*'", "'/'", "'&&'", "'!'", "'\"'", "'pr'", "'forward'", 
                     "'back'", "'backward'", "'right'", "'left'", "'clearscreen'", 
                     "'penup'", "'pendown'", "'penerase'", "'penpaint'", 
                     "'hideturtle'", "'showturtle'", "'setpencolor'", "'setscreencolor'", 
                     "'rnd'", "'ran'", "'asin'", "'acos'", "'atan'", "'log'", 
                     "'setpenwidth'", "'.'", "'end'", null, null, null, 
                     "'('", "')'" ];

var symbolicNames = [ null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, "PARAMETERDECL", "STRINGLITERAL", 
                      "STRING", "LPAREN", "RPAREN", "NUMBER", "COMMENT", 
                      "EOL", "WS" ];

var ruleNames =  [ "prog", "line", "cmd", "procedureInvocation", "procedureDeclaration", 
                   "parameterDeclarations", "colornameWithoutTypingErrors", 
                   "func", "repeat", "whilee", "block", "ife", "expression", 
                   "comparisonOperator", "sExpr", "term", "factor", "nsFact", 
                   "value", "deref", "colorname", "rgb", "colornumber", 
                   "make", "print", "quotedstring", "name", "fd", "bk", 
                   "rt", "lt", "cs", "ct", "pu", "pd", "pe", "ppt", "ht", 
                   "st", "setpc", "setsc", "home", "stop", "setxy", "setx", 
                   "sety", "random", "sin", "cos", "tan", "arcsin", "arccos", 
                   "arctan", "abs", "sqrt", "mod", "power", "log10", "waite", 
                   "wash", "setpw", "circle", "setheading", "number", "comment", 
                   "pie", "ee", "eol", "maybeTo", "end" ];

function LogoEditorParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

LogoEditorParser.prototype = Object.create(antlr4.Parser.prototype);
LogoEditorParser.prototype.constructor = LogoEditorParser;

Object.defineProperty(LogoEditorParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

LogoEditorParser.EOF = antlr4.Token.EOF;
LogoEditorParser.T__0 = 1;
LogoEditorParser.T__1 = 2;
LogoEditorParser.T__2 = 3;
LogoEditorParser.T__3 = 4;
LogoEditorParser.T__4 = 5;
LogoEditorParser.T__5 = 6;
LogoEditorParser.T__6 = 7;
LogoEditorParser.T__7 = 8;
LogoEditorParser.T__8 = 9;
LogoEditorParser.T__9 = 10;
LogoEditorParser.T__10 = 11;
LogoEditorParser.T__11 = 12;
LogoEditorParser.T__12 = 13;
LogoEditorParser.T__13 = 14;
LogoEditorParser.T__14 = 15;
LogoEditorParser.T__15 = 16;
LogoEditorParser.T__16 = 17;
LogoEditorParser.T__17 = 18;
LogoEditorParser.T__18 = 19;
LogoEditorParser.T__19 = 20;
LogoEditorParser.T__20 = 21;
LogoEditorParser.T__21 = 22;
LogoEditorParser.T__22 = 23;
LogoEditorParser.T__23 = 24;
LogoEditorParser.T__24 = 25;
LogoEditorParser.T__25 = 26;
LogoEditorParser.T__26 = 27;
LogoEditorParser.T__27 = 28;
LogoEditorParser.T__28 = 29;
LogoEditorParser.T__29 = 30;
LogoEditorParser.T__30 = 31;
LogoEditorParser.T__31 = 32;
LogoEditorParser.T__32 = 33;
LogoEditorParser.T__33 = 34;
LogoEditorParser.T__34 = 35;
LogoEditorParser.T__35 = 36;
LogoEditorParser.T__36 = 37;
LogoEditorParser.T__37 = 38;
LogoEditorParser.T__38 = 39;
LogoEditorParser.T__39 = 40;
LogoEditorParser.T__40 = 41;
LogoEditorParser.T__41 = 42;
LogoEditorParser.T__42 = 43;
LogoEditorParser.T__43 = 44;
LogoEditorParser.T__44 = 45;
LogoEditorParser.T__45 = 46;
LogoEditorParser.T__46 = 47;
LogoEditorParser.T__47 = 48;
LogoEditorParser.T__48 = 49;
LogoEditorParser.T__49 = 50;
LogoEditorParser.T__50 = 51;
LogoEditorParser.T__51 = 52;
LogoEditorParser.T__52 = 53;
LogoEditorParser.T__53 = 54;
LogoEditorParser.T__54 = 55;
LogoEditorParser.T__55 = 56;
LogoEditorParser.T__56 = 57;
LogoEditorParser.T__57 = 58;
LogoEditorParser.T__58 = 59;
LogoEditorParser.T__59 = 60;
LogoEditorParser.T__60 = 61;
LogoEditorParser.T__61 = 62;
LogoEditorParser.T__62 = 63;
LogoEditorParser.T__63 = 64;
LogoEditorParser.T__64 = 65;
LogoEditorParser.T__65 = 66;
LogoEditorParser.T__66 = 67;
LogoEditorParser.T__67 = 68;
LogoEditorParser.T__68 = 69;
LogoEditorParser.T__69 = 70;
LogoEditorParser.T__70 = 71;
LogoEditorParser.T__71 = 72;
LogoEditorParser.T__72 = 73;
LogoEditorParser.T__73 = 74;
LogoEditorParser.T__74 = 75;
LogoEditorParser.T__75 = 76;
LogoEditorParser.T__76 = 77;
LogoEditorParser.T__77 = 78;
LogoEditorParser.T__78 = 79;
LogoEditorParser.T__79 = 80;
LogoEditorParser.T__80 = 81;
LogoEditorParser.T__81 = 82;
LogoEditorParser.T__82 = 83;
LogoEditorParser.T__83 = 84;
LogoEditorParser.T__84 = 85;
LogoEditorParser.T__85 = 86;
LogoEditorParser.T__86 = 87;
LogoEditorParser.T__87 = 88;
LogoEditorParser.T__88 = 89;
LogoEditorParser.T__89 = 90;
LogoEditorParser.T__90 = 91;
LogoEditorParser.T__91 = 92;
LogoEditorParser.T__92 = 93;
LogoEditorParser.T__93 = 94;
LogoEditorParser.T__94 = 95;
LogoEditorParser.T__95 = 96;
LogoEditorParser.T__96 = 97;
LogoEditorParser.T__97 = 98;
LogoEditorParser.T__98 = 99;
LogoEditorParser.T__99 = 100;
LogoEditorParser.T__100 = 101;
LogoEditorParser.T__101 = 102;
LogoEditorParser.PARAMETERDECL = 103;
LogoEditorParser.STRINGLITERAL = 104;
LogoEditorParser.STRING = 105;
LogoEditorParser.LPAREN = 106;
LogoEditorParser.RPAREN = 107;
LogoEditorParser.NUMBER = 108;
LogoEditorParser.COMMENT = 109;
LogoEditorParser.EOL = 110;
LogoEditorParser.WS = 111;

LogoEditorParser.RULE_prog = 0;
LogoEditorParser.RULE_line = 1;
LogoEditorParser.RULE_cmd = 2;
LogoEditorParser.RULE_procedureInvocation = 3;
LogoEditorParser.RULE_procedureDeclaration = 4;
LogoEditorParser.RULE_parameterDeclarations = 5;
LogoEditorParser.RULE_colornameWithoutTypingErrors = 6;
LogoEditorParser.RULE_func = 7;
LogoEditorParser.RULE_repeat = 8;
LogoEditorParser.RULE_whilee = 9;
LogoEditorParser.RULE_block = 10;
LogoEditorParser.RULE_ife = 11;
LogoEditorParser.RULE_expression = 12;
LogoEditorParser.RULE_comparisonOperator = 13;
LogoEditorParser.RULE_sExpr = 14;
LogoEditorParser.RULE_term = 15;
LogoEditorParser.RULE_factor = 16;
LogoEditorParser.RULE_nsFact = 17;
LogoEditorParser.RULE_value = 18;
LogoEditorParser.RULE_deref = 19;
LogoEditorParser.RULE_colorname = 20;
LogoEditorParser.RULE_rgb = 21;
LogoEditorParser.RULE_colornumber = 22;
LogoEditorParser.RULE_make = 23;
LogoEditorParser.RULE_print = 24;
LogoEditorParser.RULE_quotedstring = 25;
LogoEditorParser.RULE_name = 26;
LogoEditorParser.RULE_fd = 27;
LogoEditorParser.RULE_bk = 28;
LogoEditorParser.RULE_rt = 29;
LogoEditorParser.RULE_lt = 30;
LogoEditorParser.RULE_cs = 31;
LogoEditorParser.RULE_ct = 32;
LogoEditorParser.RULE_pu = 33;
LogoEditorParser.RULE_pd = 34;
LogoEditorParser.RULE_pe = 35;
LogoEditorParser.RULE_ppt = 36;
LogoEditorParser.RULE_ht = 37;
LogoEditorParser.RULE_st = 38;
LogoEditorParser.RULE_setpc = 39;
LogoEditorParser.RULE_setsc = 40;
LogoEditorParser.RULE_home = 41;
LogoEditorParser.RULE_stop = 42;
LogoEditorParser.RULE_setxy = 43;
LogoEditorParser.RULE_setx = 44;
LogoEditorParser.RULE_sety = 45;
LogoEditorParser.RULE_random = 46;
LogoEditorParser.RULE_sin = 47;
LogoEditorParser.RULE_cos = 48;
LogoEditorParser.RULE_tan = 49;
LogoEditorParser.RULE_arcsin = 50;
LogoEditorParser.RULE_arccos = 51;
LogoEditorParser.RULE_arctan = 52;
LogoEditorParser.RULE_abs = 53;
LogoEditorParser.RULE_sqrt = 54;
LogoEditorParser.RULE_mod = 55;
LogoEditorParser.RULE_power = 56;
LogoEditorParser.RULE_log10 = 57;
LogoEditorParser.RULE_waite = 58;
LogoEditorParser.RULE_wash = 59;
LogoEditorParser.RULE_setpw = 60;
LogoEditorParser.RULE_circle = 61;
LogoEditorParser.RULE_setheading = 62;
LogoEditorParser.RULE_number = 63;
LogoEditorParser.RULE_comment = 64;
LogoEditorParser.RULE_pie = 65;
LogoEditorParser.RULE_ee = 66;
LogoEditorParser.RULE_eol = 67;
LogoEditorParser.RULE_maybeTo = 68;
LogoEditorParser.RULE_end = 69;

function ProgContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_prog;
    return this;
}

ProgContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ProgContext.prototype.constructor = ProgContext;

ProgContext.prototype.procedureDeclaration = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ProcedureDeclarationContext);
    } else {
        return this.getTypedRuleContext(ProcedureDeclarationContext,i);
    }
};

ProgContext.prototype.eol = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(EolContext);
    } else {
        return this.getTypedRuleContext(EolContext,i);
    }
};

ProgContext.prototype.comment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(CommentContext);
    } else {
        return this.getTypedRuleContext(CommentContext,i);
    }
};

ProgContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterProg(this);
	}
};

ProgContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitProg(this);
	}
};

ProgContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitProg(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ProgContext = ProgContext;

LogoEditorParser.prototype.prog = function() {

    var localctx = new ProgContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, LogoEditorParser.RULE_prog);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 145;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__0) | (1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || _la===LogoEditorParser.T__44 || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.PARAMETERDECL - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)) | (1 << (LogoEditorParser.EOL - 79)))) !== 0)) {
            this.state = 143;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,0,this._ctx);
            switch(la_) {
            case 1:
                this.state = 140;
                this.procedureDeclaration();
                break;

            case 2:
                this.state = 141;
                this.eol();
                break;

            case 3:
                this.state = 142;
                this.comment();
                break;

            }
            this.state = 147;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LineContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_line;
    return this;
}

LineContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LineContext.prototype.constructor = LineContext;

LineContext.prototype.cmd = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(CmdContext);
    } else {
        return this.getTypedRuleContext(CmdContext,i);
    }
};

LineContext.prototype.comment = function() {
    return this.getTypedRuleContext(CommentContext,0);
};

LineContext.prototype.print = function() {
    return this.getTypedRuleContext(PrintContext,0);
};

LineContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterLine(this);
	}
};

LineContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitLine(this);
	}
};

LineContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitLine(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.LineContext = LineContext;

LogoEditorParser.prototype.line = function() {

    var localctx = new LineContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, LogoEditorParser.RULE_line);
    try {
        this.state = 161;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,5,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 149; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 148;
            		this.cmd();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 151; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,2, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            this.state = 154;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,3,this._ctx);
            if(la_===1) {
                this.state = 153;
                this.comment();

            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 156;
            this.comment();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 157;
            this.print();
            this.state = 159;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,4,this._ctx);
            if(la_===1) {
                this.state = 158;
                this.comment();

            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CmdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_cmd;
    return this;
}

CmdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CmdContext.prototype.constructor = CmdContext;

CmdContext.prototype.repeat = function() {
    return this.getTypedRuleContext(RepeatContext,0);
};

CmdContext.prototype.fd = function() {
    return this.getTypedRuleContext(FdContext,0);
};

CmdContext.prototype.bk = function() {
    return this.getTypedRuleContext(BkContext,0);
};

CmdContext.prototype.rt = function() {
    return this.getTypedRuleContext(RtContext,0);
};

CmdContext.prototype.lt = function() {
    return this.getTypedRuleContext(LtContext,0);
};

CmdContext.prototype.cs = function() {
    return this.getTypedRuleContext(CsContext,0);
};

CmdContext.prototype.ct = function() {
    return this.getTypedRuleContext(CtContext,0);
};

CmdContext.prototype.pu = function() {
    return this.getTypedRuleContext(PuContext,0);
};

CmdContext.prototype.pd = function() {
    return this.getTypedRuleContext(PdContext,0);
};

CmdContext.prototype.ht = function() {
    return this.getTypedRuleContext(HtContext,0);
};

CmdContext.prototype.st = function() {
    return this.getTypedRuleContext(StContext,0);
};

CmdContext.prototype.pe = function() {
    return this.getTypedRuleContext(PeContext,0);
};

CmdContext.prototype.ppt = function() {
    return this.getTypedRuleContext(PptContext,0);
};

CmdContext.prototype.home = function() {
    return this.getTypedRuleContext(HomeContext,0);
};

CmdContext.prototype.setx = function() {
    return this.getTypedRuleContext(SetxContext,0);
};

CmdContext.prototype.sety = function() {
    return this.getTypedRuleContext(SetyContext,0);
};

CmdContext.prototype.setxy = function() {
    return this.getTypedRuleContext(SetxyContext,0);
};

CmdContext.prototype.setpc = function() {
    return this.getTypedRuleContext(SetpcContext,0);
};

CmdContext.prototype.setsc = function() {
    return this.getTypedRuleContext(SetscContext,0);
};

CmdContext.prototype.make = function() {
    return this.getTypedRuleContext(MakeContext,0);
};

CmdContext.prototype.ife = function() {
    return this.getTypedRuleContext(IfeContext,0);
};

CmdContext.prototype.stop = function() {
    return this.getTypedRuleContext(StopContext,0);
};

CmdContext.prototype.waite = function() {
    return this.getTypedRuleContext(WaiteContext,0);
};

CmdContext.prototype.whilee = function() {
    return this.getTypedRuleContext(WhileeContext,0);
};

CmdContext.prototype.wash = function() {
    return this.getTypedRuleContext(WashContext,0);
};

CmdContext.prototype.setpw = function() {
    return this.getTypedRuleContext(SetpwContext,0);
};

CmdContext.prototype.circle = function() {
    return this.getTypedRuleContext(CircleContext,0);
};

CmdContext.prototype.setheading = function() {
    return this.getTypedRuleContext(SetheadingContext,0);
};

CmdContext.prototype.print = function() {
    return this.getTypedRuleContext(PrintContext,0);
};

CmdContext.prototype.procedureInvocation = function() {
    return this.getTypedRuleContext(ProcedureInvocationContext,0);
};

CmdContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterCmd(this);
	}
};

CmdContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitCmd(this);
	}
};

CmdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitCmd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.CmdContext = CmdContext;

LogoEditorParser.prototype.cmd = function() {

    var localctx = new CmdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, LogoEditorParser.RULE_cmd);
    try {
        this.state = 193;
        switch(this._input.LA(1)) {
        case LogoEditorParser.T__1:
            this.enterOuterAlt(localctx, 1);
            this.state = 163;
            this.repeat();
            break;
        case LogoEditorParser.T__2:
        case LogoEditorParser.T__79:
            this.enterOuterAlt(localctx, 2);
            this.state = 164;
            this.fd();
            break;
        case LogoEditorParser.T__3:
        case LogoEditorParser.T__80:
        case LogoEditorParser.T__81:
            this.enterOuterAlt(localctx, 3);
            this.state = 165;
            this.bk();
            break;
        case LogoEditorParser.T__4:
        case LogoEditorParser.T__82:
            this.enterOuterAlt(localctx, 4);
            this.state = 166;
            this.rt();
            break;
        case LogoEditorParser.T__5:
        case LogoEditorParser.T__83:
            this.enterOuterAlt(localctx, 5);
            this.state = 167;
            this.lt();
            break;
        case LogoEditorParser.T__6:
        case LogoEditorParser.T__84:
            this.enterOuterAlt(localctx, 6);
            this.state = 168;
            this.cs();
            break;
        case LogoEditorParser.T__7:
            this.enterOuterAlt(localctx, 7);
            this.state = 169;
            this.ct();
            break;
        case LogoEditorParser.T__8:
        case LogoEditorParser.T__85:
            this.enterOuterAlt(localctx, 8);
            this.state = 170;
            this.pu();
            break;
        case LogoEditorParser.T__9:
        case LogoEditorParser.T__86:
            this.enterOuterAlt(localctx, 9);
            this.state = 171;
            this.pd();
            break;
        case LogoEditorParser.T__10:
        case LogoEditorParser.T__89:
            this.enterOuterAlt(localctx, 10);
            this.state = 172;
            this.ht();
            break;
        case LogoEditorParser.T__11:
        case LogoEditorParser.T__90:
            this.enterOuterAlt(localctx, 11);
            this.state = 173;
            this.st();
            break;
        case LogoEditorParser.T__12:
        case LogoEditorParser.T__87:
            this.enterOuterAlt(localctx, 12);
            this.state = 174;
            this.pe();
            break;
        case LogoEditorParser.T__13:
        case LogoEditorParser.T__88:
            this.enterOuterAlt(localctx, 13);
            this.state = 175;
            this.ppt();
            break;
        case LogoEditorParser.T__14:
            this.enterOuterAlt(localctx, 14);
            this.state = 176;
            this.home();
            break;
        case LogoEditorParser.T__15:
            this.enterOuterAlt(localctx, 15);
            this.state = 177;
            this.setx();
            break;
        case LogoEditorParser.T__16:
            this.enterOuterAlt(localctx, 16);
            this.state = 178;
            this.sety();
            break;
        case LogoEditorParser.T__17:
            this.enterOuterAlt(localctx, 17);
            this.state = 179;
            this.setxy();
            break;
        case LogoEditorParser.T__18:
        case LogoEditorParser.T__91:
            this.enterOuterAlt(localctx, 18);
            this.state = 180;
            this.setpc();
            break;
        case LogoEditorParser.T__19:
        case LogoEditorParser.T__92:
            this.enterOuterAlt(localctx, 19);
            this.state = 181;
            this.setsc();
            break;
        case LogoEditorParser.T__20:
            this.enterOuterAlt(localctx, 20);
            this.state = 182;
            this.make();
            break;
        case LogoEditorParser.T__21:
            this.enterOuterAlt(localctx, 21);
            this.state = 183;
            this.ife();
            break;
        case LogoEditorParser.T__22:
            this.enterOuterAlt(localctx, 22);
            this.state = 184;
            this.stop();
            break;
        case LogoEditorParser.T__23:
            this.enterOuterAlt(localctx, 23);
            this.state = 185;
            this.waite();
            break;
        case LogoEditorParser.T__24:
            this.enterOuterAlt(localctx, 24);
            this.state = 186;
            this.whilee();
            break;
        case LogoEditorParser.T__25:
            this.enterOuterAlt(localctx, 25);
            this.state = 187;
            this.wash();
            break;
        case LogoEditorParser.T__26:
        case LogoEditorParser.T__99:
            this.enterOuterAlt(localctx, 26);
            this.state = 188;
            this.setpw();
            break;
        case LogoEditorParser.T__27:
            this.enterOuterAlt(localctx, 27);
            this.state = 189;
            this.circle();
            break;
        case LogoEditorParser.T__28:
            this.enterOuterAlt(localctx, 28);
            this.state = 190;
            this.setheading();
            break;
        case LogoEditorParser.T__29:
        case LogoEditorParser.T__78:
            this.enterOuterAlt(localctx, 29);
            this.state = 191;
            this.print();
            break;
        case LogoEditorParser.STRING:
            this.enterOuterAlt(localctx, 30);
            this.state = 192;
            this.procedureInvocation();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ProcedureInvocationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_procedureInvocation;
    return this;
}

ProcedureInvocationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ProcedureInvocationContext.prototype.constructor = ProcedureInvocationContext;

ProcedureInvocationContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

ProcedureInvocationContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ProcedureInvocationContext.prototype.colornameWithoutTypingErrors = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColornameWithoutTypingErrorsContext);
    } else {
        return this.getTypedRuleContext(ColornameWithoutTypingErrorsContext,i);
    }
};

ProcedureInvocationContext.prototype.block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(BlockContext);
    } else {
        return this.getTypedRuleContext(BlockContext,i);
    }
};

ProcedureInvocationContext.prototype.rgb = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(RgbContext);
    } else {
        return this.getTypedRuleContext(RgbContext,i);
    }
};

ProcedureInvocationContext.prototype.quotedstring = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(QuotedstringContext);
    } else {
        return this.getTypedRuleContext(QuotedstringContext,i);
    }
};

ProcedureInvocationContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterProcedureInvocation(this);
	}
};

ProcedureInvocationContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitProcedureInvocation(this);
	}
};

ProcedureInvocationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitProcedureInvocation(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ProcedureInvocationContext = ProcedureInvocationContext;

LogoEditorParser.prototype.procedureInvocation = function() {

    var localctx = new ProcedureInvocationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, LogoEditorParser.RULE_procedureInvocation);
    try {
        this.state = 206;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,9,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 195;
            this.match(LogoEditorParser.STRING);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 196;
            this.match(LogoEditorParser.STRING);
            this.state = 202; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 202;
            		this._errHandler.sync(this);
            		var la_ = this._interp.adaptivePredict(this._input,7,this._ctx);
            		switch(la_) {
            		case 1:
            		    this.state = 197;
            		    this.expression();
            		    break;

            		case 2:
            		    this.state = 198;
            		    this.colornameWithoutTypingErrors();
            		    break;

            		case 3:
            		    this.state = 199;
            		    this.block();
            		    break;

            		case 4:
            		    this.state = 200;
            		    this.rgb();
            		    break;

            		case 5:
            		    this.state = 201;
            		    this.quotedstring();
            		    break;

            		}
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 204; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,8, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ProcedureDeclarationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_procedureDeclaration;
    this.OK = null; // Token
    this.MANYTOS = null; // Token
    this.NAMETO = null; // Token
    this.NAMEEND = null; // Token
    this.NAMECMD = null; // Token
    this.NAMEFUNC = null; // Token
    this.METHODNAMEWHITESPACE = null; // Token
    this.EOLBEFOREPARAMS = null; // Token
    this.PARAMSONELINE = null; // Token
    this.EOLAFTERTO = null; // Token
    this.NOEOLBEFOREEND = null; // Token
    this.PARAMSNOCOLON = null; // Token
    this.NOEOL = null; // Token
    this.MANYENDS = null; // Token
    this.MISSPELLEDTO = null; // MaybeToContext
    this.MISSINGTO = null; // NameContext
    this.NOTONONAME = null; // ParameterDeclarationsContext
    this.NOTONONAMETOO = null; // LineContext
    return this;
}

ProcedureDeclarationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ProcedureDeclarationContext.prototype.constructor = ProcedureDeclarationContext;

ProcedureDeclarationContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

ProcedureDeclarationContext.prototype.eol = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(EolContext);
    } else {
        return this.getTypedRuleContext(EolContext,i);
    }
};

ProcedureDeclarationContext.prototype.end = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(EndContext);
    } else {
        return this.getTypedRuleContext(EndContext,i);
    }
};

ProcedureDeclarationContext.prototype.parameterDeclarations = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ParameterDeclarationsContext);
    } else {
        return this.getTypedRuleContext(ParameterDeclarationsContext,i);
    }
};

ProcedureDeclarationContext.prototype.line = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(LineContext);
    } else {
        return this.getTypedRuleContext(LineContext,i);
    }
};

ProcedureDeclarationContext.prototype.STRING = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LogoEditorParser.STRING);
    } else {
        return this.getToken(LogoEditorParser.STRING, i);
    }
};


ProcedureDeclarationContext.prototype.maybeTo = function() {
    return this.getTypedRuleContext(MaybeToContext,0);
};

ProcedureDeclarationContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterProcedureDeclaration(this);
	}
};

ProcedureDeclarationContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitProcedureDeclaration(this);
	}
};

ProcedureDeclarationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitProcedureDeclaration(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ProcedureDeclarationContext = ProcedureDeclarationContext;

LogoEditorParser.prototype.procedureDeclaration = function() {

    var localctx = new ProcedureDeclarationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, LogoEditorParser.RULE_procedureDeclaration);
    var _la = 0; // Token type
    try {
        this.state = 1092;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,185,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 208;
            localctx.OK = this.match(LogoEditorParser.T__0);
            this.state = 209;
            this.name();
            this.state = 213;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.T__44 || _la===LogoEditorParser.PARAMETERDECL) {
                this.state = 210;
                this.parameterDeclarations();
                this.state = 215;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 216;
            this.eol();
            this.state = 223;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)) | (1 << (LogoEditorParser.EOL - 79)))) !== 0)) {
                this.state = 218;
                _la = this._input.LA(1);
                if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                    this.state = 217;
                    this.line();
                }

                this.state = 220;
                this.eol();
                this.state = 225;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 226;
            this.end();
            this.state = 230;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,13,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 227;
                    this.eol(); 
                }
                this.state = 232;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,13,this._ctx);
            }

            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 233;
            localctx.MANYTOS = this.match(LogoEditorParser.T__0);
            this.state = 237;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.EOL) {
                this.state = 234;
                this.eol();
                this.state = 239;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 247; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 240;
                this.match(LogoEditorParser.T__0);
                this.state = 244;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la===LogoEditorParser.EOL) {
                    this.state = 241;
                    this.eol();
                    this.state = 246;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 249; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.T__0);
            this.state = 251;
            this.name();
            this.state = 255;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,17,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 252;
                    this.eol(); 
                }
                this.state = 257;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,17,this._ctx);
            }

            this.state = 267;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,20,this._ctx);
            if(la_===1) {
                this.state = 258;
                this.parameterDeclarations();
                this.state = 264;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,19,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 262;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 259;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 260;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 261;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 266;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,19,this._ctx);
                }


            }
            this.state = 272;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,21,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 269;
                    this.eol(); 
                }
                this.state = 274;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,21,this._ctx);
            }

            this.state = 281;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,23,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 276;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 275;
                        this.line();
                    }

                    this.state = 278;
                    this.eol(); 
                }
                this.state = 283;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,23,this._ctx);
            }

            this.state = 285;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,24,this._ctx);
            if(la_===1) {
                this.state = 284;
                this.line();

            }
            this.state = 296;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,26,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 290;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 287;
                        this.eol();
                        this.state = 292;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 293;
                    this.end(); 
                }
                this.state = 298;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,26,this._ctx);
            }

            this.state = 302;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,27,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 299;
                    this.eol(); 
                }
                this.state = 304;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,27,this._ctx);
            }

            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 305;
            localctx.NAMETO = this.match(LogoEditorParser.T__0);
            this.state = 306;
            this.match(LogoEditorParser.T__0);
            this.state = 310;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,28,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 307;
                    this.eol(); 
                }
                this.state = 312;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,28,this._ctx);
            }

            this.state = 322;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,31,this._ctx);
            if(la_===1) {
                this.state = 313;
                this.parameterDeclarations();
                this.state = 319;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,30,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 317;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 314;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 315;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 316;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 321;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,30,this._ctx);
                }


            }
            this.state = 327;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,32,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 324;
                    this.eol(); 
                }
                this.state = 329;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,32,this._ctx);
            }

            this.state = 336;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,34,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 331;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 330;
                        this.line();
                    }

                    this.state = 333;
                    this.eol(); 
                }
                this.state = 338;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,34,this._ctx);
            }

            this.state = 340;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,35,this._ctx);
            if(la_===1) {
                this.state = 339;
                this.line();

            }
            this.state = 351;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,37,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 345;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 342;
                        this.eol();
                        this.state = 347;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 348;
                    this.end(); 
                }
                this.state = 353;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,37,this._ctx);
            }

            this.state = 357;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,38,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 354;
                    this.eol(); 
                }
                this.state = 359;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,38,this._ctx);
            }

            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 360;
            localctx.NAMEEND = this.match(LogoEditorParser.T__0);
            this.state = 361;
            this.end();
            this.state = 365;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,39,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 362;
                    this.eol(); 
                }
                this.state = 367;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,39,this._ctx);
            }

            this.state = 377;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,42,this._ctx);
            if(la_===1) {
                this.state = 368;
                this.parameterDeclarations();
                this.state = 374;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,41,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 372;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 369;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 370;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 371;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 376;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,41,this._ctx);
                }


            }
            this.state = 382;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,43,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 379;
                    this.eol(); 
                }
                this.state = 384;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,43,this._ctx);
            }

            this.state = 391;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,45,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 386;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 385;
                        this.line();
                    }

                    this.state = 388;
                    this.eol(); 
                }
                this.state = 393;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,45,this._ctx);
            }

            this.state = 395;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,46,this._ctx);
            if(la_===1) {
                this.state = 394;
                this.line();

            }
            this.state = 406;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,48,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 400;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 397;
                        this.eol();
                        this.state = 402;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 403;
                    this.end(); 
                }
                this.state = 408;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,48,this._ctx);
            }

            this.state = 412;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,49,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 409;
                    this.eol(); 
                }
                this.state = 414;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,49,this._ctx);
            }

            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 415;
            localctx.NAMECMD = this.match(LogoEditorParser.T__0);
            this.state = 416;
            _la = this._input.LA(1);
            if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0))) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 420;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,50,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 417;
                    this.eol(); 
                }
                this.state = 422;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,50,this._ctx);
            }

            this.state = 432;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,53,this._ctx);
            if(la_===1) {
                this.state = 423;
                this.parameterDeclarations();
                this.state = 429;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,52,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 427;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 424;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 425;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 426;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 431;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,52,this._ctx);
                }


            }
            this.state = 437;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,54,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 434;
                    this.eol(); 
                }
                this.state = 439;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,54,this._ctx);
            }

            this.state = 446;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,56,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 441;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 440;
                        this.line();
                    }

                    this.state = 443;
                    this.eol(); 
                }
                this.state = 448;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,56,this._ctx);
            }

            this.state = 450;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,57,this._ctx);
            if(la_===1) {
                this.state = 449;
                this.line();

            }
            this.state = 461;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,59,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 455;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 452;
                        this.eol();
                        this.state = 457;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 458;
                    this.end(); 
                }
                this.state = 463;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,59,this._ctx);
            }

            this.state = 467;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,60,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 464;
                    this.eol(); 
                }
                this.state = 469;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,60,this._ctx);
            }

            break;

        case 6:
            this.enterOuterAlt(localctx, 6);
            this.state = 470;
            localctx.NAMEFUNC = this.match(LogoEditorParser.T__0);
            this.state = 471;
            _la = this._input.LA(1);
            if(!(((((_la - 31)) & ~0x1f) == 0 && ((1 << (_la - 31)) & ((1 << (LogoEditorParser.T__30 - 31)) | (1 << (LogoEditorParser.T__31 - 31)) | (1 << (LogoEditorParser.T__32 - 31)) | (1 << (LogoEditorParser.T__33 - 31)) | (1 << (LogoEditorParser.T__34 - 31)) | (1 << (LogoEditorParser.T__35 - 31)) | (1 << (LogoEditorParser.T__36 - 31)) | (1 << (LogoEditorParser.T__37 - 31)) | (1 << (LogoEditorParser.T__38 - 31)) | (1 << (LogoEditorParser.T__39 - 31)) | (1 << (LogoEditorParser.T__40 - 31)) | (1 << (LogoEditorParser.T__41 - 31)) | (1 << (LogoEditorParser.T__42 - 31)) | (1 << (LogoEditorParser.T__43 - 31)))) !== 0))) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 475;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,61,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 472;
                    this.eol(); 
                }
                this.state = 477;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,61,this._ctx);
            }

            this.state = 487;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,64,this._ctx);
            if(la_===1) {
                this.state = 478;
                this.parameterDeclarations();
                this.state = 484;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,63,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 482;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 479;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 480;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 481;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 486;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,63,this._ctx);
                }


            }
            this.state = 492;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,65,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 489;
                    this.eol(); 
                }
                this.state = 494;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,65,this._ctx);
            }

            this.state = 501;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,67,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 496;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 495;
                        this.line();
                    }

                    this.state = 498;
                    this.eol(); 
                }
                this.state = 503;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,67,this._ctx);
            }

            this.state = 505;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,68,this._ctx);
            if(la_===1) {
                this.state = 504;
                this.line();

            }
            this.state = 516;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,70,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 510;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 507;
                        this.eol();
                        this.state = 512;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 513;
                    this.end(); 
                }
                this.state = 518;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,70,this._ctx);
            }

            this.state = 522;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,71,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 519;
                    this.eol(); 
                }
                this.state = 524;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,71,this._ctx);
            }

            break;

        case 7:
            this.enterOuterAlt(localctx, 7);
            this.state = 525;
            localctx.METHODNAMEWHITESPACE = this.match(LogoEditorParser.T__0);
            this.state = 526;
            this.match(LogoEditorParser.STRING);
            this.state = 528; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 527;
            		this.match(LogoEditorParser.STRING);
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 530; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,72, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            this.state = 535;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,73,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 532;
                    this.eol(); 
                }
                this.state = 537;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,73,this._ctx);
            }

            this.state = 542;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,75,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 540;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__44:
                    case LogoEditorParser.PARAMETERDECL:
                        this.state = 538;
                        this.parameterDeclarations();
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 539;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 544;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,75,this._ctx);
            }

            this.state = 548;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,76,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 545;
                    this.eol(); 
                }
                this.state = 550;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,76,this._ctx);
            }

            this.state = 557;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,78,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 552;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 551;
                        this.line();
                    }

                    this.state = 554;
                    this.eol(); 
                }
                this.state = 559;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,78,this._ctx);
            }

            this.state = 561;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,79,this._ctx);
            if(la_===1) {
                this.state = 560;
                this.line();

            }
            this.state = 572;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,81,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 566;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 563;
                        this.eol();
                        this.state = 568;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 569;
                    this.end(); 
                }
                this.state = 574;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,81,this._ctx);
            }

            this.state = 578;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,82,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 575;
                    this.eol(); 
                }
                this.state = 580;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,82,this._ctx);
            }

            break;

        case 8:
            this.enterOuterAlt(localctx, 8);
            this.state = 581;
            localctx.EOLBEFOREPARAMS = this.match(LogoEditorParser.T__0);
            this.state = 582;
            this.name();
            this.state = 584; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 583;
                this.eol();
                this.state = 586; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.EOL);
            this.state = 588;
            this.parameterDeclarations();
            this.state = 594;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,85,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 592;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__44:
                    case LogoEditorParser.PARAMETERDECL:
                        this.state = 589;
                        this.parameterDeclarations();
                        break;
                    case LogoEditorParser.STRING:
                        this.state = 590;
                        this.match(LogoEditorParser.STRING);
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 591;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 596;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,85,this._ctx);
            }

            this.state = 600;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,86,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 597;
                    this.eol(); 
                }
                this.state = 602;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,86,this._ctx);
            }

            this.state = 609;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,88,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 604;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 603;
                        this.line();
                    }

                    this.state = 606;
                    this.eol(); 
                }
                this.state = 611;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,88,this._ctx);
            }

            this.state = 613;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,89,this._ctx);
            if(la_===1) {
                this.state = 612;
                this.line();

            }
            this.state = 624;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,91,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 618;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 615;
                        this.eol();
                        this.state = 620;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 621;
                    this.end(); 
                }
                this.state = 626;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,91,this._ctx);
            }

            this.state = 630;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,92,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 627;
                    this.eol(); 
                }
                this.state = 632;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,92,this._ctx);
            }

            break;

        case 9:
            this.enterOuterAlt(localctx, 9);
            this.state = 633;
            localctx.PARAMSONELINE = this.match(LogoEditorParser.T__0);
            this.state = 634;
            this.name();

            this.state = 636; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 635;
                this.parameterDeclarations();
                this.state = 638; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.T__44 || _la===LogoEditorParser.PARAMETERDECL);
            this.state = 641; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 640;
                this.eol();
                this.state = 643; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.EOL);
            this.state = 646; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 645;
            		this.parameterDeclarations();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 648; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,95, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            this.state = 654;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,97,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 652;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__44:
                    case LogoEditorParser.PARAMETERDECL:
                        this.state = 650;
                        this.parameterDeclarations();
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 651;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 656;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,97,this._ctx);
            }

            this.state = 660;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,98,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 657;
                    this.eol(); 
                }
                this.state = 662;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,98,this._ctx);
            }

            this.state = 669;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,100,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 664;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 663;
                        this.line();
                    }

                    this.state = 666;
                    this.eol(); 
                }
                this.state = 671;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,100,this._ctx);
            }

            this.state = 673;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,101,this._ctx);
            if(la_===1) {
                this.state = 672;
                this.line();

            }
            this.state = 684;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,103,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 678;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 675;
                        this.eol();
                        this.state = 680;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 681;
                    this.end(); 
                }
                this.state = 686;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,103,this._ctx);
            }

            this.state = 690;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,104,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 687;
                    this.eol(); 
                }
                this.state = 692;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,104,this._ctx);
            }

            break;

        case 10:
            this.enterOuterAlt(localctx, 10);
            this.state = 693;
            localctx.EOLAFTERTO = this.match(LogoEditorParser.T__0);
            this.state = 695; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 694;
                this.eol();
                this.state = 697; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.EOL);
            this.state = 699;
            this.name();
            this.state = 703;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,106,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 700;
                    this.eol(); 
                }
                this.state = 705;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,106,this._ctx);
            }

            this.state = 715;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,109,this._ctx);
            if(la_===1) {
                this.state = 706;
                this.parameterDeclarations();
                this.state = 712;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,108,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 710;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 707;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 708;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 709;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 714;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,108,this._ctx);
                }


            }
            this.state = 720;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,110,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 717;
                    this.eol(); 
                }
                this.state = 722;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,110,this._ctx);
            }

            this.state = 729;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,112,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 724;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 723;
                        this.line();
                    }

                    this.state = 726;
                    this.eol(); 
                }
                this.state = 731;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,112,this._ctx);
            }

            this.state = 733;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,113,this._ctx);
            if(la_===1) {
                this.state = 732;
                this.line();

            }
            this.state = 744;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,115,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 738;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 735;
                        this.eol();
                        this.state = 740;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 741;
                    this.end(); 
                }
                this.state = 746;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,115,this._ctx);
            }

            this.state = 750;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,116,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 747;
                    this.eol(); 
                }
                this.state = 752;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,116,this._ctx);
            }

            break;

        case 11:
            this.enterOuterAlt(localctx, 11);
            this.state = 753;
            localctx.NOEOLBEFOREEND = this.match(LogoEditorParser.T__0);
            this.state = 754;
            this.name();
            this.state = 758;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.T__44 || _la===LogoEditorParser.PARAMETERDECL) {
                this.state = 755;
                this.parameterDeclarations();
                this.state = 760;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 777;
            _la = this._input.LA(1);
            if(_la===LogoEditorParser.EOL) {
                this.state = 762; 
                this._errHandler.sync(this);
                var _alt = 1;
                do {
                	switch (_alt) {
                	case 1:
                		this.state = 761;
                		this.eol();
                		break;
                	default:
                		throw new antlr4.error.NoViableAltException(this);
                	}
                	this.state = 764; 
                	this._errHandler.sync(this);
                	_alt = this._interp.adaptivePredict(this._input,118, this._ctx);
                } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
                this.state = 772;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,120,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 767;
                        _la = this._input.LA(1);
                        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                            this.state = 766;
                            this.line();
                        }

                        this.state = 769;
                        this.eol(); 
                    }
                    this.state = 774;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,120,this._ctx);
                }

                this.state = 775;
                this.line();
            }

            this.state = 779;
            this.end();
            this.state = 783;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,122,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 780;
                    this.eol(); 
                }
                this.state = 785;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,122,this._ctx);
            }

            break;

        case 12:
            this.enterOuterAlt(localctx, 12);
            this.state = 786;
            localctx.PARAMSNOCOLON = this.match(LogoEditorParser.T__0);
            this.state = 787;
            this.name();
            this.state = 791;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.STRING) {
                this.state = 788;
                this.match(LogoEditorParser.STRING);
                this.state = 793;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 794;
            this.parameterDeclarations();
            this.state = 799;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,125,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 797;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__44:
                    case LogoEditorParser.PARAMETERDECL:
                        this.state = 795;
                        this.parameterDeclarations();
                        break;
                    case LogoEditorParser.STRING:
                        this.state = 796;
                        this.match(LogoEditorParser.STRING);
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 801;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,125,this._ctx);
            }

            this.state = 802;
            this.match(LogoEditorParser.STRING);
            this.state = 807;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,127,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 805;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__44:
                    case LogoEditorParser.PARAMETERDECL:
                        this.state = 803;
                        this.parameterDeclarations();
                        break;
                    case LogoEditorParser.STRING:
                        this.state = 804;
                        this.match(LogoEditorParser.STRING);
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 809;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,127,this._ctx);
            }

            this.state = 813;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,128,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 810;
                    this.eol(); 
                }
                this.state = 815;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,128,this._ctx);
            }

            this.state = 822;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,130,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 817;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 816;
                        this.line();
                    }

                    this.state = 819;
                    this.eol(); 
                }
                this.state = 824;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,130,this._ctx);
            }

            this.state = 826;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,131,this._ctx);
            if(la_===1) {
                this.state = 825;
                this.line();

            }
            this.state = 837;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,133,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 831;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 828;
                        this.eol();
                        this.state = 833;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 834;
                    this.end(); 
                }
                this.state = 839;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,133,this._ctx);
            }

            this.state = 843;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,134,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 840;
                    this.eol(); 
                }
                this.state = 845;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,134,this._ctx);
            }

            break;

        case 13:
            this.enterOuterAlt(localctx, 13);
            this.state = 846;
            localctx.NOEOL = this.match(LogoEditorParser.T__0);
            this.state = 847;
            this.name();
            this.state = 851;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.T__44 || _la===LogoEditorParser.PARAMETERDECL) {
                this.state = 848;
                this.parameterDeclarations();
                this.state = 853;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 854;
            this.line();
            this.state = 861;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,137,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 855;
                    this.eol();
                    this.state = 857;
                    this._errHandler.sync(this);
                    var la_ = this._interp.adaptivePredict(this._input,136,this._ctx);
                    if(la_===1) {
                        this.state = 856;
                        this.line();

                    } 
                }
                this.state = 863;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,137,this._ctx);
            }

            this.state = 873;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,139,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 867;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 864;
                        this.eol();
                        this.state = 869;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 870;
                    this.end(); 
                }
                this.state = 875;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,139,this._ctx);
            }

            this.state = 879;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,140,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 876;
                    this.eol(); 
                }
                this.state = 881;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,140,this._ctx);
            }

            break;

        case 14:
            this.enterOuterAlt(localctx, 14);
            this.state = 882;
            localctx.MANYENDS = this.match(LogoEditorParser.T__0);
            this.state = 883;
            this.name();
            this.state = 887;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.T__44 || _la===LogoEditorParser.PARAMETERDECL) {
                this.state = 884;
                this.parameterDeclarations();
                this.state = 889;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 893;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,142,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 890;
                    this.eol(); 
                }
                this.state = 895;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,142,this._ctx);
            }

            this.state = 902;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,144,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 897;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 896;
                        this.line();
                    }

                    this.state = 899;
                    this.eol(); 
                }
                this.state = 904;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,144,this._ctx);
            }

            this.state = 906;
            _la = this._input.LA(1);
            if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                this.state = 905;
                this.line();
            }

            this.state = 908;
            this.end();
            this.state = 912;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LogoEditorParser.EOL) {
                this.state = 909;
                this.eol();
                this.state = 914;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 915;
            this.end();
            this.state = 920;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,148,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 918;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__101:
                        this.state = 916;
                        this.end();
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 917;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 922;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,148,this._ctx);
            }

            this.state = 926;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,149,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 923;
                    this.eol(); 
                }
                this.state = 928;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,149,this._ctx);
            }

            break;

        case 15:
            this.enterOuterAlt(localctx, 15);
            this.state = 929;
            localctx.MISSPELLEDTO = this.maybeTo();
            this.state = 930;
            this.name();
            this.state = 934;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,150,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 931;
                    this.eol(); 
                }
                this.state = 936;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,150,this._ctx);
            }

            this.state = 946;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,153,this._ctx);
            if(la_===1) {
                this.state = 937;
                this.parameterDeclarations();
                this.state = 943;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,152,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 941;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 938;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 939;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 940;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 945;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,152,this._ctx);
                }


            }
            this.state = 951;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,154,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 948;
                    this.eol(); 
                }
                this.state = 953;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,154,this._ctx);
            }

            this.state = 960;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,156,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 955;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 954;
                        this.line();
                    }

                    this.state = 957;
                    this.eol(); 
                }
                this.state = 962;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,156,this._ctx);
            }

            this.state = 964;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,157,this._ctx);
            if(la_===1) {
                this.state = 963;
                this.line();

            }
            this.state = 975;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,159,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 969;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 966;
                        this.eol();
                        this.state = 971;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 972;
                    this.end(); 
                }
                this.state = 977;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,159,this._ctx);
            }

            this.state = 981;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,160,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 978;
                    this.eol(); 
                }
                this.state = 983;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,160,this._ctx);
            }

            break;

        case 16:
            this.enterOuterAlt(localctx, 16);
            this.state = 984;
            localctx.MISSINGTO = this.name();
            this.state = 988;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,161,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 985;
                    this.eol(); 
                }
                this.state = 990;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,161,this._ctx);
            }

            this.state = 1000;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,164,this._ctx);
            if(la_===1) {
                this.state = 991;
                this.parameterDeclarations();
                this.state = 997;
                this._errHandler.sync(this);
                var _alt = this._interp.adaptivePredict(this._input,163,this._ctx)
                while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                    if(_alt===1) {
                        this.state = 995;
                        switch(this._input.LA(1)) {
                        case LogoEditorParser.T__44:
                        case LogoEditorParser.PARAMETERDECL:
                            this.state = 992;
                            this.parameterDeclarations();
                            break;
                        case LogoEditorParser.STRING:
                            this.state = 993;
                            this.match(LogoEditorParser.STRING);
                            break;
                        case LogoEditorParser.EOL:
                            this.state = 994;
                            this.eol();
                            break;
                        default:
                            throw new antlr4.error.NoViableAltException(this);
                        } 
                    }
                    this.state = 999;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input,163,this._ctx);
                }


            }
            this.state = 1005;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,165,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1002;
                    this.eol(); 
                }
                this.state = 1007;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,165,this._ctx);
            }

            this.state = 1014;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,167,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1009;
                    _la = this._input.LA(1);
                    if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29))) !== 0) || ((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LogoEditorParser.T__78 - 79)) | (1 << (LogoEditorParser.T__79 - 79)) | (1 << (LogoEditorParser.T__80 - 79)) | (1 << (LogoEditorParser.T__81 - 79)) | (1 << (LogoEditorParser.T__82 - 79)) | (1 << (LogoEditorParser.T__83 - 79)) | (1 << (LogoEditorParser.T__84 - 79)) | (1 << (LogoEditorParser.T__85 - 79)) | (1 << (LogoEditorParser.T__86 - 79)) | (1 << (LogoEditorParser.T__87 - 79)) | (1 << (LogoEditorParser.T__88 - 79)) | (1 << (LogoEditorParser.T__89 - 79)) | (1 << (LogoEditorParser.T__90 - 79)) | (1 << (LogoEditorParser.T__91 - 79)) | (1 << (LogoEditorParser.T__92 - 79)) | (1 << (LogoEditorParser.T__99 - 79)) | (1 << (LogoEditorParser.STRING - 79)) | (1 << (LogoEditorParser.COMMENT - 79)))) !== 0)) {
                        this.state = 1008;
                        this.line();
                    }

                    this.state = 1011;
                    this.eol(); 
                }
                this.state = 1016;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,167,this._ctx);
            }

            this.state = 1018;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,168,this._ctx);
            if(la_===1) {
                this.state = 1017;
                this.line();

            }
            this.state = 1029;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,170,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1023;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la===LogoEditorParser.EOL) {
                        this.state = 1020;
                        this.eol();
                        this.state = 1025;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 1026;
                    this.end(); 
                }
                this.state = 1031;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,170,this._ctx);
            }

            this.state = 1035;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,171,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1032;
                    this.eol(); 
                }
                this.state = 1037;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,171,this._ctx);
            }

            break;

        case 17:
            this.enterOuterAlt(localctx, 17);
            this.state = 1039; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1038;
            		localctx.NOTONONAME = this.parameterDeclarations();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1041; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,172, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            this.state = 1047;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,174,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1045;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__44:
                    case LogoEditorParser.PARAMETERDECL:
                        this.state = 1043;
                        this.parameterDeclarations();
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 1044;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 1049;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,174,this._ctx);
            }

            this.state = 1058;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,176,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1050;
                    this.line();
                    this.state = 1052; 
                    this._errHandler.sync(this);
                    var _alt = 1;
                    do {
                    	switch (_alt) {
                    	case 1:
                    		this.state = 1051;
                    		this.eol();
                    		break;
                    	default:
                    		throw new antlr4.error.NoViableAltException(this);
                    	}
                    	this.state = 1054; 
                    	this._errHandler.sync(this);
                    	_alt = this._interp.adaptivePredict(this._input,175, this._ctx);
                    } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER ); 
                }
                this.state = 1060;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,176,this._ctx);
            }

            this.state = 1062;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,177,this._ctx);
            if(la_===1) {
                this.state = 1061;
                this.line();

            }
            this.state = 1068;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,179,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1066;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__101:
                        this.state = 1064;
                        this.end();
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 1065;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 1070;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,179,this._ctx);
            }

            break;

        case 18:
            this.enterOuterAlt(localctx, 18);
            this.state = 1071;
            localctx.NOTONONAMETOO = this.line();
            this.state = 1082;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,182,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1073; 
                    this._errHandler.sync(this);
                    var _alt = 1;
                    do {
                    	switch (_alt) {
                    	case 1:
                    		this.state = 1072;
                    		this.eol();
                    		break;
                    	default:
                    		throw new antlr4.error.NoViableAltException(this);
                    	}
                    	this.state = 1075; 
                    	this._errHandler.sync(this);
                    	_alt = this._interp.adaptivePredict(this._input,180, this._ctx);
                    } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
                    this.state = 1078;
                    this._errHandler.sync(this);
                    var la_ = this._interp.adaptivePredict(this._input,181,this._ctx);
                    if(la_===1) {
                        this.state = 1077;
                        this.line();

                    } 
                }
                this.state = 1084;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,182,this._ctx);
            }

            this.state = 1089;
            this._errHandler.sync(this);
            var _alt = this._interp.adaptivePredict(this._input,184,this._ctx)
            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
                if(_alt===1) {
                    this.state = 1087;
                    switch(this._input.LA(1)) {
                    case LogoEditorParser.T__101:
                        this.state = 1085;
                        this.end();
                        break;
                    case LogoEditorParser.EOL:
                        this.state = 1086;
                        this.eol();
                        break;
                    default:
                        throw new antlr4.error.NoViableAltException(this);
                    } 
                }
                this.state = 1091;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input,184,this._ctx);
            }

            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ParameterDeclarationsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_parameterDeclarations;
    this.PARAMDECLOK = null; // Token
    this.PARAMDECLNOTOK = null; // Token
    this.PARAMDECLNONAME = null; // Token
    return this;
}

ParameterDeclarationsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParameterDeclarationsContext.prototype.constructor = ParameterDeclarationsContext;

ParameterDeclarationsContext.prototype.PARAMETERDECL = function() {
    return this.getToken(LogoEditorParser.PARAMETERDECL, 0);
};

ParameterDeclarationsContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

ParameterDeclarationsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterParameterDeclarations(this);
	}
};

ParameterDeclarationsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitParameterDeclarations(this);
	}
};

ParameterDeclarationsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitParameterDeclarations(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ParameterDeclarationsContext = ParameterDeclarationsContext;

LogoEditorParser.prototype.parameterDeclarations = function() {

    var localctx = new ParameterDeclarationsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, LogoEditorParser.RULE_parameterDeclarations);
    try {
        this.state = 1098;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,186,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1094;
            localctx.PARAMDECLOK = this.match(LogoEditorParser.PARAMETERDECL);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1095;
            localctx.PARAMDECLNOTOK = this.match(LogoEditorParser.T__44);
            this.state = 1096;
            this.match(LogoEditorParser.STRING);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1097;
            localctx.PARAMDECLNONAME = this.match(LogoEditorParser.T__44);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ColornameWithoutTypingErrorsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_colornameWithoutTypingErrors;
    this.COLORNAMEOK = null; // Token
    return this;
}

ColornameWithoutTypingErrorsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColornameWithoutTypingErrorsContext.prototype.constructor = ColornameWithoutTypingErrorsContext;


ColornameWithoutTypingErrorsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterColornameWithoutTypingErrors(this);
	}
};

ColornameWithoutTypingErrorsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitColornameWithoutTypingErrors(this);
	}
};

ColornameWithoutTypingErrorsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitColornameWithoutTypingErrors(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ColornameWithoutTypingErrorsContext = ColornameWithoutTypingErrorsContext;

LogoEditorParser.prototype.colornameWithoutTypingErrors = function() {

    var localctx = new ColornameWithoutTypingErrorsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, LogoEditorParser.RULE_colornameWithoutTypingErrors);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1100;
        localctx.COLORNAMEOK = this._input.LT(1);
        _la = this._input.LA(1);
        if(!(((((_la - 46)) & ~0x1f) == 0 && ((1 << (_la - 46)) & ((1 << (LogoEditorParser.T__45 - 46)) | (1 << (LogoEditorParser.T__46 - 46)) | (1 << (LogoEditorParser.T__47 - 46)) | (1 << (LogoEditorParser.T__48 - 46)) | (1 << (LogoEditorParser.T__49 - 46)) | (1 << (LogoEditorParser.T__50 - 46)) | (1 << (LogoEditorParser.T__51 - 46)) | (1 << (LogoEditorParser.T__52 - 46)) | (1 << (LogoEditorParser.T__53 - 46)) | (1 << (LogoEditorParser.T__54 - 46)) | (1 << (LogoEditorParser.T__55 - 46)) | (1 << (LogoEditorParser.T__56 - 46)) | (1 << (LogoEditorParser.T__57 - 46)) | (1 << (LogoEditorParser.T__58 - 46)) | (1 << (LogoEditorParser.T__59 - 46)) | (1 << (LogoEditorParser.T__60 - 46)) | (1 << (LogoEditorParser.T__61 - 46)))) !== 0))) {
            localctx.COLORNAMEOK = this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FuncContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_func;
    this.FUNCOK = null; // RandomContext
    return this;
}

FuncContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FuncContext.prototype.constructor = FuncContext;

FuncContext.prototype.random = function() {
    return this.getTypedRuleContext(RandomContext,0);
};

FuncContext.prototype.sin = function() {
    return this.getTypedRuleContext(SinContext,0);
};

FuncContext.prototype.cos = function() {
    return this.getTypedRuleContext(CosContext,0);
};

FuncContext.prototype.tan = function() {
    return this.getTypedRuleContext(TanContext,0);
};

FuncContext.prototype.arcsin = function() {
    return this.getTypedRuleContext(ArcsinContext,0);
};

FuncContext.prototype.arccos = function() {
    return this.getTypedRuleContext(ArccosContext,0);
};

FuncContext.prototype.arctan = function() {
    return this.getTypedRuleContext(ArctanContext,0);
};

FuncContext.prototype.abs = function() {
    return this.getTypedRuleContext(AbsContext,0);
};

FuncContext.prototype.sqrt = function() {
    return this.getTypedRuleContext(SqrtContext,0);
};

FuncContext.prototype.mod = function() {
    return this.getTypedRuleContext(ModContext,0);
};

FuncContext.prototype.power = function() {
    return this.getTypedRuleContext(PowerContext,0);
};

FuncContext.prototype.log10 = function() {
    return this.getTypedRuleContext(Log10Context,0);
};

FuncContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterFunc(this);
	}
};

FuncContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitFunc(this);
	}
};

FuncContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitFunc(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.FuncContext = FuncContext;

LogoEditorParser.prototype.func = function() {

    var localctx = new FuncContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, LogoEditorParser.RULE_func);
    try {
        this.state = 1114;
        switch(this._input.LA(1)) {
        case LogoEditorParser.T__30:
        case LogoEditorParser.T__93:
        case LogoEditorParser.T__94:
            this.enterOuterAlt(localctx, 1);
            this.state = 1102;
            localctx.FUNCOK = this.random();
            break;
        case LogoEditorParser.T__31:
            this.enterOuterAlt(localctx, 2);
            this.state = 1103;
            this.sin();
            break;
        case LogoEditorParser.T__32:
            this.enterOuterAlt(localctx, 3);
            this.state = 1104;
            this.cos();
            break;
        case LogoEditorParser.T__33:
            this.enterOuterAlt(localctx, 4);
            this.state = 1105;
            this.tan();
            break;
        case LogoEditorParser.T__34:
        case LogoEditorParser.T__95:
            this.enterOuterAlt(localctx, 5);
            this.state = 1106;
            this.arcsin();
            break;
        case LogoEditorParser.T__35:
        case LogoEditorParser.T__96:
            this.enterOuterAlt(localctx, 6);
            this.state = 1107;
            this.arccos();
            break;
        case LogoEditorParser.T__36:
        case LogoEditorParser.T__97:
            this.enterOuterAlt(localctx, 7);
            this.state = 1108;
            this.arctan();
            break;
        case LogoEditorParser.T__37:
            this.enterOuterAlt(localctx, 8);
            this.state = 1109;
            this.abs();
            break;
        case LogoEditorParser.T__38:
            this.enterOuterAlt(localctx, 9);
            this.state = 1110;
            this.sqrt();
            break;
        case LogoEditorParser.T__39:
            this.enterOuterAlt(localctx, 10);
            this.state = 1111;
            this.mod();
            break;
        case LogoEditorParser.T__40:
            this.enterOuterAlt(localctx, 11);
            this.state = 1112;
            this.power();
            break;
        case LogoEditorParser.T__41:
        case LogoEditorParser.T__98:
            this.enterOuterAlt(localctx, 12);
            this.state = 1113;
            this.log10();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RepeatContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_repeat;
    this.REPEATOK = null; // Token
    this.REPEATMISSINGEXPR = null; // Token
    this.REPEATNOBRACKETS = null; // Token
    this.REPEATMISSINGBLOCK = null; // Token
    this.REPEATNOARG = null; // Token
    return this;
}

RepeatContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RepeatContext.prototype.constructor = RepeatContext;

RepeatContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

RepeatContext.prototype.block = function() {
    return this.getTypedRuleContext(BlockContext,0);
};

RepeatContext.prototype.cmd = function() {
    return this.getTypedRuleContext(CmdContext,0);
};

RepeatContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterRepeat(this);
	}
};

RepeatContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitRepeat(this);
	}
};

RepeatContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitRepeat(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.RepeatContext = RepeatContext;

LogoEditorParser.prototype.repeat = function() {

    var localctx = new RepeatContext(this, this._ctx, this.state);
    this.enterRule(localctx, 16, LogoEditorParser.RULE_repeat);
    try {
        this.state = 1129;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,188,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1116;
            localctx.REPEATOK = this.match(LogoEditorParser.T__1);
            this.state = 1117;
            this.expression();
            this.state = 1118;
            this.block();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1120;
            localctx.REPEATMISSINGEXPR = this.match(LogoEditorParser.T__1);
            this.state = 1121;
            this.block();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1122;
            localctx.REPEATNOBRACKETS = this.match(LogoEditorParser.T__1);
            this.state = 1123;
            this.expression();
            this.state = 1124;
            this.cmd();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1126;
            localctx.REPEATMISSINGBLOCK = this.match(LogoEditorParser.T__1);
            this.state = 1127;
            this.expression();
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 1128;
            localctx.REPEATNOARG = this.match(LogoEditorParser.T__1);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WhileeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_whilee;
    this.WHILEOK = null; // Token
    this.WHILEMISSINGBLOCK = null; // Token
    this.WHILEMANYBLOCKS = null; // Token
    this.WHILEMISSINGBOTHPAREN = null; // Token
    this.WHILENOARGS = null; // Token
    return this;
}

WhileeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WhileeContext.prototype.constructor = WhileeContext;

WhileeContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

WhileeContext.prototype.block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(BlockContext);
    } else {
        return this.getTypedRuleContext(BlockContext,i);
    }
};

WhileeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterWhilee(this);
	}
};

WhileeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitWhilee(this);
	}
};

WhileeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitWhilee(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.WhileeContext = WhileeContext;

LogoEditorParser.prototype.whilee = function() {

    var localctx = new WhileeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, LogoEditorParser.RULE_whilee);
    var _la = 0; // Token type
    try {
        this.state = 1158;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,191,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1131;
            localctx.WHILEOK = this.match(LogoEditorParser.T__24);
            this.state = 1132;
            this.match(LogoEditorParser.T__62);
            this.state = 1133;
            this.expression();
            this.state = 1134;
            this.match(LogoEditorParser.T__63);
            this.state = 1135;
            this.block();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1137;
            localctx.WHILEMISSINGBLOCK = this.match(LogoEditorParser.T__24);
            this.state = 1138;
            this.match(LogoEditorParser.T__62);
            this.state = 1139;
            this.expression();
            this.state = 1140;
            this.match(LogoEditorParser.T__63);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1142;
            localctx.WHILEMANYBLOCKS = this.match(LogoEditorParser.T__24);
            this.state = 1143;
            this.match(LogoEditorParser.T__62);
            this.state = 1144;
            this.expression();
            this.state = 1145;
            this.match(LogoEditorParser.T__63);
            this.state = 1146;
            this.block();
            this.state = 1148; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 1147;
                this.block();
                this.state = 1150; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.T__62);
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1152;
            localctx.WHILEMISSINGBOTHPAREN = this.match(LogoEditorParser.T__24);
            this.state = 1153;
            this.expression();
            this.state = 1155;
            _la = this._input.LA(1);
            if(_la===LogoEditorParser.T__62) {
                this.state = 1154;
                this.block();
            }

            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 1157;
            localctx.WHILENOARGS = this.match(LogoEditorParser.T__24);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function BlockContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_block;
    this.BLOCKOK = null; // Token
    return this;
}

BlockContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BlockContext.prototype.constructor = BlockContext;

BlockContext.prototype.eol = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(EolContext);
    } else {
        return this.getTypedRuleContext(EolContext,i);
    }
};

BlockContext.prototype.cmd = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(CmdContext);
    } else {
        return this.getTypedRuleContext(CmdContext,i);
    }
};

BlockContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterBlock(this);
	}
};

BlockContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitBlock(this);
	}
};

BlockContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitBlock(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.BlockContext = BlockContext;

LogoEditorParser.prototype.block = function() {

    var localctx = new BlockContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, LogoEditorParser.RULE_block);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1160;
        localctx.BLOCKOK = this.match(LogoEditorParser.T__62);
        this.state = 1164;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,192,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 1161;
                this.eol(); 
            }
            this.state = 1166;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,192,this._ctx);
        }

        this.state = 1171;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,194,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 1169;
                switch(this._input.LA(1)) {
                case LogoEditorParser.T__1:
                case LogoEditorParser.T__2:
                case LogoEditorParser.T__3:
                case LogoEditorParser.T__4:
                case LogoEditorParser.T__5:
                case LogoEditorParser.T__6:
                case LogoEditorParser.T__7:
                case LogoEditorParser.T__8:
                case LogoEditorParser.T__9:
                case LogoEditorParser.T__10:
                case LogoEditorParser.T__11:
                case LogoEditorParser.T__12:
                case LogoEditorParser.T__13:
                case LogoEditorParser.T__14:
                case LogoEditorParser.T__15:
                case LogoEditorParser.T__16:
                case LogoEditorParser.T__17:
                case LogoEditorParser.T__18:
                case LogoEditorParser.T__19:
                case LogoEditorParser.T__20:
                case LogoEditorParser.T__21:
                case LogoEditorParser.T__22:
                case LogoEditorParser.T__23:
                case LogoEditorParser.T__24:
                case LogoEditorParser.T__25:
                case LogoEditorParser.T__26:
                case LogoEditorParser.T__27:
                case LogoEditorParser.T__28:
                case LogoEditorParser.T__29:
                case LogoEditorParser.T__78:
                case LogoEditorParser.T__79:
                case LogoEditorParser.T__80:
                case LogoEditorParser.T__81:
                case LogoEditorParser.T__82:
                case LogoEditorParser.T__83:
                case LogoEditorParser.T__84:
                case LogoEditorParser.T__85:
                case LogoEditorParser.T__86:
                case LogoEditorParser.T__87:
                case LogoEditorParser.T__88:
                case LogoEditorParser.T__89:
                case LogoEditorParser.T__90:
                case LogoEditorParser.T__91:
                case LogoEditorParser.T__92:
                case LogoEditorParser.T__99:
                case LogoEditorParser.STRING:
                    this.state = 1167;
                    this.cmd();
                    break;
                case LogoEditorParser.EOL:
                    this.state = 1168;
                    this.eol();
                    break;
                default:
                    throw new antlr4.error.NoViableAltException(this);
                } 
            }
            this.state = 1173;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,194,this._ctx);
        }

        this.state = 1177;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===LogoEditorParser.EOL) {
            this.state = 1174;
            this.eol();
            this.state = 1179;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 1180;
        this.match(LogoEditorParser.T__63);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function IfeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_ife;
    this.IFOK = null; // Token
    this.IFELSEOK = null; // Token
    this.IFNOBLOCK = null; // Token
    this.IFMANYBLOCKS = null; // Token
    this.IFBRACKETS = null; // Token
    this.IFNOARGS = null; // Token
    return this;
}

IfeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
IfeContext.prototype.constructor = IfeContext;

IfeContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

IfeContext.prototype.block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(BlockContext);
    } else {
        return this.getTypedRuleContext(BlockContext,i);
    }
};

IfeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterIfe(this);
	}
};

IfeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitIfe(this);
	}
};

IfeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitIfe(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.IfeContext = IfeContext;

LogoEditorParser.prototype.ife = function() {

    var localctx = new IfeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, LogoEditorParser.RULE_ife);
    var _la = 0; // Token type
    try {
        this.state = 1213;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,198,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1182;
            localctx.IFOK = this.match(LogoEditorParser.T__21);
            this.state = 1183;
            this.expression();
            this.state = 1184;
            this.block();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1186;
            localctx.IFELSEOK = this.match(LogoEditorParser.T__21);
            this.state = 1187;
            this.expression();
            this.state = 1188;
            this.block();
            this.state = 1189;
            this.block();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1191;
            localctx.IFNOBLOCK = this.match(LogoEditorParser.T__21);
            this.state = 1192;
            this.expression();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1193;
            localctx.IFMANYBLOCKS = this.match(LogoEditorParser.T__21);
            this.state = 1194;
            this.expression();
            this.state = 1195;
            this.block();
            this.state = 1196;
            this.block();
            this.state = 1198; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 1197;
                this.block();
                this.state = 1200; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LogoEditorParser.T__62);
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 1202;
            localctx.IFBRACKETS = this.match(LogoEditorParser.T__21);

            this.state = 1203;
            this.match(LogoEditorParser.T__62);
            this.state = 1204;
            this.expression();

            this.state = 1205;
            this.match(LogoEditorParser.T__63);
            this.state = 1210;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,197,this._ctx);
            if(la_===1) {
                this.state = 1206;
                this.block();

            } else if(la_===2) {
                this.state = 1207;
                this.block();
                this.state = 1208;
                this.block();

            }
            break;

        case 6:
            this.enterOuterAlt(localctx, 6);
            this.state = 1212;
            localctx.IFNOARGS = this.match(LogoEditorParser.T__21);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ExpressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_expression;
    return this;
}

ExpressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExpressionContext.prototype.constructor = ExpressionContext;

ExpressionContext.prototype.number = function() {
    return this.getTypedRuleContext(NumberContext,0);
};

ExpressionContext.prototype.sExpr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(SExprContext);
    } else {
        return this.getTypedRuleContext(SExprContext,i);
    }
};

ExpressionContext.prototype.comparisonOperator = function() {
    return this.getTypedRuleContext(ComparisonOperatorContext,0);
};

ExpressionContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterExpression(this);
	}
};

ExpressionContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitExpression(this);
	}
};

ExpressionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitExpression(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ExpressionContext = ExpressionContext;

LogoEditorParser.prototype.expression = function() {

    var localctx = new ExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, LogoEditorParser.RULE_expression);
    try {
        this.state = 1222;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,200,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1215;
            this.number();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1216;
            this.sExpr();
            this.state = 1220;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,199,this._ctx);
            if(la_===1) {
                this.state = 1217;
                this.comparisonOperator();
                this.state = 1218;
                this.sExpr();

            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ComparisonOperatorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_comparisonOperator;
    return this;
}

ComparisonOperatorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ComparisonOperatorContext.prototype.constructor = ComparisonOperatorContext;


ComparisonOperatorContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterComparisonOperator(this);
	}
};

ComparisonOperatorContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitComparisonOperator(this);
	}
};

ComparisonOperatorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitComparisonOperator(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ComparisonOperatorContext = ComparisonOperatorContext;

LogoEditorParser.prototype.comparisonOperator = function() {

    var localctx = new ComparisonOperatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, LogoEditorParser.RULE_comparisonOperator);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1224;
        _la = this._input.LA(1);
        if(!(((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (LogoEditorParser.T__64 - 65)) | (1 << (LogoEditorParser.T__65 - 65)) | (1 << (LogoEditorParser.T__66 - 65)) | (1 << (LogoEditorParser.T__67 - 65)) | (1 << (LogoEditorParser.T__68 - 65)) | (1 << (LogoEditorParser.T__69 - 65)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_sExpr;
    return this;
}

SExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SExprContext.prototype.constructor = SExprContext;

SExprContext.prototype.term = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TermContext);
    } else {
        return this.getTypedRuleContext(TermContext,i);
    }
};

SExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSExpr(this);
	}
};

SExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSExpr(this);
	}
};

SExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SExprContext = SExprContext;

LogoEditorParser.prototype.sExpr = function() {

    var localctx = new SExprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, LogoEditorParser.RULE_sExpr);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1226;
        this.term();
        this.state = 1231;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,201,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 1227;
                _la = this._input.LA(1);
                if(!(((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoEditorParser.T__70 - 71)) | (1 << (LogoEditorParser.T__71 - 71)) | (1 << (LogoEditorParser.T__72 - 71)))) !== 0))) {
                this._errHandler.recoverInline(this);
                }
                else {
                    this.consume();
                }
                this.state = 1228;
                this.term(); 
            }
            this.state = 1233;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,201,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function TermContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_term;
    return this;
}

TermContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TermContext.prototype.constructor = TermContext;

TermContext.prototype.factor = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(FactorContext);
    } else {
        return this.getTypedRuleContext(FactorContext,i);
    }
};

TermContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterTerm(this);
	}
};

TermContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitTerm(this);
	}
};

TermContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitTerm(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.TermContext = TermContext;

LogoEditorParser.prototype.term = function() {

    var localctx = new TermContext(this, this._ctx, this.state);
    this.enterRule(localctx, 30, LogoEditorParser.RULE_term);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1234;
        this.factor();
        this.state = 1239;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,202,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 1235;
                _la = this._input.LA(1);
                if(!(((((_la - 74)) & ~0x1f) == 0 && ((1 << (_la - 74)) & ((1 << (LogoEditorParser.T__73 - 74)) | (1 << (LogoEditorParser.T__74 - 74)) | (1 << (LogoEditorParser.T__75 - 74)))) !== 0))) {
                this._errHandler.recoverInline(this);
                }
                else {
                    this.consume();
                }
                this.state = 1236;
                this.factor(); 
            }
            this.state = 1241;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,202,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FactorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_factor;
    return this;
}

FactorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FactorContext.prototype.constructor = FactorContext;

FactorContext.prototype.nsFact = function() {
    return this.getTypedRuleContext(NsFactContext,0);
};

FactorContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterFactor(this);
	}
};

FactorContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitFactor(this);
	}
};

FactorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitFactor(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.FactorContext = FactorContext;

LogoEditorParser.prototype.factor = function() {

    var localctx = new FactorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, LogoEditorParser.RULE_factor);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1243;
        _la = this._input.LA(1);
        if(_la===LogoEditorParser.T__70 || _la===LogoEditorParser.T__71) {
            this.state = 1242;
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__70 || _la===LogoEditorParser.T__71)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
        }

        this.state = 1245;
        this.nsFact();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NsFactContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_nsFact;
    return this;
}

NsFactContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NsFactContext.prototype.constructor = NsFactContext;

NsFactContext.prototype.number = function() {
    return this.getTypedRuleContext(NumberContext,0);
};

NsFactContext.prototype.deref = function() {
    return this.getTypedRuleContext(DerefContext,0);
};

NsFactContext.prototype.func = function() {
    return this.getTypedRuleContext(FuncContext,0);
};

NsFactContext.prototype.LPAREN = function() {
    return this.getToken(LogoEditorParser.LPAREN, 0);
};

NsFactContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

NsFactContext.prototype.RPAREN = function() {
    return this.getToken(LogoEditorParser.RPAREN, 0);
};

NsFactContext.prototype.factor = function() {
    return this.getTypedRuleContext(FactorContext,0);
};

NsFactContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterNsFact(this);
	}
};

NsFactContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitNsFact(this);
	}
};

NsFactContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitNsFact(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.NsFactContext = NsFactContext;

LogoEditorParser.prototype.nsFact = function() {

    var localctx = new NsFactContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, LogoEditorParser.RULE_nsFact);
    try {
        this.state = 1256;
        switch(this._input.LA(1)) {
        case LogoEditorParser.T__42:
        case LogoEditorParser.T__43:
        case LogoEditorParser.NUMBER:
            this.enterOuterAlt(localctx, 1);
            this.state = 1247;
            this.number();
            break;
        case LogoEditorParser.T__44:
        case LogoEditorParser.T__77:
        case LogoEditorParser.PARAMETERDECL:
        case LogoEditorParser.STRINGLITERAL:
            this.enterOuterAlt(localctx, 2);
            this.state = 1248;
            this.deref();
            break;
        case LogoEditorParser.T__30:
        case LogoEditorParser.T__31:
        case LogoEditorParser.T__32:
        case LogoEditorParser.T__33:
        case LogoEditorParser.T__34:
        case LogoEditorParser.T__35:
        case LogoEditorParser.T__36:
        case LogoEditorParser.T__37:
        case LogoEditorParser.T__38:
        case LogoEditorParser.T__39:
        case LogoEditorParser.T__40:
        case LogoEditorParser.T__41:
        case LogoEditorParser.T__93:
        case LogoEditorParser.T__94:
        case LogoEditorParser.T__95:
        case LogoEditorParser.T__96:
        case LogoEditorParser.T__97:
        case LogoEditorParser.T__98:
            this.enterOuterAlt(localctx, 3);
            this.state = 1249;
            this.func();
            break;
        case LogoEditorParser.LPAREN:
            this.enterOuterAlt(localctx, 4);
            this.state = 1250;
            this.match(LogoEditorParser.LPAREN);
            this.state = 1251;
            this.expression();
            this.state = 1252;
            this.match(LogoEditorParser.RPAREN);
            break;
        case LogoEditorParser.T__76:
            this.enterOuterAlt(localctx, 5);
            this.state = 1254;
            this.match(LogoEditorParser.T__76);
            this.state = 1255;
            this.factor();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ValueContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_value;
    return this;
}

ValueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ValueContext.prototype.constructor = ValueContext;

ValueContext.prototype.STRINGLITERAL = function() {
    return this.getToken(LogoEditorParser.STRINGLITERAL, 0);
};

ValueContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ValueContext.prototype.deref = function() {
    return this.getTypedRuleContext(DerefContext,0);
};

ValueContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterValue(this);
	}
};

ValueContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitValue(this);
	}
};

ValueContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitValue(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ValueContext = ValueContext;

LogoEditorParser.prototype.value = function() {

    var localctx = new ValueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, LogoEditorParser.RULE_value);
    try {
        this.state = 1261;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,205,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1258;
            this.match(LogoEditorParser.STRINGLITERAL);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1259;
            this.expression();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1260;
            this.deref();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function DerefContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_deref;
    this.DEREFOK = null; // Token
    this.DEREFNOTOK = null; // Token
    this.DEREFNONAME = null; // Token
    this.DEREFMAKEONE = null; // Token
    this.DEREFMAKETWO = null; // Token
    return this;
}

DerefContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DerefContext.prototype.constructor = DerefContext;

DerefContext.prototype.PARAMETERDECL = function() {
    return this.getToken(LogoEditorParser.PARAMETERDECL, 0);
};

DerefContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

DerefContext.prototype.STRINGLITERAL = function() {
    return this.getToken(LogoEditorParser.STRINGLITERAL, 0);
};

DerefContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterDeref(this);
	}
};

DerefContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitDeref(this);
	}
};

DerefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitDeref(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.DerefContext = DerefContext;

LogoEditorParser.prototype.deref = function() {

    var localctx = new DerefContext(this, this._ctx, this.state);
    this.enterRule(localctx, 38, LogoEditorParser.RULE_deref);
    try {
        this.state = 1270;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,206,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1263;
            localctx.DEREFOK = this.match(LogoEditorParser.PARAMETERDECL);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1264;
            localctx.DEREFNOTOK = this.match(LogoEditorParser.T__44);
            this.state = 1265;
            this.match(LogoEditorParser.STRING);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1266;
            localctx.DEREFNONAME = this.match(LogoEditorParser.T__44);
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1267;
            localctx.DEREFMAKEONE = this.match(LogoEditorParser.T__77);
            this.state = 1268;
            this.match(LogoEditorParser.STRING);
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 1269;
            localctx.DEREFMAKETWO = this.match(LogoEditorParser.STRINGLITERAL);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ColornameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_colorname;
    this.COLORNAMEOK = null; // Token
    this.COLORNAMENOTOK = null; // Token
    return this;
}

ColornameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColornameContext.prototype.constructor = ColornameContext;

ColornameContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

ColornameContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterColorname(this);
	}
};

ColornameContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitColorname(this);
	}
};

ColornameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitColorname(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ColornameContext = ColornameContext;

LogoEditorParser.prototype.colorname = function() {

    var localctx = new ColornameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 40, LogoEditorParser.RULE_colorname);
    var _la = 0; // Token type
    try {
        this.state = 1274;
        switch(this._input.LA(1)) {
        case LogoEditorParser.T__45:
        case LogoEditorParser.T__46:
        case LogoEditorParser.T__47:
        case LogoEditorParser.T__48:
        case LogoEditorParser.T__49:
        case LogoEditorParser.T__50:
        case LogoEditorParser.T__51:
        case LogoEditorParser.T__52:
        case LogoEditorParser.T__53:
        case LogoEditorParser.T__54:
        case LogoEditorParser.T__55:
        case LogoEditorParser.T__56:
        case LogoEditorParser.T__57:
        case LogoEditorParser.T__58:
        case LogoEditorParser.T__59:
        case LogoEditorParser.T__60:
        case LogoEditorParser.T__61:
            this.enterOuterAlt(localctx, 1);
            this.state = 1272;
            localctx.COLORNAMEOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(((((_la - 46)) & ~0x1f) == 0 && ((1 << (_la - 46)) & ((1 << (LogoEditorParser.T__45 - 46)) | (1 << (LogoEditorParser.T__46 - 46)) | (1 << (LogoEditorParser.T__47 - 46)) | (1 << (LogoEditorParser.T__48 - 46)) | (1 << (LogoEditorParser.T__49 - 46)) | (1 << (LogoEditorParser.T__50 - 46)) | (1 << (LogoEditorParser.T__51 - 46)) | (1 << (LogoEditorParser.T__52 - 46)) | (1 << (LogoEditorParser.T__53 - 46)) | (1 << (LogoEditorParser.T__54 - 46)) | (1 << (LogoEditorParser.T__55 - 46)) | (1 << (LogoEditorParser.T__56 - 46)) | (1 << (LogoEditorParser.T__57 - 46)) | (1 << (LogoEditorParser.T__58 - 46)) | (1 << (LogoEditorParser.T__59 - 46)) | (1 << (LogoEditorParser.T__60 - 46)) | (1 << (LogoEditorParser.T__61 - 46)))) !== 0))) {
                localctx.COLORNAMEOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;
        case LogoEditorParser.STRING:
            this.enterOuterAlt(localctx, 2);
            this.state = 1273;
            localctx.COLORNAMENOTOK = this.match(LogoEditorParser.STRING);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RgbContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_rgb;
    this.RGBOK = null; // Token
    return this;
}

RgbContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RgbContext.prototype.constructor = RgbContext;

RgbContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

RgbContext.prototype.eol = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(EolContext);
    } else {
        return this.getTypedRuleContext(EolContext,i);
    }
};

RgbContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterRgb(this);
	}
};

RgbContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitRgb(this);
	}
};

RgbContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitRgb(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.RgbContext = RgbContext;

LogoEditorParser.prototype.rgb = function() {

    var localctx = new RgbContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, LogoEditorParser.RULE_rgb);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1276;
        localctx.RGBOK = this.match(LogoEditorParser.T__62);
        this.state = 1277;
        this.expression();
        this.state = 1278;
        this.expression();
        this.state = 1279;
        this.expression();
        this.state = 1283;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===LogoEditorParser.EOL) {
            this.state = 1280;
            this.eol();
            this.state = 1285;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 1286;
        this.match(LogoEditorParser.T__63);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ColornumberContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_colornumber;
    return this;
}

ColornumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColornumberContext.prototype.constructor = ColornumberContext;

ColornumberContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ColornumberContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterColornumber(this);
	}
};

ColornumberContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitColornumber(this);
	}
};

ColornumberContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitColornumber(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ColornumberContext = ColornumberContext;

LogoEditorParser.prototype.colornumber = function() {

    var localctx = new ColornumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 44, LogoEditorParser.RULE_colornumber);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1288;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function MakeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_make;
    this.MAKEOK = null; // Token
    this.MAKEMANYVALS = null; // Token
    this.MAKENOVAL = null; // Token
    this.MAKEREVERSE = null; // Token
    this.MAKECOLON = null; // Token
    this.MAKENOLIT = null; // Token
    this.MAKELITNOTOK = null; // Token
    this.MAKESPACEMANYVALS = null; // Token
    this.MAKESPACENOVAL = null; // Token
    this.MAKENOARGS = null; // Token
    return this;
}

MakeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MakeContext.prototype.constructor = MakeContext;

MakeContext.prototype.STRINGLITERAL = function() {
    return this.getToken(LogoEditorParser.STRINGLITERAL, 0);
};

MakeContext.prototype.value = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ValueContext);
    } else {
        return this.getTypedRuleContext(ValueContext,i);
    }
};

MakeContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

MakeContext.prototype.PARAMETERDECL = function() {
    return this.getToken(LogoEditorParser.PARAMETERDECL, 0);
};

MakeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterMake(this);
	}
};

MakeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitMake(this);
	}
};

MakeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitMake(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.MakeContext = MakeContext;

LogoEditorParser.prototype.make = function() {

    var localctx = new MakeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 46, LogoEditorParser.RULE_make);
    try {
        this.state = 1336;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,213,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1290;
            localctx.MAKEOK = this.match(LogoEditorParser.T__20);
            this.state = 1291;
            this.match(LogoEditorParser.STRINGLITERAL);
            this.state = 1292;
            this.value();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1293;
            localctx.MAKEMANYVALS = this.match(LogoEditorParser.T__20);
            this.state = 1294;
            this.match(LogoEditorParser.STRINGLITERAL);
            this.state = 1295;
            this.value();
            this.state = 1297; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1296;
            		this.value();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1299; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,209, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1301;
            localctx.MAKENOVAL = this.match(LogoEditorParser.T__20);
            this.state = 1302;
            this.match(LogoEditorParser.STRINGLITERAL);
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1303;
            localctx.MAKEREVERSE = this.match(LogoEditorParser.T__20);
            this.state = 1304;
            this.value();
            this.state = 1308;
            switch(this._input.LA(1)) {
            case LogoEditorParser.STRINGLITERAL:
                this.state = 1305;
                this.match(LogoEditorParser.STRINGLITERAL);
                break;
            case LogoEditorParser.T__77:
                this.state = 1306;
                this.match(LogoEditorParser.T__77);
                this.state = 1307;
                this.match(LogoEditorParser.STRING);
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 1310;
            localctx.MAKECOLON = this.match(LogoEditorParser.T__20);
            this.state = 1314;
            switch(this._input.LA(1)) {
            case LogoEditorParser.PARAMETERDECL:
                this.state = 1311;
                this.match(LogoEditorParser.PARAMETERDECL);
                break;
            case LogoEditorParser.T__44:
                this.state = 1312;
                this.match(LogoEditorParser.T__44);
                this.state = 1313;
                this.match(LogoEditorParser.STRING);
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            this.state = 1316;
            this.value();
            break;

        case 6:
            this.enterOuterAlt(localctx, 6);
            this.state = 1317;
            localctx.MAKENOLIT = this.match(LogoEditorParser.T__20);
            this.state = 1318;
            this.value();
            break;

        case 7:
            this.enterOuterAlt(localctx, 7);
            this.state = 1319;
            localctx.MAKELITNOTOK = this.match(LogoEditorParser.T__20);
            this.state = 1320;
            this.match(LogoEditorParser.T__77);
            this.state = 1321;
            this.match(LogoEditorParser.STRING);
            this.state = 1322;
            this.value();
            break;

        case 8:
            this.enterOuterAlt(localctx, 8);
            this.state = 1323;
            localctx.MAKESPACEMANYVALS = this.match(LogoEditorParser.T__20);
            this.state = 1324;
            this.match(LogoEditorParser.T__77);
            this.state = 1325;
            this.match(LogoEditorParser.STRING);
            this.state = 1326;
            this.value();
            this.state = 1328; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1327;
            		this.value();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1330; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,212, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 9:
            this.enterOuterAlt(localctx, 9);
            this.state = 1332;
            localctx.MAKESPACENOVAL = this.match(LogoEditorParser.T__20);
            this.state = 1333;
            this.match(LogoEditorParser.T__77);
            this.state = 1334;
            this.match(LogoEditorParser.STRING);
            break;

        case 10:
            this.enterOuterAlt(localctx, 10);
            this.state = 1335;
            localctx.MAKENOARGS = this.match(LogoEditorParser.T__20);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PrintContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_print;
    this.PRINTOK = null; // Token
    this.PRINTMANYARGS = null; // Token
    this.PRINTNOARG = null; // Token
    return this;
}

PrintContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PrintContext.prototype.constructor = PrintContext;

PrintContext.prototype.value = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ValueContext);
    } else {
        return this.getTypedRuleContext(ValueContext,i);
    }
};

PrintContext.prototype.quotedstring = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(QuotedstringContext);
    } else {
        return this.getTypedRuleContext(QuotedstringContext,i);
    }
};

PrintContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPrint(this);
	}
};

PrintContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPrint(this);
	}
};

PrintContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPrint(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PrintContext = PrintContext;

LogoEditorParser.prototype.print = function() {

    var localctx = new PrintContext(this, this._ctx, this.state);
    this.enterRule(localctx, 48, LogoEditorParser.RULE_print);
    var _la = 0; // Token type
    try {
        this.state = 1355;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,218,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1338;
            localctx.PRINTOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__29 || _la===LogoEditorParser.T__78)) {
                localctx.PRINTOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1341;
            switch(this._input.LA(1)) {
            case LogoEditorParser.T__30:
            case LogoEditorParser.T__31:
            case LogoEditorParser.T__32:
            case LogoEditorParser.T__33:
            case LogoEditorParser.T__34:
            case LogoEditorParser.T__35:
            case LogoEditorParser.T__36:
            case LogoEditorParser.T__37:
            case LogoEditorParser.T__38:
            case LogoEditorParser.T__39:
            case LogoEditorParser.T__40:
            case LogoEditorParser.T__41:
            case LogoEditorParser.T__42:
            case LogoEditorParser.T__43:
            case LogoEditorParser.T__44:
            case LogoEditorParser.T__70:
            case LogoEditorParser.T__71:
            case LogoEditorParser.T__76:
            case LogoEditorParser.T__77:
            case LogoEditorParser.T__93:
            case LogoEditorParser.T__94:
            case LogoEditorParser.T__95:
            case LogoEditorParser.T__96:
            case LogoEditorParser.T__97:
            case LogoEditorParser.T__98:
            case LogoEditorParser.PARAMETERDECL:
            case LogoEditorParser.STRINGLITERAL:
            case LogoEditorParser.LPAREN:
            case LogoEditorParser.NUMBER:
                this.state = 1339;
                this.value();
                break;
            case LogoEditorParser.T__62:
                this.state = 1340;
                this.quotedstring();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1343;
            localctx.PRINTMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__29 || _la===LogoEditorParser.T__78)) {
                localctx.PRINTMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1346;
            switch(this._input.LA(1)) {
            case LogoEditorParser.T__30:
            case LogoEditorParser.T__31:
            case LogoEditorParser.T__32:
            case LogoEditorParser.T__33:
            case LogoEditorParser.T__34:
            case LogoEditorParser.T__35:
            case LogoEditorParser.T__36:
            case LogoEditorParser.T__37:
            case LogoEditorParser.T__38:
            case LogoEditorParser.T__39:
            case LogoEditorParser.T__40:
            case LogoEditorParser.T__41:
            case LogoEditorParser.T__42:
            case LogoEditorParser.T__43:
            case LogoEditorParser.T__44:
            case LogoEditorParser.T__70:
            case LogoEditorParser.T__71:
            case LogoEditorParser.T__76:
            case LogoEditorParser.T__77:
            case LogoEditorParser.T__93:
            case LogoEditorParser.T__94:
            case LogoEditorParser.T__95:
            case LogoEditorParser.T__96:
            case LogoEditorParser.T__97:
            case LogoEditorParser.T__98:
            case LogoEditorParser.PARAMETERDECL:
            case LogoEditorParser.STRINGLITERAL:
            case LogoEditorParser.LPAREN:
            case LogoEditorParser.NUMBER:
                this.state = 1344;
                this.value();
                break;
            case LogoEditorParser.T__62:
                this.state = 1345;
                this.quotedstring();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            this.state = 1350; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1350;
            		switch(this._input.LA(1)) {
            		case LogoEditorParser.T__30:
            		case LogoEditorParser.T__31:
            		case LogoEditorParser.T__32:
            		case LogoEditorParser.T__33:
            		case LogoEditorParser.T__34:
            		case LogoEditorParser.T__35:
            		case LogoEditorParser.T__36:
            		case LogoEditorParser.T__37:
            		case LogoEditorParser.T__38:
            		case LogoEditorParser.T__39:
            		case LogoEditorParser.T__40:
            		case LogoEditorParser.T__41:
            		case LogoEditorParser.T__42:
            		case LogoEditorParser.T__43:
            		case LogoEditorParser.T__44:
            		case LogoEditorParser.T__70:
            		case LogoEditorParser.T__71:
            		case LogoEditorParser.T__76:
            		case LogoEditorParser.T__77:
            		case LogoEditorParser.T__93:
            		case LogoEditorParser.T__94:
            		case LogoEditorParser.T__95:
            		case LogoEditorParser.T__96:
            		case LogoEditorParser.T__97:
            		case LogoEditorParser.T__98:
            		case LogoEditorParser.PARAMETERDECL:
            		case LogoEditorParser.STRINGLITERAL:
            		case LogoEditorParser.LPAREN:
            		case LogoEditorParser.NUMBER:
            		    this.state = 1348;
            		    this.value();
            		    break;
            		case LogoEditorParser.T__62:
            		    this.state = 1349;
            		    this.quotedstring();
            		    break;
            		default:
            		    throw new antlr4.error.NoViableAltException(this);
            		}
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1352; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,217, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1354;
            localctx.PRINTNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__29 || _la===LogoEditorParser.T__78)) {
                localctx.PRINTNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function QuotedstringContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_quotedstring;
    this.QUOTEDSTRINGOK = null; // Token
    return this;
}

QuotedstringContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
QuotedstringContext.prototype.constructor = QuotedstringContext;


QuotedstringContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterQuotedstring(this);
	}
};

QuotedstringContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitQuotedstring(this);
	}
};

QuotedstringContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitQuotedstring(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.QuotedstringContext = QuotedstringContext;

LogoEditorParser.prototype.quotedstring = function() {

    var localctx = new QuotedstringContext(this, this._ctx, this.state);
    this.enterRule(localctx, 50, LogoEditorParser.RULE_quotedstring);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1357;
        localctx.QUOTEDSTRINGOK = this.match(LogoEditorParser.T__62);
        this.state = 1361;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoEditorParser.T__0) | (1 << LogoEditorParser.T__1) | (1 << LogoEditorParser.T__2) | (1 << LogoEditorParser.T__3) | (1 << LogoEditorParser.T__4) | (1 << LogoEditorParser.T__5) | (1 << LogoEditorParser.T__6) | (1 << LogoEditorParser.T__7) | (1 << LogoEditorParser.T__8) | (1 << LogoEditorParser.T__9) | (1 << LogoEditorParser.T__10) | (1 << LogoEditorParser.T__11) | (1 << LogoEditorParser.T__12) | (1 << LogoEditorParser.T__13) | (1 << LogoEditorParser.T__14) | (1 << LogoEditorParser.T__15) | (1 << LogoEditorParser.T__16) | (1 << LogoEditorParser.T__17) | (1 << LogoEditorParser.T__18) | (1 << LogoEditorParser.T__19) | (1 << LogoEditorParser.T__20) | (1 << LogoEditorParser.T__21) | (1 << LogoEditorParser.T__22) | (1 << LogoEditorParser.T__23) | (1 << LogoEditorParser.T__24) | (1 << LogoEditorParser.T__25) | (1 << LogoEditorParser.T__26) | (1 << LogoEditorParser.T__27) | (1 << LogoEditorParser.T__28) | (1 << LogoEditorParser.T__29) | (1 << LogoEditorParser.T__30))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LogoEditorParser.T__31 - 32)) | (1 << (LogoEditorParser.T__32 - 32)) | (1 << (LogoEditorParser.T__33 - 32)) | (1 << (LogoEditorParser.T__34 - 32)) | (1 << (LogoEditorParser.T__35 - 32)) | (1 << (LogoEditorParser.T__36 - 32)) | (1 << (LogoEditorParser.T__37 - 32)) | (1 << (LogoEditorParser.T__38 - 32)) | (1 << (LogoEditorParser.T__39 - 32)) | (1 << (LogoEditorParser.T__40 - 32)) | (1 << (LogoEditorParser.T__41 - 32)) | (1 << (LogoEditorParser.T__42 - 32)) | (1 << (LogoEditorParser.T__43 - 32)) | (1 << (LogoEditorParser.T__44 - 32)) | (1 << (LogoEditorParser.T__45 - 32)) | (1 << (LogoEditorParser.T__46 - 32)) | (1 << (LogoEditorParser.T__47 - 32)) | (1 << (LogoEditorParser.T__48 - 32)) | (1 << (LogoEditorParser.T__49 - 32)) | (1 << (LogoEditorParser.T__50 - 32)) | (1 << (LogoEditorParser.T__51 - 32)) | (1 << (LogoEditorParser.T__52 - 32)) | (1 << (LogoEditorParser.T__53 - 32)) | (1 << (LogoEditorParser.T__54 - 32)) | (1 << (LogoEditorParser.T__55 - 32)) | (1 << (LogoEditorParser.T__56 - 32)) | (1 << (LogoEditorParser.T__57 - 32)) | (1 << (LogoEditorParser.T__58 - 32)) | (1 << (LogoEditorParser.T__59 - 32)) | (1 << (LogoEditorParser.T__60 - 32)) | (1 << (LogoEditorParser.T__61 - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (LogoEditorParser.T__64 - 65)) | (1 << (LogoEditorParser.T__65 - 65)) | (1 << (LogoEditorParser.T__66 - 65)) | (1 << (LogoEditorParser.T__67 - 65)) | (1 << (LogoEditorParser.T__68 - 65)) | (1 << (LogoEditorParser.T__69 - 65)) | (1 << (LogoEditorParser.T__70 - 65)) | (1 << (LogoEditorParser.T__71 - 65)) | (1 << (LogoEditorParser.T__72 - 65)) | (1 << (LogoEditorParser.T__73 - 65)) | (1 << (LogoEditorParser.T__74 - 65)) | (1 << (LogoEditorParser.T__75 - 65)) | (1 << (LogoEditorParser.T__76 - 65)) | (1 << (LogoEditorParser.T__77 - 65)) | (1 << (LogoEditorParser.T__78 - 65)) | (1 << (LogoEditorParser.T__79 - 65)) | (1 << (LogoEditorParser.T__80 - 65)) | (1 << (LogoEditorParser.T__81 - 65)) | (1 << (LogoEditorParser.T__82 - 65)) | (1 << (LogoEditorParser.T__83 - 65)) | (1 << (LogoEditorParser.T__84 - 65)) | (1 << (LogoEditorParser.T__85 - 65)) | (1 << (LogoEditorParser.T__86 - 65)) | (1 << (LogoEditorParser.T__87 - 65)) | (1 << (LogoEditorParser.T__88 - 65)) | (1 << (LogoEditorParser.T__89 - 65)) | (1 << (LogoEditorParser.T__90 - 65)) | (1 << (LogoEditorParser.T__91 - 65)) | (1 << (LogoEditorParser.T__92 - 65)) | (1 << (LogoEditorParser.T__93 - 65)) | (1 << (LogoEditorParser.T__94 - 65)) | (1 << (LogoEditorParser.T__95 - 65)))) !== 0) || ((((_la - 97)) & ~0x1f) == 0 && ((1 << (_la - 97)) & ((1 << (LogoEditorParser.T__96 - 97)) | (1 << (LogoEditorParser.T__97 - 97)) | (1 << (LogoEditorParser.T__98 - 97)) | (1 << (LogoEditorParser.T__99 - 97)) | (1 << (LogoEditorParser.T__100 - 97)) | (1 << (LogoEditorParser.T__101 - 97)) | (1 << (LogoEditorParser.PARAMETERDECL - 97)) | (1 << (LogoEditorParser.STRINGLITERAL - 97)) | (1 << (LogoEditorParser.STRING - 97)) | (1 << (LogoEditorParser.LPAREN - 97)) | (1 << (LogoEditorParser.RPAREN - 97)) | (1 << (LogoEditorParser.NUMBER - 97)) | (1 << (LogoEditorParser.COMMENT - 97)) | (1 << (LogoEditorParser.EOL - 97)) | (1 << (LogoEditorParser.WS - 97)))) !== 0)) {
            this.state = 1358;
            _la = this._input.LA(1);
            if(_la<=0 || _la===LogoEditorParser.T__62 || _la===LogoEditorParser.T__63) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1363;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 1364;
        this.match(LogoEditorParser.T__63);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_name;
    return this;
}

NameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NameContext.prototype.constructor = NameContext;

NameContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

NameContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterName(this);
	}
};

NameContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitName(this);
	}
};

NameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.NameContext = NameContext;

LogoEditorParser.prototype.name = function() {

    var localctx = new NameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 52, LogoEditorParser.RULE_name);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1366;
        this.match(LogoEditorParser.STRING);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_fd;
    this.FDOK = null; // Token
    this.FDMANYARGS = null; // Token
    this.FDNOARGS = null; // Token
    return this;
}

FdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FdContext.prototype.constructor = FdContext;

FdContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

FdContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterFd(this);
	}
};

FdContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitFd(this);
	}
};

FdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitFd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.FdContext = FdContext;

LogoEditorParser.prototype.fd = function() {

    var localctx = new FdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 54, LogoEditorParser.RULE_fd);
    var _la = 0; // Token type
    try {
        this.state = 1378;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,221,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1368;
            localctx.FDOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__2 || _la===LogoEditorParser.T__79)) {
                localctx.FDOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1369;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1370;
            localctx.FDMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__2 || _la===LogoEditorParser.T__79)) {
                localctx.FDMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1371;
            this.expression();
            this.state = 1373; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1372;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1375; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,220, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1377;
            localctx.FDNOARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__2 || _la===LogoEditorParser.T__79)) {
                localctx.FDNOARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function BkContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_bk;
    this.BKOK = null; // Token
    this.BKMANYARGS = null; // Token
    this.BKNOARGS = null; // Token
    return this;
}

BkContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BkContext.prototype.constructor = BkContext;

BkContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

BkContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterBk(this);
	}
};

BkContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitBk(this);
	}
};

BkContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitBk(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.BkContext = BkContext;

LogoEditorParser.prototype.bk = function() {

    var localctx = new BkContext(this, this._ctx, this.state);
    this.enterRule(localctx, 56, LogoEditorParser.RULE_bk);
    var _la = 0; // Token type
    try {
        this.state = 1390;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,223,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1380;
            localctx.BKOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__3 || _la===LogoEditorParser.T__80 || _la===LogoEditorParser.T__81)) {
                localctx.BKOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1381;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1382;
            localctx.BKMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__3 || _la===LogoEditorParser.T__80 || _la===LogoEditorParser.T__81)) {
                localctx.BKMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1383;
            this.expression();
            this.state = 1385; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1384;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1387; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,222, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1389;
            localctx.BKNOARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__3 || _la===LogoEditorParser.T__80 || _la===LogoEditorParser.T__81)) {
                localctx.BKNOARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_rt;
    this.RTOK = null; // Token
    this.RTMANYARGS = null; // Token
    this.RTNOARGS = null; // Token
    return this;
}

RtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RtContext.prototype.constructor = RtContext;

RtContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

RtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterRt(this);
	}
};

RtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitRt(this);
	}
};

RtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitRt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.RtContext = RtContext;

LogoEditorParser.prototype.rt = function() {

    var localctx = new RtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 58, LogoEditorParser.RULE_rt);
    var _la = 0; // Token type
    try {
        this.state = 1402;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,225,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1392;
            localctx.RTOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__4 || _la===LogoEditorParser.T__82)) {
                localctx.RTOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1393;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1394;
            localctx.RTMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__4 || _la===LogoEditorParser.T__82)) {
                localctx.RTMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1395;
            this.expression();
            this.state = 1397; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1396;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1399; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,224, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1401;
            localctx.RTNOARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__4 || _la===LogoEditorParser.T__82)) {
                localctx.RTNOARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_lt;
    this.LTOK = null; // Token
    this.LTMANYARGS = null; // Token
    this.LTNOARGS = null; // Token
    return this;
}

LtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LtContext.prototype.constructor = LtContext;

LtContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

LtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterLt(this);
	}
};

LtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitLt(this);
	}
};

LtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitLt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.LtContext = LtContext;

LogoEditorParser.prototype.lt = function() {

    var localctx = new LtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 60, LogoEditorParser.RULE_lt);
    var _la = 0; // Token type
    try {
        this.state = 1414;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,227,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1404;
            localctx.LTOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__5 || _la===LogoEditorParser.T__83)) {
                localctx.LTOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1405;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1406;
            localctx.LTMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__5 || _la===LogoEditorParser.T__83)) {
                localctx.LTMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1407;
            this.expression();
            this.state = 1409; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1408;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1411; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,226, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1413;
            localctx.LTNOARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__5 || _la===LogoEditorParser.T__83)) {
                localctx.LTNOARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_cs;
    this.CSOK = null; // Token
    this.CSMANYARGS = null; // Token
    return this;
}

CsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CsContext.prototype.constructor = CsContext;

CsContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

CsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterCs(this);
	}
};

CsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitCs(this);
	}
};

CsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitCs(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.CsContext = CsContext;

LogoEditorParser.prototype.cs = function() {

    var localctx = new CsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 62, LogoEditorParser.RULE_cs);
    var _la = 0; // Token type
    try {
        this.state = 1423;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,229,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1416;
            localctx.CSOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__6 || _la===LogoEditorParser.T__84)) {
                localctx.CSOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1417;
            localctx.CSMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__6 || _la===LogoEditorParser.T__84)) {
                localctx.CSMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1419; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1418;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1421; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,228, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_ct;
    this.CTOK = null; // Token
    this.CTMANYARGS = null; // Token
    return this;
}

CtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CtContext.prototype.constructor = CtContext;

CtContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

CtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterCt(this);
	}
};

CtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitCt(this);
	}
};

CtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitCt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.CtContext = CtContext;

LogoEditorParser.prototype.ct = function() {

    var localctx = new CtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 64, LogoEditorParser.RULE_ct);
    try {
        this.state = 1432;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,231,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1425;
            localctx.CTOK = this.match(LogoEditorParser.T__7);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1426;
            localctx.CTMANYARGS = this.match(LogoEditorParser.T__7);
            this.state = 1428; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1427;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1430; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,230, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PuContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_pu;
    this.PUOK = null; // Token
    this.PUMANYARGS = null; // Token
    return this;
}

PuContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PuContext.prototype.constructor = PuContext;

PuContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

PuContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPu(this);
	}
};

PuContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPu(this);
	}
};

PuContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPu(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PuContext = PuContext;

LogoEditorParser.prototype.pu = function() {

    var localctx = new PuContext(this, this._ctx, this.state);
    this.enterRule(localctx, 66, LogoEditorParser.RULE_pu);
    var _la = 0; // Token type
    try {
        this.state = 1441;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,233,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1434;
            localctx.PUOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__8 || _la===LogoEditorParser.T__85)) {
                localctx.PUOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1435;
            localctx.PUMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__8 || _la===LogoEditorParser.T__85)) {
                localctx.PUMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1437; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1436;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1439; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,232, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_pd;
    this.PDOK = null; // Token
    this.PDMANYARGS = null; // Token
    return this;
}

PdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PdContext.prototype.constructor = PdContext;

PdContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

PdContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPd(this);
	}
};

PdContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPd(this);
	}
};

PdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PdContext = PdContext;

LogoEditorParser.prototype.pd = function() {

    var localctx = new PdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 68, LogoEditorParser.RULE_pd);
    var _la = 0; // Token type
    try {
        this.state = 1450;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,235,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1443;
            localctx.PDOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__9 || _la===LogoEditorParser.T__86)) {
                localctx.PDOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1444;
            localctx.PDMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__9 || _la===LogoEditorParser.T__86)) {
                localctx.PDMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1446; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1445;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1448; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,234, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_pe;
    this.PEOK = null; // Token
    this.PEMANYARGS = null; // Token
    return this;
}

PeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PeContext.prototype.constructor = PeContext;

PeContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

PeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPe(this);
	}
};

PeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPe(this);
	}
};

PeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPe(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PeContext = PeContext;

LogoEditorParser.prototype.pe = function() {

    var localctx = new PeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 70, LogoEditorParser.RULE_pe);
    var _la = 0; // Token type
    try {
        this.state = 1459;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,237,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1452;
            localctx.PEOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__12 || _la===LogoEditorParser.T__87)) {
                localctx.PEOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1453;
            localctx.PEMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__12 || _la===LogoEditorParser.T__87)) {
                localctx.PEMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1455; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1454;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1457; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,236, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PptContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_ppt;
    this.PPTOK = null; // Token
    this.PPTMANYARGS = null; // Token
    return this;
}

PptContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PptContext.prototype.constructor = PptContext;

PptContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

PptContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPpt(this);
	}
};

PptContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPpt(this);
	}
};

PptContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPpt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PptContext = PptContext;

LogoEditorParser.prototype.ppt = function() {

    var localctx = new PptContext(this, this._ctx, this.state);
    this.enterRule(localctx, 72, LogoEditorParser.RULE_ppt);
    var _la = 0; // Token type
    try {
        this.state = 1468;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,239,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1461;
            localctx.PPTOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__13 || _la===LogoEditorParser.T__88)) {
                localctx.PPTOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1462;
            localctx.PPTMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__13 || _la===LogoEditorParser.T__88)) {
                localctx.PPTMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1464; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1463;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1466; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,238, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function HtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_ht;
    this.HTOK = null; // Token
    this.HTMANYARGS = null; // Token
    return this;
}

HtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
HtContext.prototype.constructor = HtContext;

HtContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

HtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterHt(this);
	}
};

HtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitHt(this);
	}
};

HtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitHt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.HtContext = HtContext;

LogoEditorParser.prototype.ht = function() {

    var localctx = new HtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 74, LogoEditorParser.RULE_ht);
    var _la = 0; // Token type
    try {
        this.state = 1477;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,241,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1470;
            localctx.HTOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__10 || _la===LogoEditorParser.T__89)) {
                localctx.HTOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1471;
            localctx.HTMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__10 || _la===LogoEditorParser.T__89)) {
                localctx.HTMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1473; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1472;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1475; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,240, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function StContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_st;
    this.STOK = null; // Token
    this.STMANYARGS = null; // Token
    return this;
}

StContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
StContext.prototype.constructor = StContext;

StContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

StContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSt(this);
	}
};

StContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSt(this);
	}
};

StContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.StContext = StContext;

LogoEditorParser.prototype.st = function() {

    var localctx = new StContext(this, this._ctx, this.state);
    this.enterRule(localctx, 76, LogoEditorParser.RULE_st);
    var _la = 0; // Token type
    try {
        this.state = 1486;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,243,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1479;
            localctx.STOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__11 || _la===LogoEditorParser.T__90)) {
                localctx.STOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1480;
            localctx.STMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__11 || _la===LogoEditorParser.T__90)) {
                localctx.STMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1482; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1481;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1484; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,242, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetpcContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_setpc;
    this.SETPCOK = null; // Token
    this.SETPCMANYARGS = null; // Token
    this.SETPCNOARG = null; // Token
    return this;
}

SetpcContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetpcContext.prototype.constructor = SetpcContext;

SetpcContext.prototype.colornumber = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColornumberContext);
    } else {
        return this.getTypedRuleContext(ColornumberContext,i);
    }
};

SetpcContext.prototype.rgb = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(RgbContext);
    } else {
        return this.getTypedRuleContext(RgbContext,i);
    }
};

SetpcContext.prototype.colorname = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColornameContext);
    } else {
        return this.getTypedRuleContext(ColornameContext,i);
    }
};

SetpcContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSetpc(this);
	}
};

SetpcContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSetpc(this);
	}
};

SetpcContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSetpc(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetpcContext = SetpcContext;

LogoEditorParser.prototype.setpc = function() {

    var localctx = new SetpcContext(this, this._ctx, this.state);
    this.enterRule(localctx, 78, LogoEditorParser.RULE_setpc);
    var _la = 0; // Token type
    try {
        this.state = 1508;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,248,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1488;
            localctx.SETPCOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__18 || _la===LogoEditorParser.T__91)) {
                localctx.SETPCOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1492;
            switch(this._input.LA(1)) {
            case LogoEditorParser.T__30:
            case LogoEditorParser.T__31:
            case LogoEditorParser.T__32:
            case LogoEditorParser.T__33:
            case LogoEditorParser.T__34:
            case LogoEditorParser.T__35:
            case LogoEditorParser.T__36:
            case LogoEditorParser.T__37:
            case LogoEditorParser.T__38:
            case LogoEditorParser.T__39:
            case LogoEditorParser.T__40:
            case LogoEditorParser.T__41:
            case LogoEditorParser.T__42:
            case LogoEditorParser.T__43:
            case LogoEditorParser.T__44:
            case LogoEditorParser.T__70:
            case LogoEditorParser.T__71:
            case LogoEditorParser.T__76:
            case LogoEditorParser.T__77:
            case LogoEditorParser.T__93:
            case LogoEditorParser.T__94:
            case LogoEditorParser.T__95:
            case LogoEditorParser.T__96:
            case LogoEditorParser.T__97:
            case LogoEditorParser.T__98:
            case LogoEditorParser.PARAMETERDECL:
            case LogoEditorParser.STRINGLITERAL:
            case LogoEditorParser.LPAREN:
            case LogoEditorParser.NUMBER:
                this.state = 1489;
                this.colornumber();
                break;
            case LogoEditorParser.T__62:
                this.state = 1490;
                this.rgb();
                break;
            case LogoEditorParser.T__45:
            case LogoEditorParser.T__46:
            case LogoEditorParser.T__47:
            case LogoEditorParser.T__48:
            case LogoEditorParser.T__49:
            case LogoEditorParser.T__50:
            case LogoEditorParser.T__51:
            case LogoEditorParser.T__52:
            case LogoEditorParser.T__53:
            case LogoEditorParser.T__54:
            case LogoEditorParser.T__55:
            case LogoEditorParser.T__56:
            case LogoEditorParser.T__57:
            case LogoEditorParser.T__58:
            case LogoEditorParser.T__59:
            case LogoEditorParser.T__60:
            case LogoEditorParser.T__61:
            case LogoEditorParser.STRING:
                this.state = 1491;
                this.colorname();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1494;
            localctx.SETPCMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__18 || _la===LogoEditorParser.T__91)) {
                localctx.SETPCMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1498;
            switch(this._input.LA(1)) {
            case LogoEditorParser.T__30:
            case LogoEditorParser.T__31:
            case LogoEditorParser.T__32:
            case LogoEditorParser.T__33:
            case LogoEditorParser.T__34:
            case LogoEditorParser.T__35:
            case LogoEditorParser.T__36:
            case LogoEditorParser.T__37:
            case LogoEditorParser.T__38:
            case LogoEditorParser.T__39:
            case LogoEditorParser.T__40:
            case LogoEditorParser.T__41:
            case LogoEditorParser.T__42:
            case LogoEditorParser.T__43:
            case LogoEditorParser.T__44:
            case LogoEditorParser.T__70:
            case LogoEditorParser.T__71:
            case LogoEditorParser.T__76:
            case LogoEditorParser.T__77:
            case LogoEditorParser.T__93:
            case LogoEditorParser.T__94:
            case LogoEditorParser.T__95:
            case LogoEditorParser.T__96:
            case LogoEditorParser.T__97:
            case LogoEditorParser.T__98:
            case LogoEditorParser.PARAMETERDECL:
            case LogoEditorParser.STRINGLITERAL:
            case LogoEditorParser.LPAREN:
            case LogoEditorParser.NUMBER:
                this.state = 1495;
                this.colornumber();
                break;
            case LogoEditorParser.T__62:
                this.state = 1496;
                this.rgb();
                break;
            case LogoEditorParser.T__45:
            case LogoEditorParser.T__46:
            case LogoEditorParser.T__47:
            case LogoEditorParser.T__48:
            case LogoEditorParser.T__49:
            case LogoEditorParser.T__50:
            case LogoEditorParser.T__51:
            case LogoEditorParser.T__52:
            case LogoEditorParser.T__53:
            case LogoEditorParser.T__54:
            case LogoEditorParser.T__55:
            case LogoEditorParser.T__56:
            case LogoEditorParser.T__57:
            case LogoEditorParser.T__58:
            case LogoEditorParser.T__59:
            case LogoEditorParser.T__60:
            case LogoEditorParser.T__61:
            case LogoEditorParser.STRING:
                this.state = 1497;
                this.colorname();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            this.state = 1503; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1503;
            		switch(this._input.LA(1)) {
            		case LogoEditorParser.T__30:
            		case LogoEditorParser.T__31:
            		case LogoEditorParser.T__32:
            		case LogoEditorParser.T__33:
            		case LogoEditorParser.T__34:
            		case LogoEditorParser.T__35:
            		case LogoEditorParser.T__36:
            		case LogoEditorParser.T__37:
            		case LogoEditorParser.T__38:
            		case LogoEditorParser.T__39:
            		case LogoEditorParser.T__40:
            		case LogoEditorParser.T__41:
            		case LogoEditorParser.T__42:
            		case LogoEditorParser.T__43:
            		case LogoEditorParser.T__44:
            		case LogoEditorParser.T__70:
            		case LogoEditorParser.T__71:
            		case LogoEditorParser.T__76:
            		case LogoEditorParser.T__77:
            		case LogoEditorParser.T__93:
            		case LogoEditorParser.T__94:
            		case LogoEditorParser.T__95:
            		case LogoEditorParser.T__96:
            		case LogoEditorParser.T__97:
            		case LogoEditorParser.T__98:
            		case LogoEditorParser.PARAMETERDECL:
            		case LogoEditorParser.STRINGLITERAL:
            		case LogoEditorParser.LPAREN:
            		case LogoEditorParser.NUMBER:
            		    this.state = 1500;
            		    this.colornumber();
            		    break;
            		case LogoEditorParser.T__62:
            		    this.state = 1501;
            		    this.rgb();
            		    break;
            		case LogoEditorParser.T__45:
            		case LogoEditorParser.T__46:
            		case LogoEditorParser.T__47:
            		case LogoEditorParser.T__48:
            		case LogoEditorParser.T__49:
            		case LogoEditorParser.T__50:
            		case LogoEditorParser.T__51:
            		case LogoEditorParser.T__52:
            		case LogoEditorParser.T__53:
            		case LogoEditorParser.T__54:
            		case LogoEditorParser.T__55:
            		case LogoEditorParser.T__56:
            		case LogoEditorParser.T__57:
            		case LogoEditorParser.T__58:
            		case LogoEditorParser.T__59:
            		case LogoEditorParser.T__60:
            		case LogoEditorParser.T__61:
            		case LogoEditorParser.STRING:
            		    this.state = 1502;
            		    this.colorname();
            		    break;
            		default:
            		    throw new antlr4.error.NoViableAltException(this);
            		}
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1505; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,247, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1507;
            localctx.SETPCNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__18 || _la===LogoEditorParser.T__91)) {
                localctx.SETPCNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetscContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_setsc;
    this.SETSCOK = null; // Token
    this.SETSCMANYARGS = null; // Token
    this.SETSCNOARG = null; // Token
    return this;
}

SetscContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetscContext.prototype.constructor = SetscContext;

SetscContext.prototype.colornumber = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColornumberContext);
    } else {
        return this.getTypedRuleContext(ColornumberContext,i);
    }
};

SetscContext.prototype.rgb = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(RgbContext);
    } else {
        return this.getTypedRuleContext(RgbContext,i);
    }
};

SetscContext.prototype.colorname = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColornameContext);
    } else {
        return this.getTypedRuleContext(ColornameContext,i);
    }
};

SetscContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSetsc(this);
	}
};

SetscContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSetsc(this);
	}
};

SetscContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSetsc(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetscContext = SetscContext;

LogoEditorParser.prototype.setsc = function() {

    var localctx = new SetscContext(this, this._ctx, this.state);
    this.enterRule(localctx, 80, LogoEditorParser.RULE_setsc);
    var _la = 0; // Token type
    try {
        this.state = 1530;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,253,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1510;
            localctx.SETSCOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__19 || _la===LogoEditorParser.T__92)) {
                localctx.SETSCOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1514;
            switch(this._input.LA(1)) {
            case LogoEditorParser.T__30:
            case LogoEditorParser.T__31:
            case LogoEditorParser.T__32:
            case LogoEditorParser.T__33:
            case LogoEditorParser.T__34:
            case LogoEditorParser.T__35:
            case LogoEditorParser.T__36:
            case LogoEditorParser.T__37:
            case LogoEditorParser.T__38:
            case LogoEditorParser.T__39:
            case LogoEditorParser.T__40:
            case LogoEditorParser.T__41:
            case LogoEditorParser.T__42:
            case LogoEditorParser.T__43:
            case LogoEditorParser.T__44:
            case LogoEditorParser.T__70:
            case LogoEditorParser.T__71:
            case LogoEditorParser.T__76:
            case LogoEditorParser.T__77:
            case LogoEditorParser.T__93:
            case LogoEditorParser.T__94:
            case LogoEditorParser.T__95:
            case LogoEditorParser.T__96:
            case LogoEditorParser.T__97:
            case LogoEditorParser.T__98:
            case LogoEditorParser.PARAMETERDECL:
            case LogoEditorParser.STRINGLITERAL:
            case LogoEditorParser.LPAREN:
            case LogoEditorParser.NUMBER:
                this.state = 1511;
                this.colornumber();
                break;
            case LogoEditorParser.T__62:
                this.state = 1512;
                this.rgb();
                break;
            case LogoEditorParser.T__45:
            case LogoEditorParser.T__46:
            case LogoEditorParser.T__47:
            case LogoEditorParser.T__48:
            case LogoEditorParser.T__49:
            case LogoEditorParser.T__50:
            case LogoEditorParser.T__51:
            case LogoEditorParser.T__52:
            case LogoEditorParser.T__53:
            case LogoEditorParser.T__54:
            case LogoEditorParser.T__55:
            case LogoEditorParser.T__56:
            case LogoEditorParser.T__57:
            case LogoEditorParser.T__58:
            case LogoEditorParser.T__59:
            case LogoEditorParser.T__60:
            case LogoEditorParser.T__61:
            case LogoEditorParser.STRING:
                this.state = 1513;
                this.colorname();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1516;
            localctx.SETSCMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__19 || _la===LogoEditorParser.T__92)) {
                localctx.SETSCMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1520;
            switch(this._input.LA(1)) {
            case LogoEditorParser.T__30:
            case LogoEditorParser.T__31:
            case LogoEditorParser.T__32:
            case LogoEditorParser.T__33:
            case LogoEditorParser.T__34:
            case LogoEditorParser.T__35:
            case LogoEditorParser.T__36:
            case LogoEditorParser.T__37:
            case LogoEditorParser.T__38:
            case LogoEditorParser.T__39:
            case LogoEditorParser.T__40:
            case LogoEditorParser.T__41:
            case LogoEditorParser.T__42:
            case LogoEditorParser.T__43:
            case LogoEditorParser.T__44:
            case LogoEditorParser.T__70:
            case LogoEditorParser.T__71:
            case LogoEditorParser.T__76:
            case LogoEditorParser.T__77:
            case LogoEditorParser.T__93:
            case LogoEditorParser.T__94:
            case LogoEditorParser.T__95:
            case LogoEditorParser.T__96:
            case LogoEditorParser.T__97:
            case LogoEditorParser.T__98:
            case LogoEditorParser.PARAMETERDECL:
            case LogoEditorParser.STRINGLITERAL:
            case LogoEditorParser.LPAREN:
            case LogoEditorParser.NUMBER:
                this.state = 1517;
                this.colornumber();
                break;
            case LogoEditorParser.T__62:
                this.state = 1518;
                this.rgb();
                break;
            case LogoEditorParser.T__45:
            case LogoEditorParser.T__46:
            case LogoEditorParser.T__47:
            case LogoEditorParser.T__48:
            case LogoEditorParser.T__49:
            case LogoEditorParser.T__50:
            case LogoEditorParser.T__51:
            case LogoEditorParser.T__52:
            case LogoEditorParser.T__53:
            case LogoEditorParser.T__54:
            case LogoEditorParser.T__55:
            case LogoEditorParser.T__56:
            case LogoEditorParser.T__57:
            case LogoEditorParser.T__58:
            case LogoEditorParser.T__59:
            case LogoEditorParser.T__60:
            case LogoEditorParser.T__61:
            case LogoEditorParser.STRING:
                this.state = 1519;
                this.colorname();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            this.state = 1525; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1525;
            		switch(this._input.LA(1)) {
            		case LogoEditorParser.T__30:
            		case LogoEditorParser.T__31:
            		case LogoEditorParser.T__32:
            		case LogoEditorParser.T__33:
            		case LogoEditorParser.T__34:
            		case LogoEditorParser.T__35:
            		case LogoEditorParser.T__36:
            		case LogoEditorParser.T__37:
            		case LogoEditorParser.T__38:
            		case LogoEditorParser.T__39:
            		case LogoEditorParser.T__40:
            		case LogoEditorParser.T__41:
            		case LogoEditorParser.T__42:
            		case LogoEditorParser.T__43:
            		case LogoEditorParser.T__44:
            		case LogoEditorParser.T__70:
            		case LogoEditorParser.T__71:
            		case LogoEditorParser.T__76:
            		case LogoEditorParser.T__77:
            		case LogoEditorParser.T__93:
            		case LogoEditorParser.T__94:
            		case LogoEditorParser.T__95:
            		case LogoEditorParser.T__96:
            		case LogoEditorParser.T__97:
            		case LogoEditorParser.T__98:
            		case LogoEditorParser.PARAMETERDECL:
            		case LogoEditorParser.STRINGLITERAL:
            		case LogoEditorParser.LPAREN:
            		case LogoEditorParser.NUMBER:
            		    this.state = 1522;
            		    this.colornumber();
            		    break;
            		case LogoEditorParser.T__62:
            		    this.state = 1523;
            		    this.rgb();
            		    break;
            		case LogoEditorParser.T__45:
            		case LogoEditorParser.T__46:
            		case LogoEditorParser.T__47:
            		case LogoEditorParser.T__48:
            		case LogoEditorParser.T__49:
            		case LogoEditorParser.T__50:
            		case LogoEditorParser.T__51:
            		case LogoEditorParser.T__52:
            		case LogoEditorParser.T__53:
            		case LogoEditorParser.T__54:
            		case LogoEditorParser.T__55:
            		case LogoEditorParser.T__56:
            		case LogoEditorParser.T__57:
            		case LogoEditorParser.T__58:
            		case LogoEditorParser.T__59:
            		case LogoEditorParser.T__60:
            		case LogoEditorParser.T__61:
            		case LogoEditorParser.STRING:
            		    this.state = 1524;
            		    this.colorname();
            		    break;
            		default:
            		    throw new antlr4.error.NoViableAltException(this);
            		}
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1527; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,252, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1529;
            localctx.SETSCNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__19 || _la===LogoEditorParser.T__92)) {
                localctx.SETSCNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function HomeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_home;
    this.HOMEOK = null; // Token
    this.HOMEMANYARGS = null; // Token
    return this;
}

HomeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
HomeContext.prototype.constructor = HomeContext;

HomeContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

HomeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterHome(this);
	}
};

HomeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitHome(this);
	}
};

HomeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitHome(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.HomeContext = HomeContext;

LogoEditorParser.prototype.home = function() {

    var localctx = new HomeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 82, LogoEditorParser.RULE_home);
    try {
        this.state = 1539;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,255,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1532;
            localctx.HOMEOK = this.match(LogoEditorParser.T__14);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1533;
            localctx.HOMEMANYARGS = this.match(LogoEditorParser.T__14);
            this.state = 1535; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1534;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1537; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,254, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function StopContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_stop;
    this.STOPOK = null; // Token
    this.STOPMANYARGS = null; // Token
    return this;
}

StopContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
StopContext.prototype.constructor = StopContext;

StopContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

StopContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterStop(this);
	}
};

StopContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitStop(this);
	}
};

StopContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitStop(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.StopContext = StopContext;

LogoEditorParser.prototype.stop = function() {

    var localctx = new StopContext(this, this._ctx, this.state);
    this.enterRule(localctx, 84, LogoEditorParser.RULE_stop);
    try {
        this.state = 1548;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,257,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1541;
            localctx.STOPOK = this.match(LogoEditorParser.T__22);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1542;
            localctx.STOPMANYARGS = this.match(LogoEditorParser.T__22);
            this.state = 1544; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1543;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1546; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,256, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetxyContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_setxy;
    this.SETXYOK = null; // Token
    this.SETXYONEARG = null; // Token
    this.SETXYMANYARGS = null; // Token
    this.SETXYNOARG = null; // Token
    return this;
}

SetxyContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetxyContext.prototype.constructor = SetxyContext;

SetxyContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SetxyContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSetxy(this);
	}
};

SetxyContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSetxy(this);
	}
};

SetxyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSetxy(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetxyContext = SetxyContext;

LogoEditorParser.prototype.setxy = function() {

    var localctx = new SetxyContext(this, this._ctx, this.state);
    this.enterRule(localctx, 86, LogoEditorParser.RULE_setxy);
    try {
        this.state = 1565;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,259,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1550;
            localctx.SETXYOK = this.match(LogoEditorParser.T__17);
            this.state = 1551;
            this.expression();
            this.state = 1552;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1554;
            localctx.SETXYONEARG = this.match(LogoEditorParser.T__17);
            this.state = 1555;
            this.expression();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1556;
            localctx.SETXYMANYARGS = this.match(LogoEditorParser.T__17);
            this.state = 1557;
            this.expression();
            this.state = 1558;
            this.expression();
            this.state = 1560; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1559;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1562; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,258, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1564;
            localctx.SETXYNOARG = this.match(LogoEditorParser.T__17);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetxContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_setx;
    this.SETXOK = null; // Token
    this.SETXMANYARGS = null; // Token
    this.SETXNOARG = null; // Token
    return this;
}

SetxContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetxContext.prototype.constructor = SetxContext;

SetxContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SetxContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSetx(this);
	}
};

SetxContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSetx(this);
	}
};

SetxContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSetx(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetxContext = SetxContext;

LogoEditorParser.prototype.setx = function() {

    var localctx = new SetxContext(this, this._ctx, this.state);
    this.enterRule(localctx, 88, LogoEditorParser.RULE_setx);
    try {
        this.state = 1577;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,261,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1567;
            localctx.SETXOK = this.match(LogoEditorParser.T__15);
            this.state = 1568;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1569;
            localctx.SETXMANYARGS = this.match(LogoEditorParser.T__15);
            this.state = 1570;
            this.expression();
            this.state = 1572; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1571;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1574; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,260, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1576;
            localctx.SETXNOARG = this.match(LogoEditorParser.T__15);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetyContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_sety;
    this.SETYOK = null; // Token
    this.SETYMANYARGS = null; // Token
    this.SETYNOARG = null; // Token
    return this;
}

SetyContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetyContext.prototype.constructor = SetyContext;

SetyContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SetyContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSety(this);
	}
};

SetyContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSety(this);
	}
};

SetyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSety(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetyContext = SetyContext;

LogoEditorParser.prototype.sety = function() {

    var localctx = new SetyContext(this, this._ctx, this.state);
    this.enterRule(localctx, 90, LogoEditorParser.RULE_sety);
    try {
        this.state = 1589;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,263,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1579;
            localctx.SETYOK = this.match(LogoEditorParser.T__16);
            this.state = 1580;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1581;
            localctx.SETYMANYARGS = this.match(LogoEditorParser.T__16);
            this.state = 1582;
            this.expression();
            this.state = 1584; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1583;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1586; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,262, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1588;
            localctx.SETYNOARG = this.match(LogoEditorParser.T__16);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RandomContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_random;
    this.RANDOMOK = null; // Token
    this.RANDOMMANYARGS = null; // Token
    this.RANDOMNOARG = null; // Token
    return this;
}

RandomContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RandomContext.prototype.constructor = RandomContext;

RandomContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

RandomContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterRandom(this);
	}
};

RandomContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitRandom(this);
	}
};

RandomContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitRandom(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.RandomContext = RandomContext;

LogoEditorParser.prototype.random = function() {

    var localctx = new RandomContext(this, this._ctx, this.state);
    this.enterRule(localctx, 92, LogoEditorParser.RULE_random);
    var _la = 0; // Token type
    try {
        this.state = 1601;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,265,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1591;
            localctx.RANDOMOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__30 || _la===LogoEditorParser.T__93 || _la===LogoEditorParser.T__94)) {
                localctx.RANDOMOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1592;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1593;
            localctx.RANDOMMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__30 || _la===LogoEditorParser.T__93 || _la===LogoEditorParser.T__94)) {
                localctx.RANDOMMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1594;
            this.expression();
            this.state = 1596; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1595;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1598; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,264, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1600;
            localctx.RANDOMNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__30 || _la===LogoEditorParser.T__93 || _la===LogoEditorParser.T__94)) {
                localctx.RANDOMNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SinContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_sin;
    this.SINOK = null; // Token
    this.SINMANYARGS = null; // Token
    this.SINNOARG = null; // Token
    return this;
}

SinContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SinContext.prototype.constructor = SinContext;

SinContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SinContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSin(this);
	}
};

SinContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSin(this);
	}
};

SinContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSin(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SinContext = SinContext;

LogoEditorParser.prototype.sin = function() {

    var localctx = new SinContext(this, this._ctx, this.state);
    this.enterRule(localctx, 94, LogoEditorParser.RULE_sin);
    try {
        this.state = 1613;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,267,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1603;
            localctx.SINOK = this.match(LogoEditorParser.T__31);
            this.state = 1604;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1605;
            localctx.SINMANYARGS = this.match(LogoEditorParser.T__31);
            this.state = 1606;
            this.expression();
            this.state = 1608; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1607;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1610; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,266, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1612;
            localctx.SINNOARG = this.match(LogoEditorParser.T__31);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CosContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_cos;
    this.COSOK = null; // Token
    this.COSMANYARGS = null; // Token
    this.COSNOARG = null; // Token
    return this;
}

CosContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CosContext.prototype.constructor = CosContext;

CosContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

CosContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterCos(this);
	}
};

CosContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitCos(this);
	}
};

CosContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitCos(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.CosContext = CosContext;

LogoEditorParser.prototype.cos = function() {

    var localctx = new CosContext(this, this._ctx, this.state);
    this.enterRule(localctx, 96, LogoEditorParser.RULE_cos);
    try {
        this.state = 1625;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,269,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1615;
            localctx.COSOK = this.match(LogoEditorParser.T__32);
            this.state = 1616;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1617;
            localctx.COSMANYARGS = this.match(LogoEditorParser.T__32);
            this.state = 1618;
            this.expression();
            this.state = 1620; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1619;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1622; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,268, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1624;
            localctx.COSNOARG = this.match(LogoEditorParser.T__32);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function TanContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_tan;
    this.TANOK = null; // Token
    this.TANMANYARGS = null; // Token
    this.TANNOARG = null; // Token
    return this;
}

TanContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TanContext.prototype.constructor = TanContext;

TanContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

TanContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterTan(this);
	}
};

TanContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitTan(this);
	}
};

TanContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitTan(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.TanContext = TanContext;

LogoEditorParser.prototype.tan = function() {

    var localctx = new TanContext(this, this._ctx, this.state);
    this.enterRule(localctx, 98, LogoEditorParser.RULE_tan);
    try {
        this.state = 1637;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,271,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1627;
            localctx.TANOK = this.match(LogoEditorParser.T__33);
            this.state = 1628;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1629;
            localctx.TANMANYARGS = this.match(LogoEditorParser.T__33);
            this.state = 1630;
            this.expression();
            this.state = 1632; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1631;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1634; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,270, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1636;
            localctx.TANNOARG = this.match(LogoEditorParser.T__33);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ArcsinContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_arcsin;
    this.ARCSINOK = null; // Token
    this.ARCSINMANYARGS = null; // Token
    this.ARCSINNOARG = null; // Token
    return this;
}

ArcsinContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArcsinContext.prototype.constructor = ArcsinContext;

ArcsinContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ArcsinContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterArcsin(this);
	}
};

ArcsinContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitArcsin(this);
	}
};

ArcsinContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitArcsin(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ArcsinContext = ArcsinContext;

LogoEditorParser.prototype.arcsin = function() {

    var localctx = new ArcsinContext(this, this._ctx, this.state);
    this.enterRule(localctx, 100, LogoEditorParser.RULE_arcsin);
    var _la = 0; // Token type
    try {
        this.state = 1649;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,273,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1639;
            localctx.ARCSINOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__34 || _la===LogoEditorParser.T__95)) {
                localctx.ARCSINOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1640;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1641;
            localctx.ARCSINMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__34 || _la===LogoEditorParser.T__95)) {
                localctx.ARCSINMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1642;
            this.expression();
            this.state = 1644; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1643;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1646; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,272, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1648;
            localctx.ARCSINNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__34 || _la===LogoEditorParser.T__95)) {
                localctx.ARCSINNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ArccosContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_arccos;
    this.ARCCOSOK = null; // Token
    this.ARCCOSMANYARGS = null; // Token
    this.ARCCOSNOARG = null; // Token
    return this;
}

ArccosContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArccosContext.prototype.constructor = ArccosContext;

ArccosContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ArccosContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterArccos(this);
	}
};

ArccosContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitArccos(this);
	}
};

ArccosContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitArccos(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ArccosContext = ArccosContext;

LogoEditorParser.prototype.arccos = function() {

    var localctx = new ArccosContext(this, this._ctx, this.state);
    this.enterRule(localctx, 102, LogoEditorParser.RULE_arccos);
    var _la = 0; // Token type
    try {
        this.state = 1661;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,275,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1651;
            localctx.ARCCOSOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__35 || _la===LogoEditorParser.T__96)) {
                localctx.ARCCOSOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1652;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1653;
            localctx.ARCCOSMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__35 || _la===LogoEditorParser.T__96)) {
                localctx.ARCCOSMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1654;
            this.expression();
            this.state = 1656; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1655;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1658; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,274, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1660;
            localctx.ARCCOSNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__35 || _la===LogoEditorParser.T__96)) {
                localctx.ARCCOSNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ArctanContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_arctan;
    this.ARCTANOK = null; // Token
    this.ARCTANMANYARGS = null; // Token
    this.ARCTANNOARG = null; // Token
    return this;
}

ArctanContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArctanContext.prototype.constructor = ArctanContext;

ArctanContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ArctanContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterArctan(this);
	}
};

ArctanContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitArctan(this);
	}
};

ArctanContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitArctan(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ArctanContext = ArctanContext;

LogoEditorParser.prototype.arctan = function() {

    var localctx = new ArctanContext(this, this._ctx, this.state);
    this.enterRule(localctx, 104, LogoEditorParser.RULE_arctan);
    var _la = 0; // Token type
    try {
        this.state = 1673;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,277,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1663;
            localctx.ARCTANOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__36 || _la===LogoEditorParser.T__97)) {
                localctx.ARCTANOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1664;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1665;
            localctx.ARCTANMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__36 || _la===LogoEditorParser.T__97)) {
                localctx.ARCTANMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1666;
            this.expression();
            this.state = 1668; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1667;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1670; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,276, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1672;
            localctx.ARCTANNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__36 || _la===LogoEditorParser.T__97)) {
                localctx.ARCTANNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function AbsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_abs;
    this.ABSOK = null; // Token
    this.ABSMANYARGS = null; // Token
    this.ABSNOARG = null; // Token
    return this;
}

AbsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AbsContext.prototype.constructor = AbsContext;

AbsContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

AbsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterAbs(this);
	}
};

AbsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitAbs(this);
	}
};

AbsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitAbs(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.AbsContext = AbsContext;

LogoEditorParser.prototype.abs = function() {

    var localctx = new AbsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 106, LogoEditorParser.RULE_abs);
    try {
        this.state = 1685;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,279,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1675;
            localctx.ABSOK = this.match(LogoEditorParser.T__37);
            this.state = 1676;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1677;
            localctx.ABSMANYARGS = this.match(LogoEditorParser.T__37);
            this.state = 1678;
            this.expression();
            this.state = 1680; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1679;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1682; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,278, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1684;
            localctx.ABSNOARG = this.match(LogoEditorParser.T__37);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SqrtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_sqrt;
    this.SQRTOK = null; // Token
    this.SQRTMANYARGS = null; // Token
    this.SQRTNOARG = null; // Token
    return this;
}

SqrtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SqrtContext.prototype.constructor = SqrtContext;

SqrtContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SqrtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSqrt(this);
	}
};

SqrtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSqrt(this);
	}
};

SqrtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSqrt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SqrtContext = SqrtContext;

LogoEditorParser.prototype.sqrt = function() {

    var localctx = new SqrtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 108, LogoEditorParser.RULE_sqrt);
    try {
        this.state = 1697;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,281,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1687;
            localctx.SQRTOK = this.match(LogoEditorParser.T__38);
            this.state = 1688;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1689;
            localctx.SQRTMANYARGS = this.match(LogoEditorParser.T__38);
            this.state = 1690;
            this.expression();
            this.state = 1692; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1691;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1694; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,280, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1696;
            localctx.SQRTNOARG = this.match(LogoEditorParser.T__38);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ModContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_mod;
    this.MODOK = null; // Token
    this.MODMANYARGS = null; // Token
    this.MODONEARG = null; // Token
    this.MODNOARG = null; // Token
    return this;
}

ModContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ModContext.prototype.constructor = ModContext;

ModContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ModContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterMod(this);
	}
};

ModContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitMod(this);
	}
};

ModContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitMod(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.ModContext = ModContext;

LogoEditorParser.prototype.mod = function() {

    var localctx = new ModContext(this, this._ctx, this.state);
    this.enterRule(localctx, 110, LogoEditorParser.RULE_mod);
    try {
        this.state = 1714;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,283,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1699;
            localctx.MODOK = this.match(LogoEditorParser.T__39);
            this.state = 1700;
            this.expression();
            this.state = 1701;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1703;
            localctx.MODMANYARGS = this.match(LogoEditorParser.T__39);
            this.state = 1704;
            this.expression();
            this.state = 1705;
            this.expression();
            this.state = 1707; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1706;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1709; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,282, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1711;
            localctx.MODONEARG = this.match(LogoEditorParser.T__39);
            this.state = 1712;
            this.expression();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1713;
            localctx.MODNOARG = this.match(LogoEditorParser.T__39);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PowerContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_power;
    this.POWEROK = null; // Token
    this.POWERMANYARGS = null; // Token
    this.POWERONEARG = null; // Token
    this.POWERNOARG = null; // Token
    return this;
}

PowerContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PowerContext.prototype.constructor = PowerContext;

PowerContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

PowerContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPower(this);
	}
};

PowerContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPower(this);
	}
};

PowerContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPower(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PowerContext = PowerContext;

LogoEditorParser.prototype.power = function() {

    var localctx = new PowerContext(this, this._ctx, this.state);
    this.enterRule(localctx, 112, LogoEditorParser.RULE_power);
    try {
        this.state = 1731;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,285,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1716;
            localctx.POWEROK = this.match(LogoEditorParser.T__40);
            this.state = 1717;
            this.expression();
            this.state = 1718;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1720;
            localctx.POWERMANYARGS = this.match(LogoEditorParser.T__40);
            this.state = 1721;
            this.expression();
            this.state = 1722;
            this.expression();
            this.state = 1724; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1723;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1726; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,284, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1728;
            localctx.POWERONEARG = this.match(LogoEditorParser.T__40);
            this.state = 1729;
            this.expression();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1730;
            localctx.POWERNOARG = this.match(LogoEditorParser.T__40);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Log10Context(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_log10;
    this.LOGOK = null; // Token
    this.LOGMANYARGS = null; // Token
    this.LOGNOARG = null; // Token
    return this;
}

Log10Context.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Log10Context.prototype.constructor = Log10Context;

Log10Context.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

Log10Context.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterLog10(this);
	}
};

Log10Context.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitLog10(this);
	}
};

Log10Context.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitLog10(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.Log10Context = Log10Context;

LogoEditorParser.prototype.log10 = function() {

    var localctx = new Log10Context(this, this._ctx, this.state);
    this.enterRule(localctx, 114, LogoEditorParser.RULE_log10);
    var _la = 0; // Token type
    try {
        this.state = 1743;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,287,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1733;
            localctx.LOGOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__41 || _la===LogoEditorParser.T__98)) {
                localctx.LOGOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1734;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1735;
            localctx.LOGMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__41 || _la===LogoEditorParser.T__98)) {
                localctx.LOGMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1736;
            this.expression();
            this.state = 1738; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1737;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1740; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,286, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1742;
            localctx.LOGNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__41 || _la===LogoEditorParser.T__98)) {
                localctx.LOGNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WaiteContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_waite;
    this.WAITOK = null; // Token
    this.WAITMANYARGS = null; // Token
    this.WAITNOARG = null; // Token
    return this;
}

WaiteContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WaiteContext.prototype.constructor = WaiteContext;

WaiteContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

WaiteContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterWaite(this);
	}
};

WaiteContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitWaite(this);
	}
};

WaiteContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitWaite(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.WaiteContext = WaiteContext;

LogoEditorParser.prototype.waite = function() {

    var localctx = new WaiteContext(this, this._ctx, this.state);
    this.enterRule(localctx, 116, LogoEditorParser.RULE_waite);
    try {
        this.state = 1755;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,289,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1745;
            localctx.WAITOK = this.match(LogoEditorParser.T__23);
            this.state = 1746;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1747;
            localctx.WAITMANYARGS = this.match(LogoEditorParser.T__23);
            this.state = 1748;
            this.expression();
            this.state = 1750; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1749;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1752; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,288, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1754;
            localctx.WAITNOARG = this.match(LogoEditorParser.T__23);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WashContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_wash;
    this.WASHOK = null; // Token
    this.WASHMANYARGS = null; // Token
    return this;
}

WashContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WashContext.prototype.constructor = WashContext;

WashContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

WashContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterWash(this);
	}
};

WashContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitWash(this);
	}
};

WashContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitWash(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.WashContext = WashContext;

LogoEditorParser.prototype.wash = function() {

    var localctx = new WashContext(this, this._ctx, this.state);
    this.enterRule(localctx, 118, LogoEditorParser.RULE_wash);
    try {
        this.state = 1764;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,291,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1757;
            localctx.WASHOK = this.match(LogoEditorParser.T__25);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1758;
            localctx.WASHMANYARGS = this.match(LogoEditorParser.T__25);
            this.state = 1760; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1759;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1762; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,290, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetpwContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_setpw;
    this.SETPWOK = null; // Token
    this.SETPWMANYARGS = null; // Token
    this.SETPWNOARG = null; // Token
    return this;
}

SetpwContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetpwContext.prototype.constructor = SetpwContext;

SetpwContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SetpwContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSetpw(this);
	}
};

SetpwContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSetpw(this);
	}
};

SetpwContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSetpw(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetpwContext = SetpwContext;

LogoEditorParser.prototype.setpw = function() {

    var localctx = new SetpwContext(this, this._ctx, this.state);
    this.enterRule(localctx, 120, LogoEditorParser.RULE_setpw);
    var _la = 0; // Token type
    try {
        this.state = 1776;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,293,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1766;
            localctx.SETPWOK = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__26 || _la===LogoEditorParser.T__99)) {
                localctx.SETPWOK = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1767;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1768;
            localctx.SETPWMANYARGS = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__26 || _la===LogoEditorParser.T__99)) {
                localctx.SETPWMANYARGS = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 1769;
            this.expression();
            this.state = 1771; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1770;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1773; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,292, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1775;
            localctx.SETPWNOARG = this._input.LT(1);
            _la = this._input.LA(1);
            if(!(_la===LogoEditorParser.T__26 || _la===LogoEditorParser.T__99)) {
                localctx.SETPWNOARG = this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CircleContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_circle;
    this.CIRCLEOK = null; // Token
    this.CIRCLEMANYARGS = null; // Token
    this.CIRCLENOARG = null; // Token
    return this;
}

CircleContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CircleContext.prototype.constructor = CircleContext;

CircleContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

CircleContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterCircle(this);
	}
};

CircleContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitCircle(this);
	}
};

CircleContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitCircle(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.CircleContext = CircleContext;

LogoEditorParser.prototype.circle = function() {

    var localctx = new CircleContext(this, this._ctx, this.state);
    this.enterRule(localctx, 122, LogoEditorParser.RULE_circle);
    try {
        this.state = 1788;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,295,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1778;
            localctx.CIRCLEOK = this.match(LogoEditorParser.T__27);
            this.state = 1779;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1780;
            localctx.CIRCLEMANYARGS = this.match(LogoEditorParser.T__27);
            this.state = 1781;
            this.expression();
            this.state = 1783; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1782;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1785; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,294, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1787;
            localctx.CIRCLENOARG = this.match(LogoEditorParser.T__27);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetheadingContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_setheading;
    this.SETHEADINGOK = null; // Token
    this.SETHEADINGMANYARGS = null; // Token
    this.SETHEADINGNOARG = null; // Token
    return this;
}

SetheadingContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetheadingContext.prototype.constructor = SetheadingContext;

SetheadingContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SetheadingContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterSetheading(this);
	}
};

SetheadingContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitSetheading(this);
	}
};

SetheadingContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitSetheading(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.SetheadingContext = SetheadingContext;

LogoEditorParser.prototype.setheading = function() {

    var localctx = new SetheadingContext(this, this._ctx, this.state);
    this.enterRule(localctx, 124, LogoEditorParser.RULE_setheading);
    try {
        this.state = 1800;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,297,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1790;
            localctx.SETHEADINGOK = this.match(LogoEditorParser.T__28);
            this.state = 1791;
            this.expression();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1792;
            localctx.SETHEADINGMANYARGS = this.match(LogoEditorParser.T__28);
            this.state = 1793;
            this.expression();
            this.state = 1795; 
            this._errHandler.sync(this);
            var _alt = 1;
            do {
            	switch (_alt) {
            	case 1:
            		this.state = 1794;
            		this.expression();
            		break;
            	default:
            		throw new antlr4.error.NoViableAltException(this);
            	}
            	this.state = 1797; 
            	this._errHandler.sync(this);
            	_alt = this._interp.adaptivePredict(this._input,296, this._ctx);
            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1799;
            localctx.SETHEADINGNOARG = this.match(LogoEditorParser.T__28);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NumberContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_number;
    return this;
}

NumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NumberContext.prototype.constructor = NumberContext;

NumberContext.prototype.NUMBER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LogoEditorParser.NUMBER);
    } else {
        return this.getToken(LogoEditorParser.NUMBER, i);
    }
};


NumberContext.prototype.pie = function() {
    return this.getTypedRuleContext(PieContext,0);
};

NumberContext.prototype.ee = function() {
    return this.getTypedRuleContext(EeContext,0);
};

NumberContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterNumber(this);
	}
};

NumberContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitNumber(this);
	}
};

NumberContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitNumber(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.NumberContext = NumberContext;

LogoEditorParser.prototype.number = function() {

    var localctx = new NumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 126, LogoEditorParser.RULE_number);
    try {
        this.state = 1808;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,298,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 1802;
            this.match(LogoEditorParser.NUMBER);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 1803;
            this.match(LogoEditorParser.NUMBER);
            this.state = 1804;
            this.match(LogoEditorParser.T__100);
            this.state = 1805;
            this.match(LogoEditorParser.NUMBER);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 1806;
            this.pie();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 1807;
            this.ee();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CommentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_comment;
    return this;
}

CommentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CommentContext.prototype.constructor = CommentContext;

CommentContext.prototype.COMMENT = function() {
    return this.getToken(LogoEditorParser.COMMENT, 0);
};

CommentContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterComment(this);
	}
};

CommentContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitComment(this);
	}
};

CommentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitComment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.CommentContext = CommentContext;

LogoEditorParser.prototype.comment = function() {

    var localctx = new CommentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 128, LogoEditorParser.RULE_comment);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1810;
        this.match(LogoEditorParser.COMMENT);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PieContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_pie;
    return this;
}

PieContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PieContext.prototype.constructor = PieContext;


PieContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterPie(this);
	}
};

PieContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitPie(this);
	}
};

PieContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitPie(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.PieContext = PieContext;

LogoEditorParser.prototype.pie = function() {

    var localctx = new PieContext(this, this._ctx, this.state);
    this.enterRule(localctx, 130, LogoEditorParser.RULE_pie);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1812;
        this.match(LogoEditorParser.T__43);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function EeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_ee;
    return this;
}

EeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
EeContext.prototype.constructor = EeContext;


EeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterEe(this);
	}
};

EeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitEe(this);
	}
};

EeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitEe(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.EeContext = EeContext;

LogoEditorParser.prototype.ee = function() {

    var localctx = new EeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 132, LogoEditorParser.RULE_ee);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1814;
        this.match(LogoEditorParser.T__42);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function EolContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_eol;
    return this;
}

EolContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
EolContext.prototype.constructor = EolContext;

EolContext.prototype.EOL = function() {
    return this.getToken(LogoEditorParser.EOL, 0);
};

EolContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterEol(this);
	}
};

EolContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitEol(this);
	}
};

EolContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitEol(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.EolContext = EolContext;

LogoEditorParser.prototype.eol = function() {

    var localctx = new EolContext(this, this._ctx, this.state);
    this.enterRule(localctx, 134, LogoEditorParser.RULE_eol);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1816;
        this.match(LogoEditorParser.EOL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function MaybeToContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_maybeTo;
    return this;
}

MaybeToContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MaybeToContext.prototype.constructor = MaybeToContext;

MaybeToContext.prototype.STRING = function() {
    return this.getToken(LogoEditorParser.STRING, 0);
};

MaybeToContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterMaybeTo(this);
	}
};

MaybeToContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitMaybeTo(this);
	}
};

MaybeToContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitMaybeTo(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.MaybeToContext = MaybeToContext;

LogoEditorParser.prototype.maybeTo = function() {

    var localctx = new MaybeToContext(this, this._ctx, this.state);
    this.enterRule(localctx, 136, LogoEditorParser.RULE_maybeTo);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1818;
        this.match(LogoEditorParser.STRING);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function EndContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoEditorParser.RULE_end;
    return this;
}

EndContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
EndContext.prototype.constructor = EndContext;


EndContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.enterEnd(this);
	}
};

EndContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoEditorListener ) {
        listener.exitEnd(this);
	}
};

EndContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoEditorVisitor ) {
        return visitor.visitEnd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoEditorParser.EndContext = EndContext;

LogoEditorParser.prototype.end = function() {

    var localctx = new EndContext(this, this._ctx, this.state);
    this.enterRule(localctx, 138, LogoEditorParser.RULE_end);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 1820;
        this.match(LogoEditorParser.T__101);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


exports.LogoEditorParser = LogoEditorParser;



//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-editor/LogoEditorParser.js
// module id = ./src/app/interpreter/interpreter-editor/LogoEditorParser.js
// module chunks = main